(function(ot) {
    ot.fn.asHTML5VideoControls = function(t, L, _, i, e, o, s, n, a) {
        var r = "ontouchstart" in window;
        var l = r ? "touchstart" : "mousedown";
        var h = r ? "touchmove" : "mousemove";
        var p = r ? "touchcancel" : "mouseup";
        var d = "click";
        var c = 32;
        var m = r ? 48 : 36;
        var u = null;
        var g = null;
        var N = false;
        var f = false;
        var v = true;
        var b = ot(this).data("ishd");
        var w = ot(this).data("hd");
        var D = ot(this).data("src");
        var x = ot(this);
        x.get(0).removeAttribute("controls");
        var y = ot("<div class='html5boxVideoPlay'></div>");
        x.after(y);
        var j = a && "playbutton" in a && a.playbutton.length > 0 ? a.playbutton : t + "html5boxplayer_playvideo.png";
        y.css({
            position: "absolute",
            top: "50%",
            left: "50%",
            display: "block",
            cursor: "pointer",
            width: 64,
            height: 64,
            "margin-left": -32,
            "margin-top": -32,
            "background-image": "url('" + j + "')",
            "background-position": "center center",
            "background-repeat": "no-repeat"
        }).on(d, function() {
            x.get(0).play()
        });
        var k = ot("<div class='html5boxVideoFullscreenBg'></div>");
        var z = ot("<div class='html5boxVideoControls'>" + "<div class='html5boxVideoControlsBg'></div>" + "<div class='html5boxPlayPause'>" + "<div class='html5boxPlay'></div>" + "<div class='html5boxPause'></div>" + "</div>" + "<div class='html5boxTimeCurrent'>--:--</div>" + "<div class='html5boxFullscreen'></div>" + "<div class='html5boxHD'></div>" + "<div class='html5boxVolume'>" + "<div class='html5boxVolumeButton'></div>" + "<div class='html5boxVolumeBar'>" + "<div class='html5boxVolumeBarBg'>" + "<div class='html5boxVolumeBarActive'></div>" + "</div>" + "</div>" + "</div>" + "<div class='html5boxTimeTotal'>--:--</div>" + "<div class='html5boxSeeker'>" + "<div class='html5boxSeekerBuffer'></div>" + "<div class='html5boxSeekerPlay'></div>" + "<div class='html5boxSeekerHandler'></div>" + "</div>" + "<div style='clear:both;'></div>" + "</div>");
        x.after(z);
        x.after(k);
        k.css({
            display: "none",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            right: 0
        });
        z.css({
            display: "block",
            position: "absolute",
            width: "100%",
            height: m,
            left: 0,
            bottom: 0,
            right: 0,
            margin: "0 auto"
        });
        var A = function() {
            v = true
        };
        x.on("touch click mousemove mouseenter", function() {
            v = true
        });
        if (!i) setInterval(function() {
            if (v) {
                z.show();
                v = false;
                clearTimeout(u);
                u = setTimeout(function() {
                    if (!x.get(0).paused) z.fadeOut()
                }, 5e3)
            }
        }, 250);
        ot(".html5boxVideoControlsBg", z).css({
            display: "block",
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            "background-color": "#000000",
            opacity: .7,
            filter: "alpha(opacity=70)"
        });
        ot(".html5boxPlayPause", z).css({
            display: "block",
            position: "relative",
            width: c + "px",
            height: c + "px",
            margin: Math.floor((m - c) / 2),
            "float": "left"
        });
        var E = ot(".html5boxPlay", z);
        var I = ot(".html5boxPause", z);
        E.css({
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            width: c + "px",
            height: c + "px",
            cursor: "pointer",
            "background-image": "url('" + t + "html5boxplayer_playpause.png" + "')",
            "background-position": "top left"
        }).hover(function() {
            ot(this).css({
                "background-position": "bottom left"
            })
        }, function() {
            ot(this).css({
                "background-position": "top left"
            })
        }).on(d, function() {
            x.get(0).play()
        });
        I.css({
            display: "none",
            position: "absolute",
            top: 0,
            left: 0,
            width: c + "px",
            height: c + "px",
            cursor: "pointer",
            "background-image": "url('" + t + "html5boxplayer_playpause.png" + "')",
            "background-position": "top right"
        }).hover(function() {
            ot(this).css({
                "background-position": "bottom right"
            })
        }, function() {
            ot(this).css({
                "background-position": "top right"
            })
        }).on(d, function() {
            x.get(0).pause()
        });
        var R = ot(".html5boxTimeCurrent", z);
        var V = ot(".html5boxTimeTotal", z);
        var M = ot(".html5boxSeeker", z);
        var T = ot(".html5boxSeekerPlay", z);
        var W = ot(".html5boxSeekerBuffer", z);
        var Y = ot(".html5boxSeekerHandler", z);
        R.css({
            display: "block",
            position: "relative",
            "float": "left",
            "line-height": m + "px",
            "font-weight": "normal",
            "font-size": "12px",
            margin: "0 8px",
            "font-family": "Arial, Helvetica, sans-serif",
            color: "#fff"
        });
        V.css({
            display: "block",
            position: "relative",
            "float": "right",
            "line-height": m + "px",
            "font-weight": "normal",
            "font-size": "12px",
            margin: "0 8px",
            "font-family": "Arial, Helvetica, sans-serif",
            color: "#fff"
        });
        M.css({
            display: "block",
            cursor: "pointer",
            overflow: "hidden",
            position: "relative",
            height: "10px",
            "background-color": "#222",
            margin: Math.floor((m - 10) / 2) + "px 4px"
        }).on(l, function(t) {
            var i = r ? t.originalEvent.touches[0] : t;
            var e = i.pageX - M.offset().left;
            T.css({
                width: e
            });
            x.get(0).currentTime = e * x.get(0).duration / M.width();
            M.on(h, function(t) {
                var i = r ? t.originalEvent.touches[0] : t;
                var e = i.pageX - M.offset().left;
                T.css({
                    width: e
                });
                x.get(0).currentTime = e * x.get(0).duration / M.width()
            })
        }).on(p, function() {
            M.off(h)
        });
        W.css({
            display: "block",
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            "background-color": "#444"
        });
        T.css({
            display: "block",
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            "background-color": "#fcc500"
        });
        var S = s ? x : x.parent();
        if (S.get(0).requestFullscreen || S.get(0).webkitRequestFullScreen || S.get(0).mozRequestFullScreen || S.get(0).webkitEnterFullScreen || S.get(0).msRequestFullscreen) {
            var H = function(t) {
                if (t) {
                    if (s) {
                        x.get(0).setAttribute("controls", "controls");
                        if (n) x.get(0).setAttribute("controlsList", "nodownload")
                    }
                    if (S.get(0).requestFullscreen) S.get(0).requestFullscreen();
                    else if (S.get(0).webkitRequestFullScreen) S.get(0).webkitRequestFullScreen();
                    else if (S.get(0).mozRequestFullScreen) S.get(0).mozRequestFullScreen();
                    else if (S.get(0).webkitEnterFullScreen) S.get(0).webkitEnterFullScreen();
                    if (S.get(0).msRequestFullscreen) S.get(0).msRequestFullscreen()
                } else if (document.cancelFullScreen) document.cancelFullScreen();
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
                else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
                else if (document.msExitFullscreen) document.msExitFullscreen()
            };
            var $ = function(t) {
                if (s)
                    if (t) {
                        x.get(0).setAttribute("controls", "controls");
                        if (n) x.get(0).setAttribute("controlsList", "nodownload")
                    } else x.get(0).removeAttribute("controls");
                else if (t) {
                    ot(document).on("mousemove", A);
                    z.css({
                        "z-index": 2147483647,
                        position: "fixed"
                    });
                    k.css({
                        "z-index": 2147483647,
                        display: "block"
                    });
                    y.css({
                        "z-index": 2147483647
                    })
                } else {
                    ot(document).off("mousemove", A);
                    z.css({
                        "z-index": "",
                        position: "absolute"
                    });
                    k.css({
                        "z-index": "",
                        display: "none"
                    });
                    y.css({
                        "z-index": ""
                    })
                }
            };
            document.addEventListener("MSFullscreenChange", function() {
                f = document.msFullscreenElement != null;
                $(f)
            }, false);
            document.addEventListener("fullscreenchange", function() {
                f = document.fullscreen;
                $(f)
            }, false);
            document.addEventListener("mozfullscreenchange", function() {
                f = document.mozFullScreen;
                $(f)
            }, false);
            document.addEventListener("webkitfullscreenchange", function() {
                f = document.webkitIsFullScreen;
                $(f)
            }, false);
            S.get(0).addEventListener("webkitbeginfullscreen", function() {
                f = true;
                $(f)
            }, false);
            S.get(0).addEventListener("webkitendfullscreen", function() {
                f = false;
                $(f)
            }, false);
            if (!s) ot("head").append("<style type='text/css'>video" + _ + "::-webkit-media-controls { display:none !important; }</style>");
            var q = ot(".html5boxFullscreen", z);
            q.css({
                display: "block",
                position: "relative",
                "float": "right",
                width: c + "px",
                height: c + "px",
                margin: Math.floor((m - c) / 2),
                cursor: "pointer",
                "background-image": "url('" + t + "html5boxplayer_fullscreen.png" + "')",
                "background-position": "left top"
            }).hover(function() {
                var t = ot(this).css("background-position") ? ot(this).css("background-position").split(" ")[0] : ot(this).css("background-position-x");
                ot(this).css({
                    "background-position": t + " bottom"
                })
            }, function() {
                var t = ot(this).css("background-position") ? ot(this).css("background-position").split(" ")[0] : ot(this).css("background-position-x");
                ot(this).css({
                    "background-position": t + " top"
                })
            }).on(d, function() {
                f = !f;
                H(f)
            })
        }
        if (w) {
            var Z = ot(".html5boxHD", z);
            Z.css({
                display: "block",
                position: "relative",
                "float": "right",
                width: c + "px",
                height: c + "px",
                margin: Math.floor((m - c) / 2),
                cursor: "pointer",
                "background-image": "url('" + t + "html5boxplayer_hd.png" + "')",
                "background-position": (b ? "right" : "left") + " center"
            }).on(d, function() {
                b = !b;
                ot(this).css({
                    "background-position": (b ? "right" : "left") + " center"
                });
                L.isHd = b;
                var t = x.get(0).isPaused;
                x.get(0).setAttribute("src", (b ? w : D) + "#t=" + x.get(0).currentTime);
                if (!t) x.get(0).play();
                else x.get(0).pause()
            })
        }
        x.get(0).volume = o;
        var U = o == 0 ? 1 : o;
        var C = x.get(0).volume;
        x.get(0).volume = C / 2 + .1;
        if (x.get(0).volume === C / 2 + .1) {
            x.get(0).volume = C;
            var G = ot(".html5boxVolume", z);
            var B = ot(".html5boxVolumeButton", z);
            var F = ot(".html5boxVolumeBar", z);
            var O = ot(".html5boxVolumeBarBg", z);
            var P = ot(".html5boxVolumeBarActive", z);
            G.css({
                display: "block",
                position: "relative",
                "float": "right",
                width: c + "px",
                height: c + "px",
                margin: Math.floor((m - c) / 2)
            }).hover(function() {
                clearTimeout(g);
                var t = x.get(0).volume;
                P.css({
                    height: Math.round(t * 100) + "%"
                });
                F.show()
            }, function() {
                clearTimeout(g);
                g = setTimeout(function() {
                    F.hide()
                }, 1e3)
            });
            B.css({
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                width: c + "px",
                height: c + "px",
                cursor: "pointer",
                "background-image": "url('" + t + "html5boxplayer_volume.png" + "')",
                "background-position": "top " + (C > 0 ? "left" : "right")
            }).hover(function() {
                var t = ot(this).css("background-position") ? ot(this).css("background-position").split(" ")[0] : ot(this).css("background-position-x");
                ot(this).css({
                    "background-position": t + " bottom"
                })
            }, function() {
                var t = ot(this).css("background-position") ? ot(this).css("background-position").split(" ")[0] : ot(this).css("background-position-x");
                ot(this).css({
                    "background-position": t + " top"
                })
            }).on(d, function() {
                var t = x.get(0).volume;
                if (t > 0) {
                    U = t;
                    t = 0
                } else t = U;
                var i = ot(this).css("background-position") ? ot(this).css("background-position").split(" ")[1] : ot(this).css("background-position-y");
                B.css({
                    "background-position": (t > 0 ? "left" : "right") + " " + i
                });
                if (t > 0) x.get(0).muted = false;
                x.get(0).volume = t;
                document.cookie = "amazingslidervideovolume=" + t + ";path=/;";
                P.css({
                    height: Math.round(t * 100) + "%"
                })
            });
            F.css({
                display: "none",
                position: "absolute",
                left: 4,
                bottom: "100%",
                width: 24,
                height: 80,
                "margin-bottom": Math.floor((m - c) / 2),
                "background-color": "#000000",
                opacity: .7,
                filter: "alpha(opacity=70)"
            });
            O.css({
                display: "block",
                position: "relative",
                width: 10,
                height: 68,
                margin: 7,
                cursor: "pointer",
                "background-color": "#222"
            });
            P.css({
                display: "block",
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "100%",
                "background-color": "#fcc500"
            });
            O.on(l, function(t) {
                var i = r ? t.originalEvent.touches[0] : t;
                var e = 1 - (i.pageY - O.offset().top) / O.height();
                e = e > 1 ? 1 : e < 0 ? 0 : e;
                P.css({
                    height: Math.round(e * 100) + "%"
                });
                B.css({
                    "background-position": "left " + (e > 0 ? "top" : "bottom")
                });
                if (e > 0) x.get(0).muted = false;
                x.get(0).volume = e;
                document.cookie = "amazingslidervideovolume=" + e + ";path=/;";
                O.on(h, function(t) {
                    var i = r ? t.originalEvent.touches[0] : t;
                    var e = 1 - (i.pageY - O.offset().top) / O.height();
                    e = e > 1 ? 1 : e < 0 ? 0 : e;
                    P.css({
                        height: Math.round(e * 100) + "%"
                    });
                    B.css({
                        "background-position": "left " + (e > 0 ? "top" : "bottom")
                    });
                    if (e > 0) x.get(0).muted = false;
                    x.get(0).volume = e;
                    document.cookie = "amazingslidervideovolume=" + e + ";path=/;"
                })
            }).on(p, function() {
                O.off(h)
            })
        }
        var Q = function(t) {
            var i = Math.floor(t / 3600);
            var e = i < 10 ? "0" + i : i;
            var o = Math.floor((t - i * 3600) / 60);
            var s = o < 10 ? "0" + o : o;
            var n = Math.floor(t - (i * 3600 + o * 60));
            var a = n < 10 ? "0" + n : n;
            var r = s + ":" + a;
            if (i > 0) r = e + ":" + r;
            return r
        };
        if (e) y.hide();
        if (i) z.hide();
        var X = function() {
            if (!e) y.hide();
            if (!i) {
                E.hide();
                I.show()
            }
        };
        var K = function() {
            if (!e) y.show();
            if (!i) {
                z.show();
                clearTimeout(u);
                E.show();
                I.hide()
            }
        };
        var J = function() {
            ot(window).trigger("html5lightbox.videoended");
            if (!e) y.show();
            if (!i) {
                z.show();
                clearTimeout(u);
                E.show();
                I.hide()
            }
        };
        var tt = function() {
            var t = x.get(0).currentTime;
            if (t) {
                R.text(Q(t));
                var i = x.get(0).duration;
                if (i) {
                    V.text(Q(i));
                    if (!N) {
                        var e = M.width();
                        var o = Math.round(e * t / i);
                        T.css({
                            width: o
                        });
                        Y.css({
                            left: o
                        })
                    }
                }
            }
        };
        var it = function() {
            if (x.get(0).buffered && x.get(0).buffered.length > 0 && !isNaN(x.get(0).buffered.end(0)) && !isNaN(x.get(0).duration)) {
                var t = M.width();
                W.css({
                    width: Math.round(t * x.get(0).buffered.end(0) / x.get(0).duration)
                })
            }
        };
        try {
            x.on("play", X);
            x.on("pause", K);
            x.on("ended", J);
            x.on("timeupdate", tt);
            x.on("progress", it)
        } catch (et) {}
    }
})(jQuery);
(function(M) {
    M.fn.ashtml5lightbox = function(t) {
        var v = this;
        v.options = M.extend({
            freelink: "http://html5box.com/",
            defaultvideovolume: 1,
            mutevideo: false,
            autoclose: false,
            autoclosedelay: 0,
            resizedelay: 100,
            insideiframe: false,
            autoresizecontent: true,
            defaultwidth: 960,
            defaultheight: 540,
            usedefaultsizeforcontent: false,
            preload: true,
            preloadallonpageload: false,
            preloadalldelay: 5e3,
            autoplay: true,
            autoplayvideo: true,
            loopvideo: true,
            html5player: true,
            responsive: true,
            nativehtml5controls: false,
            videohidecontrols: false,
            nativecontrolsonfirefox: false,
            nativecontrolsonie: false,
            nativecontrolsoniphone: true,
            nativecontrolsonipad: true,
            nativecontrolsonandroid: true,
            nativecontrolsonfullscreen: true,
            nativecontrolsnodownload: true,
            noresizecallback: true,
            imagekeepratio: true,
            maxheight: false,
            elemautoheight: false,
            useflashonie9: true,
            useflashonie10: true,
            useflashonie11: false,
            useflashformp4onfirefox: false,
            transition: "none",
            transitionduration: 400,
            exitanimation: "",
            animationduration: "1s",
            enablepdfjs: false,
            pdfjsengine: "",
            openpdfinnewtaboniphone: false,
            openpdfinnewtabonipad: false,
            googleanalyticsaccount: "",
            arrowloop: true,
            showall: false,
            userelforgroup: true,
            shownavigation: true,
            thumbwidth: 96,
            thumbheight: 72,
            thumbgap: 4,
            thumbtopmargin: 12,
            thumbbottommargin: 12,
            thumbborder: 1,
            thumbbordercolor: "transparent",
            thumbhighlightbordercolor: "#fff",
            thumbopacity: 1,
            navbuttonwidth: 32,
            navbgcolor: "rgba(0,0,0,0.2)",
            shownavcontrol: true,
            navcontrolimage: "lightbox-navcontrol.png",
            hidenavdefault: false,
            overlaybgcolor: "#000",
            overlayopacity: .9,
            bgcolor: "#fff",
            bordersize: 8,
            borderradius: 0,
            bordermargin: 16,
            bordertopmargin: 48,
            barautoheight: true,
            barheight: 64,
            smallscreenheight: 415,
            responsivebarheight: false,
            barheightonsmallheight: 64,
            notkeepratioonsmallheight: false,
            bordertopmarginsmall: 36,
            loadingwidth: 64,
            loadingheight: 64,
            resizespeed: 400,
            fadespeed: 0,
            jsfolder: "",
            skinsfoldername: "",
            loadingimage: "lightbox-loading.gif",
            nextimage: "lightbox-next.png",
            previmage: "lightbox-prev.png",
            closeimage: "lightbox-close.png",
            playvideoimage: "lightbox-playvideo.png",
            titlebgimage: "lightbox-titlebg.png",
            navarrowsprevimage: "lightbox-navprev.png",
            navarrowsnextimage: "lightbox-navnext.png",
            navarrowsalwaysshowontouch: true,
            showarrowsbottomonsmallscreen: true,
            navarrowsbottomscreenwidth: 479,
            closeonoverlay: true,
            alwaysshownavarrows: false,
            showplaybutton: true,
            playimage: "lightbox-play.png",
            pauseimage: "lightbox-pause.png",
            playimagesize: 32,
            fullscreenmode: false,
            fullscreencloseimage: "lightbox-close-fullscreen.png",
            fullscreennextimage: "lightbox-next-fullscreen.png",
            fullscreenprevimage: "lightbox-prev-fullscreen.png",
            fullscreennomargin: false,
            fullscreenmodeonsmallscreen: false,
            fullscreennomarginonsmallscreen: false,
            fullscreensmallscreenwidth: 800,
            fullscreenbgcolor: "transparent",
            fullscreenbordersize: 0,
            fullscreentextinside: false,
            fullscreentextoutside: true,
            fullscreennotransition: true,
            videobgcolor: "#000",
            html5videoposter: "",
            showtitle: true,
            titlestyle: "bottom",
            titleinsidecss: "color:#fff; font-size:16px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 8px;",
            titlebottomcss: "color:#333; font-size:16px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left;",
            titleoutsidecss: "color:#fff; font-size:18px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:center; margin: 8px;",
            resizeleftright: true,
            showonmouseoverinside: false,
            showinsidetitleforimageonly: true,
            showdescription: true,
            descriptioninsidecss: "color:#fff; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;",
            descriptionbottomcss: "color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;",
            descriptionoutsidecss: "color:#fff; font-size:14px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:center; margin:8px; padding: 0px;",
            fullscreentitlebottomcss: "color:#fff; font-size:16px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 8px 8px;",
            fullscreendescriptionbottomcss: "color:#fff; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;",
            showsocialmedia: true,
            socialmediaposition: "position:absolute;top:8px;right:8px;",
            showtitleprefix: true,
            titleprefix: "%NUM / %TOTAL",
            autoslide: false,
            slideinterval: 5e3,
            showtimer: true,
            timerposition: "bottom",
            timerheight: 2,
            timercolor: "#dc572e",
            timeropacity: 1,
            initvimeo: true,
            inityoutube: true,
            swipepreventdefaultonandroid: false,
            initsocial: false,
            showsocial: false,
            socialposition: "position:absolute;top:100%;right:0;",
            socialpositionsmallscreen: "position:absolute;top:100%;right:0;left:0;",
            socialdirection: "horizontal",
            socialbuttonsize: 32,
            socialbuttonfontsize: 18,
            socialrotateeffect: true,
            showfacebook: true,
            showtwitter: true,
            showpinterest: true,
            showemail: true,
            imagepercentage: 75,
            sidetobottomscreenwidth: 479,
            errorwidth: 280,
            errorheight: 48,
            errorcss: "text-align:center; color:#ff0000; font-size:14px; font-family:Arial, sans-serif;",
            enabletouchswipe: true,
            mobileresizeevent: false,
            swipedistance: 0,
            bodynoscroll: false,
            useabsolutepos: false,
            useabsoluteposonmobile: false,
            supportesckey: true,
            supportarrowkeys: true,
            version: "3.3"
        }, t);
        if (typeof html5lightbox_options != "undefined" && html5lightbox_options) M.extend(v.options, html5lightbox_options);
        if (M("div.html5lightbox_options").length) M.each(M("div.html5lightbox_options").data(), function(t, i) {
            v.options[t.toLowerCase()] = i
        });
        if (M("div#html5lightbox_options").length) M.each(M("div#html5lightbox_options").data(), function(t, i) {
            v.options[t.toLowerCase()] = i
        });
        if (M("div#html5lightbox_general_options").length) M.each(M("div#html5lightbox_general_options").data(), function(t, i) {
            v.options[t.toLowerCase()] = i
        });
        var m = 0,
            d = 1,
            u = 2,
            p = 3,
            g = 4,
            f = 5,
            a = 6,
            r = 7,
            c = 8,
            b = 9,
            i = 10,
            h = 11,
            w = 12,
            o = 13,
            l = 14,
            x = 15,
            y = 16;
        v.options.types = ["IMAGE", "FLASH", "VIDEO", "YOUTUBE", "VIMEO", "PDF", "MP3", "WEB", "FLV", "DAILYMOTION", "DIV", "WISTIA", "IFRAMEVIDEO"];
        v.options.htmlfolder = window.location.href.substr(0, window.location.href.lastIndexOf("/") + 1);
        v.options.skinsfolder = v.options.skinsfoldername;
        if (v.options.skinsfolder.length > 0 && v.options.skinsfolder[v.options.skinsfolder.length - 1] != "/") v.options.skinsfolder += "/";
        if (v.options.skinsfolder.charAt(0) != "/" && v.options.skinsfolder.substring(0, 5) != "http:" && v.options.skinsfolder.substring(0, 6) != "https:") v.options.skinsfolder = v.options.jsfolder + v.options.skinsfolder;
        var e = ["loadingimage", "nextimage", "previmage", "closeimage", "playvideoimage", "titlebgimage", "navarrowsprevimage", "navarrowsnextimage", "navcontrolimage", "playimage", "pauseimage", "fullscreencloseimage", "fullscreennextimage", "fullscreenprevimage"];
        for (var s = 0; s < e.length; s++)
            if (v.options[e[s]])
                if (v.options[e[s]].substring(0, 7).toLowerCase() != "http://" && v.options[e[s]].substring(0, 8).toLowerCase() != "https://") v.options[e[s]] = v.options.skinsfolder + v.options[e[s]];
        var s;
        var n;
        v.options.flashInstalled = false;
        try {
            if (new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) v.options.flashInstalled = true
        } catch (I) {
            if (navigator.mimeTypes["application/x-shockwave-flash"]) v.options.flashInstalled = true
        }
        v.options.html5VideoSupported = !!document.createElement("video").canPlayType;
        v.options.isChrome = navigator.userAgent.match(/Chrome/i) != null;
        v.options.isFirefox = navigator.userAgent.match(/Firefox/i) != null;
        v.options.isOpera = navigator.userAgent.match(/Opera/i) != null || navigator.userAgent.match(/OPR\//i) != null;
        v.options.isSafari = navigator.userAgent.match(/Safari/i) != null;
        v.options.isIE11 = navigator.userAgent.match(/Trident\/7/) != null && navigator.userAgent.match(/rv:11/) != null;
        v.options.isIE = navigator.userAgent.match(/MSIE/i) != null && !v.options.isOpera;
        v.options.isIE10 = navigator.userAgent.match(/MSIE 10/i) != null && !this.options.isOpera;
        v.options.isIE9 = navigator.userAgent.match(/MSIE 9/i) != null && !v.options.isOpera;
        v.options.isIE8 = navigator.userAgent.match(/MSIE 8/i) != null && !v.options.isOpera;
        v.options.isIE7 = navigator.userAgent.match(/MSIE 7/i) != null && !v.options.isOpera;
        v.options.isIE6 = navigator.userAgent.match(/MSIE 6/i) != null && !v.options.isOpera;
        v.options.isIE678 = v.options.isIE6 || v.options.isIE7 || v.options.isIE8;
        v.options.isIE6789 = v.options.isIE6 || v.options.isIE7 || v.options.isIE8 || v.options.isIE9;
        v.options.isAndroid = navigator.userAgent.match(/Android/i) != null;
        v.options.isIPad = navigator.userAgent.match(/iPad/i) != null;
        v.options.isIPhone = navigator.userAgent.match(/iPod/i) != null || navigator.userAgent.match(/iPhone/i) != null;
        v.options.isIOS = v.options.isIPad || v.options.isIPhone;
        v.options.isMobile = v.options.isAndroid || v.options.isIPad || v.options.isIPhone;
        v.options.isIOSLess5 = v.options.isIPad && v.options.isIPhone && (navigator.userAgent.match(/OS 4/i) != null || navigator.userAgent.match(/OS 3/i) != null);
        v.options.supportCSSPositionFixed = !v.options.isIE6 && !v.options.isIOSLess5;
        v.options.iequirksmode = v.options.isIE6789 && document.compatMode != "CSS1Compat";
        v.options.isTouch = "ontouchstart" in window;
        if (v.options.isChrome) {
            var k = navigator.userAgent.match(/Chrome\/([0-9]+)/);
            v.options.chromeVersion = k && k.length >= 2 ? parseInt(k[1], 10) : 0
        }
        if (v.options.isAndroid) {
            var k = navigator.userAgent.match(/Android\s([0-9\.]*)/i);
            v.options.androidVersion = k && k.length >= 2 ? parseInt(k[1], 10) : -1
        }
        var z = document.createElement("video");
        v.options.canplaymp4 = z && z.canPlayType && z.canPlayType("video/mp4").replace(/no/, "");
        if (v.options.isFirefox && v.options.nativecontrolsonfirefox || (v.options.isIE6789 || v.options.isIE10 || v.options.isIE11) && v.options.nativecontrolsonie || v.options.isIPhone && v.options.nativecontrolsoniphone || v.options.isIPad && v.options.nativecontrolsonipad || v.options.isAndroid && v.options.nativecontrolsonandroid) v.options.nativehtml5controls = true;
        if (v.options.isIOS || v.options.isAndroid) v.options.nativecontrolsonfullscreen = true;
        v.options.navheight = 0;
        v.options.thumbgap += 2 * v.options.thumbborder;
        v.options.resizeTimeout = -1;
        v.slideTimeout = null;
        v.autosliding = false;
        v.existingElem = -1;
        v.direction = -3;
        v.elemArray = new Array;
        v.options.curElem = -1;
        v.defaultoptions = M.extend({}, v.options);
        if (v.options.googleanalyticsaccount && !window._gaq) {
            window._gaq = window._gaq || [];
            window._gaq.push(["_setAccount", v.options.googleanalyticsaccount]);
            window._gaq.push(["_trackPageview"]);
            M.getScript("https://ssl.google-analytics.com/ga.js")
        }
        if (v.options.initvimeo) {
            var A = document.createElement("script");
            A.src = v.options.jsfolder + "froogaloop2.min.js";
            var E = document.getElementsByTagName("script")[0];
            E.parentNode.insertBefore(A, E)
        }
        if (v.options.inityoutube) {
            var A = document.createElement("script");
            A.src = "https://www.youtube.com/iframe_api";
            var E = document.getElementsByTagName("script")[0];
            E.parentNode.insertBefore(A, E)
        }
        if (v.options.initsocial) M("head").append('<link rel="stylesheet" href="' + v.options.jsfolder + 'icons/css/fontello.css" type="text/css" />');
        v.showing = false;
        v.navvisible = false;
        v.disableEscKey = function(t) {
            if (t) v.disableesckeyinfullscreen = true;
            else setTimeout(function() {
                v.disableesckeyinfullscreen = false
            }, 1e3)
        };
        v.supportKeyboard = function() {
            v.disableesckeyinfullscreen = false;
            M(document).keyup(function(t) {
                if (!v.showing) return;
                if (!v.disableesckeyinfullscreen && v.options.supportesckey && t.keyCode == 27) v.finish();
                else if (v.options.supportarrowkeys)
                    if (t.keyCode == 39) v.gotoSlide(-1);
                    else if (t.keyCode == 37) v.gotoSlide(-2)
            });
            if (v.options.supportesckey && document.addEventListener) {
                document.addEventListener("MSFullscreenChange", function() {
                    v.disableEscKey(document.msFullscreenElement != null)
                }, false);
                document.addEventListener("webkitfullscreenchange", function() {
                    v.disableEscKey(document.webkitIsFullScreen)
                }, false)
            }
        };
        v.supportKeyboard();
        v.init = function() {
            v.showing = false;
            v.readData();
            v.createMarkup();
            v.initSlide()
        };
        v.checkParentData = function(t, i, e) {
            return t.data(e) ? t.data(e) : i && i.data(e) ? i.data(e) : null
        };
        v.checkParentClass = function(t, i, o) {
            var s = null;
            M.each([t, i], function(t, i) {
                if (i && i.attr("class")) {
                    var e = i.attr("class").split(/\s+/);
                    M.each(e, function(t, i) {
                        if (i && i.toLowerCase().indexOf("html5lightbox-" + o + "-") == 0) {
                            var e = i.split("-");
                            if (e.length == 3) s = parseInt(e[2])
                        }
                    })
                }
            });
            return s
        };
        v.readNodeData = function(t, i) {
            var e = "mediatype" in t.data() ? t.data("mediatype") : v.checkType(t.attr("href"));
            if (e < 0) return;
            var o = t.data("title") ? t.data("title") : t.attr("title");
            var s = t.data("group") ? t.data("group") : v.options.userelforgroup ? t.attr("rel") : null;
            if (!s && i) s = i.data("group") ? i.data("group") : v.options.userelforgroup ? i.attr("rel") : null;
            for (var n = 0; n < v.elemArray.length; n++)
                if (t.attr("href") == v.elemArray[n][d]) {
                    v.elemArray[n][u] = o;
                    v.elemArray[n][p] = s;
                    return
                } var a = v.checkParentData(t, i, "width");
            var r = v.checkParentData(t, i, "height");
            if (!a) a = v.checkParentClass(t, i, "width");
            if (!r) r = v.checkParentClass(t, i, "height");
            v.elemArray.push(new Array(e, t.attr("href"), o, s, a, r, v.checkParentData(t, i, "webm"), v.checkParentData(t, i, "ogg"), v.checkParentData(t, i, "thumbnail"), v.checkParentData(t, i, "description"), null, null, null, v.checkParentData(t, i, "socialmedia"), v.checkParentData(t, i, "weblink"), v.checkParentData(t, i, "weblinktarget"), v.checkParentData(t, i, "weblinktext")))
        };
        v.readData = function() {
            v.each(function() {
                var t = M(this);
                if (this.nodeName.toLowerCase() == "a" || this.nodeName.toLowerCase() == "area") v.readNodeData(t);
                else t.find("a,area").each(function() {
                    v.readNodeData(M(this), t)
                })
            })
        };
        v.createMarkup = function() {
            if (M(window).width() <= v.options.fullscreensmallscreenwidth) {
                if (v.options.fullscreenmodeonsmallscreen) {
                    v.options.fullscreenmode = true;
                    if (v.options.fullscreennomarginonsmallscreen) v.options.fullscreennomargin = true
                }
                if (v.options.fullscreenmode && v.options.fullscreennomarginonsmallscreen) v.options.fullscreennomargin = true
            }
            if (v.options.fullscreenmode) {
                v.options.bgcolor = v.options.fullscreenbgcolor;
                v.options.bordersize = v.options.fullscreenbordersize;
                if (v.options.fullscreennomargin) {
                    v.options.bordersize = 0;
                    v.options.bordermargin = 0;
                    v.options.bordertopmargin = 0;
                    v.options.bordertopmarginsmall = 0
                }
                if (v.options.fullscreentextoutside) {
                    v.options.titlestyle = "outside";
                    v.options.titlecss = v.options.titleoutsidecss;
                    v.options.descriptioncss = v.options.descriptionoutsidecss
                } else if (v.options.fullscreentextinside) {
                    v.options.titlestyle = "inside";
                    v.options.titlecss = v.options.titleinsidecss;
                    v.options.descriptioncss = v.options.descriptioninsidecss
                } else {
                    v.options.titlebottomcss = v.options.fullscreentitlebottomcss;
                    v.options.descriptionbottomcss = v.options.fullscreendescriptionbottomcss
                }
            }
            v.options.barheightoriginal = v.options.barheight;
            if (v.options.responsivebarheight) {
                var t = M(window).height();
                if (t <= v.options.smallscreenheight) v.options.barheight = v.options.barheightonsmallheight
            }
            switch (v.options.titlestyle) {
                case "inside":
                    v.options.titlecss = v.options.titleinsidecss;
                    v.options.descriptioncss = v.options.descriptioninsidecss;
                    break;
                case "outside":
                    v.options.titlecss = v.options.titleoutsidecss;
                    v.options.descriptioncss = v.options.descriptionoutsidecss;
                    break;
                default:
                    v.options.titlecss = v.options.titlebottomcss;
                    v.options.descriptioncss = v.options.descriptionbottomcss
            }
            v.options.titlecss = M.trim(v.options.titlecss);
            if (v.options.titlecss.length > 1) {
                if (v.options.titlecss.charAt(0) == "{") v.options.titlecss = v.options.titlecss.substring(1);
                if (v.options.titlecss.charAt(v.options.titlecss.length - 1) == "}") v.options.titlecss = v.options.titlecss.substring(0, v.options.titlecss.length - 1)
            }
            v.options.descriptioncss = M.trim(v.options.descriptioncss);
            if (v.options.descriptioncss.length > 1) {
                if (v.options.descriptioncss.charAt(0) == "{") v.options.descriptioncss = v.options.descriptioncss.substring(1);
                if (v.options.descriptioncss.charAt(v.options.descriptioncss.length - 1) == "}") v.options.descriptioncss = v.options.descriptioncss.substring(0, v.options.descriptioncss.length - 1)
            }
            v.options.errorcss = M.trim(v.options.errorcss);
            if (v.options.errorcss.length > 1) {
                if (v.options.errorcss.charAt(0) == "{") v.options.errorcss = v.options.errorcss.substring(1);
                if (v.options.errorcss.charAt(v.options.errorcss.length - 1) == "}") v.options.errorcss = v.options.errorcss.substring(0, v.options.errorcss.length - 1)
            }
            var i = ".bodynoscroll {height:100%;overflow:hidden;}";
            i += ".html5-hide {display:none !important;} #slider-html5-lightbox .html5-text {" + v.options.titlecss + "}";
            i += "#slider-html5-lightbox .html5-description {" + v.options.descriptioncss + "}";
            i += "#slider-html5-lightbox .html5-error {" + v.options.errorcss + "}";
            if (v.options.navarrowsalwaysshowontouch || v.options.alwaysshownavarrows) {
                i += "#slider-html5-lightbox .html5-prev-touch {left:0px;top:50%;margin-top:-16px;margin-left:-32px;} #slider-html5-lightbox .html5-next-touch {right:0px;top:50%;margin-top:-16px;margin-right:-32px;}";
                if (v.options.showarrowsbottomonsmallscreen) i += "@media (max-width: " + v.options.navarrowsbottomscreenwidth + "px) { #slider-html5-lightbox .html5-prev-touch {top:100%;left:0;margin:0;} #slider-html5-lightbox .html5-next-touch {top:100%;right:0;margin:0;} }"
            }
            i += "#slider-html5-lightbox .html5-prev-fullscreen {display:block;} #slider-html5-lightbox .html5-next-fullscreen {display:block;} #slider-html5-lightbox .html5-prev-bottom-fullscreen {display:none;} #slider-html5-lightbox .html5-next-bottom-fullscreen {display:none;}";
            if (v.options.showarrowsbottomonsmallscreen) i += "@media (max-width: " + v.options.navarrowsbottomscreenwidth + "px) {#slider-html5-lightbox .html5-prev-fullscreen {display:none;} #slider-html5-lightbox .html5-next-fullscreen {display:none;} #slider-html5-lightbox .html5-prev-bottom-fullscreen {display:block;} #slider-html5-lightbox .html5-next-bottom-fullscreen {display:block;} }";
            if (v.options.titlestyle == "right") {
                i += "#slider-html5-lightbox .html5-elem-wrap {width:" + v.options.imagepercentage + "%;height:100%;} #slider-html5-lightbox .html5-elem-data-box {min-height:100%;}";
                i += "@media (max-width: " + v.options.sidetobottomscreenwidth + "px) {#slider-html5-lightbox .html5-elem-wrap {width:100%;height:auto;} #slider-html5-lightbox .html5-elem-data-box {width:100%;height:auto;min-height:0;}}"
            } else if (v.options.titlestyle == "left") {
                i += "#slider-html5-lightbox .html5-elem-wrap {height:100%;} #slider-html5-lightbox .html5-elem-data-box {width:" + String(100 - v.options.imagepercentage) + "%;min-height:100%;}";
                i += "@media (max-width: " + v.options.sidetobottomscreenwidth + "px) {#slider-html5-lightbox .html5-elem-wrap {width:100%;height:auto;} #slider-html5-lightbox .html5-elem-data-box {width:100%;height:auto;min-height:0;}}"
            }
            i += ".html5-rotate { border-radius:50%; -webkit-transition:-webkit-transform .4s ease-in; transition: transform .4s ease-in; } .html5-rotate:hover { -webkit-transform: rotate(360deg); transform: rotate(360deg); }";
            i += "@media (max-width: " + v.options.navarrowsbottomscreenwidth + "px) {#html5-social {" + v.options.socialpositionsmallscreen + "}}";
            i += ".html5box-animated { -webkit-animation-duration:" + v.options.animationduration + "; animation-duration:" + v.options.animationduration + "; -webkit-animation-fill-mode: both; animation-fill-mode: both; } @-webkit-keyframes html5box-fadeOut { from { opacity: 1; } to { opacity: 0; } } @keyframes html5box-fadeOut { from { opacity: 1; } to { opacity: 0; } } .html5box-fadeOut { -webkit-animation-name: html5box-fadeOut; animation-name: html5box-fadeOut; }";
            i += "@-webkit-keyframes html5box-fadeOutDown { from { opacity: 1; } to { opacity: 0; -webkit-transform: translate3d(0, 100%, 0); transform: translate3d(0, 100%, 0); } } @keyframes html5box-fadeOutDown { from { opacity: 1; } to { opacity: 0; -webkit-transform: translate3d(0, 100%, 0); transform: translate3d(0, 100%, 0); } } .html5box-fadeOutDown { -webkit-animation-name: html5box-fadeOutDown; animation-name: html5box-fadeOutDown; }";
            M("head").append("<style type='text/css' data-creator='slider-html5-lightbox'>" + i + "</style>");
            var e = v.options.elemautoheight ? "auto" : "100%";
            v.$lightbox = M("<div id='slider-html5-lightbox' style='display:none;top:0px;left:0px;width:100%;height:100%;z-index:9999998;text-align:center;'>" + "<div id='html5-lightbox-overlay' style='display:block;position:absolute;top:0px;left:0px;width:100%;min-height:100%;background-color:" + v.options.overlaybgcolor + ";opacity:" + v.options.overlayopacity + ";filter:alpha(opacity=" + Math.round(v.options.overlayopacity * 100) + ");'></div>" + "<div id='html5-lightbox-box' style='display:block;position:relative;margin:0px auto;'>" + "<div class='html5-elem-box' style='display:block;position:relative;width:100%;overflow-x:hidden;overflow-y:auto;height:" + e + ";margin:0px auto;text-align:center;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;'>" + "<div class='html5-elem-wrap' style='display:block;position:relative;overflow:hidden;margin:0px auto;text-align:center;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;background-color:" + v.options.bgcolor + ";'>" + "<div class='html5-loading' style='display:none;position:absolute;top:0px;left:0px;text-align:center;width:100%;height:100%;background:url(\"" + v.options.loadingimage + "\") no-repeat center center;'></div>" + "<div class='html5-error-box html5-error' style='display:none;position:absolute;padding:" + v.options.bordersize + "px;text-align:center;width:" + v.options.errorwidth + "px;height:" + v.options.errorheight + "px;'>" + "The requested content cannot be loaded.<br />Please try again later." + "</div>" + "<div class='html5-image' style='display:none;position:relative;top:0px;left:0px;width:100%;height:100%;" + (v.options.iequirksmode ? "margin" : "padding") + ":" + v.options.bordersize + "px;text-align:center;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;'></div>" + "</div>" + "</div>" + "</div>" + "</div>");
            v.options.positionFixed = v.options.supportCSSPositionFixed && v.options.responsive && !v.options.iequirksmode;
            if (v.options.useabsolutepos || v.options.useabsoluteposonmobile && v.options.isMobile) v.options.positionFixed = false;
            v.$lightbox.css({
                position: v.options.positionFixed ? "fixed" : "absolute"
            });
            v.$lightbox.appendTo("body");
            v.$lightboxBox = M("#html5-lightbox-box", v.$lightbox);
            v.$elem = M(".html5-elem-box", v.$lightbox);
            v.$elemWrap = M(".html5-elem-wrap", v.$lightbox);
            v.$loading = M(".html5-loading", v.$lightbox);
            v.$error = M(".html5-error-box", v.$lightbox);
            v.$image = M(".html5-image", v.$lightbox);
            if (v.options.fullscreenmode && v.options.fullscreennomargin) v.$elem.css({
                overflow: "hidden"
            });
            var o = "<div class='html5-elem-data-box' style='display:none;box-sizing:border-box;'><div class='html5-text' style='display:block;overflow:hidden;'></div></div>";
            if (v.options.titlestyle == "left") v.$elem.prepend(o);
            else if (v.options.titlestyle == "outside") v.$lightbox.append(o);
            else v.$elem.append(o);
            v.$elemData = M(".html5-elem-data-box", v.$lightbox);
            v.$text = M(".html5-text", v.$lightbox);
            if (v.options.borderradius > 0) {
                v.$elem.css({
                    "border-radius": v.options.borderradius + "px",
                    "-moz-border-radius": v.options.borderradius + "px",
                    "-webkit-border-radius": v.options.borderradius + "px"
                });
                if (v.options.titlestyle == "inside") v.$elemWrap.css({
                    "border-radius": v.options.borderradius + "px",
                    "-moz-border-radius": v.options.borderradius + "px",
                    "-webkit-border-radius": v.options.borderradius + "px"
                });
                else if (v.options.titlestyle == "bottom") {
                    v.$elemWrap.css({
                        "border-top-left-radius": v.options.borderradius + "px",
                        "-moz-top-left-border-radius": v.options.borderradius + "px",
                        "-webkit-top-left-border-radius": v.options.borderradius + "px",
                        "border-top-right-radius": v.options.borderradius + "px",
                        "-moz-top-right-border-radius": v.options.borderradius + "px",
                        "-webkit-top-right-border-radius": v.options.borderradius + "px"
                    });
                    v.$elemData.css({
                        "border-bottom-left-radius": v.options.borderradius + "px",
                        "-moz-top-bottom-border-radius": v.options.borderradius + "px",
                        "-webkit-bottom-left-border-radius": v.options.borderradius + "px",
                        "border-bottom-right-radius": v.options.borderradius + "px",
                        "-moz-bottom-right-border-radius": v.options.borderradius + "px",
                        "-webkit-bottom-right-border-radius": v.options.borderradius + "px"
                    })
                }
            }
            if (v.options.titlestyle == "right" || v.options.titlestyle == "left") {
                v.$lightboxBox.css({
                    "background-color": v.options.bgcolor
                });
                if (v.options.titlestyle == "right") {
                    v.$elemWrap.css({
                        position: "relative",
                        "float": "left"
                    });
                    v.$elemData.css({
                        position: "relative",
                        overflow: "hidden",
                        padding: v.options.bordersize + "px"
                    })
                } else {
                    v.$elemWrap.css({
                        position: "relative",
                        overflow: "hidden"
                    });
                    v.$elemData.css({
                        position: "relative",
                        "float": "left",
                        padding: v.options.bordersize + "px"
                    })
                }
            } else if (v.options.titlestyle == "inside") {
                v.$elemData.css({
                    position: "absolute",
                    margin: 0,
                    padding: 0,
                    bottom: v.options.bordersize + "px",
                    left: v.options.bordersize + "px",
                    right: v.options.bordersize + "px",
                    "background-color": "#333",
                    "background-color": "rgba(51, 51, 51, 0.6)"
                });
                if (v.options.showonmouseoverinside) v.$elemData.css({
                    opacity: 0
                });
                v.$text.css({
                    padding: v.options.bordersize + "px " + 2 * v.options.bordersize + "px"
                })
            } else if (v.options.titlestyle == "outside") v.$elemData.css({
                position: "relative",
                width: "100%",
                height: "auto"
            });
            else {
                v.$elemData.css({
                    position: "relative",
                    width: "100%",
                    height: v.options.barautoheight ? "auto" : v.options.barheight + "px",
                    padding: "0 0 " + v.options.bordersize + "px" + " 0",
                    "background-color": v.options.bgcolor,
                    "text-align": "left"
                });
                if (!v.options.fullscreenmode || !v.options.fullscreennomargin) v.$text.css({
                    margin: "0 " + v.options.bordersize + "px"
                })
            }
            if (v.options.showsocial) {
                var s = '<div id="html5-social" style="display:none;' + v.options.socialposition + '">';
                var n = (v.options.socialdirection == "horizontal" ? "display:inline-block;" : "display:block;") + "margin:4px;";
                var a = "display:table-cell;width:" + v.options.socialbuttonsize + "px;height:" + v.options.socialbuttonsize + "px;font-size:" + v.options.socialbuttonfontsize + "px;border-radius:50%;color:#fff;vertical-align:middle;text-align:center;cursor:pointer;padding:0;";
                if (v.options.showemail) s += '<div class="html5-social-btn' + (v.options.socialrotateeffect ? " html5-rotate" : "") + ' html5-social-email" style="' + n + '"><div class="mh-icon-mail" style="' + a + 'background-color:#4d83ff;"></div></div>';
                if (v.options.showfacebook) s += '<div class="html5-social-btn' + (v.options.socialrotateeffect ? " html5-rotate" : "") + ' html5-social-facebook" style="' + n + '"><div class="mh-icon-facebook" style="' + a + 'background-color:#3b5998;"></div></div>';
                if (v.options.showtwitter) s += '<div class="html5-social-btn' + (v.options.socialrotateeffect ? " html5-rotate" : "") + ' html5-social-twitter" style="' + n + '"><div class="mh-icon-twitter" style="' + a + 'background-color:#03b3ee;"></div></div>';
                if (v.options.showpinterest) s += '<div class="html5-social-btn' + (v.options.socialrotateeffect ? " html5-rotate" : "") + ' html5-social-pinterest" style="' + n + '"><div class="mh-icon-pinterest" style="' + a + 'background-color:#c92228;"></div></div>';
                s += '<div style="clear:both;"></div></div>';
                v.$lightboxBox.append(s);
                M(".html5-social-btn", v.$lightbox).click(function() {
                    var t = window.location.href + (window.location.href.indexOf("?") < 0 ? "?" : "&") + "html5lightboxshare=" + encodeURIComponent(v.currentElem[d]);
                    var i = v.currentElem[u];
                    var e = v.currentElem[d];
                    if (v.currentElem[m] == 0) e = v.absoluteUrl(v.currentElem[d]);
                    else if (v.currentElem[m] == 3) e = "https://img.youtube.com/vi/" + v.getYoutubeId(v.currentElem[d]) + "/0.jpg";
                    else {
                        var o = M('.html5lightbox[href="' + v.currentElem[d] + '"]');
                        if (o.length > 0)
                            if (o.data("shareimage") && o.data("shareimage").length > 0) e = v.absoluteUrl(o.data("shareimage"));
                            else if (o.data("thumbnail") && o.data("thumbnail").length > 0) e = v.absoluteUrl(o.data("thumbnail"));
                        else {
                            var s = M("img", o);
                            if (s.length > 0) e = v.absoluteUrl(s.attr("src"))
                        }
                    }
                    var n = v.currentElem[m] == 2 || v.currentElem[m] == 3 || v.currentElem[m] == 4 || v.currentElem[m] == 8 || v.currentElem[m] == 9 || v.currentElem[m] == 11 || v.currentElem[m] == 12;
                    if (!i) i = "";
                    else i = v.html2Text(i);
                    if (M(this).hasClass("html5-social-facebook")) window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(t) + "&t=" + encodeURIComponent(i), "_blank");
                    else if (M(this).hasClass("html5-social-twitter")) window.open("https://twitter.com/share?url=" + encodeURIComponent(t) + "&text=" + encodeURIComponent(i), "_blank");
                    else if (M(this).hasClass("html5-social-pinterest")) window.open("https://pinterest.com/pin/create/bookmarklet/?media=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(t) + "&description=" + encodeURIComponent(i) + "&is_video=" + (n ? "true" : "false"), "_blank");
                    else if (M(this).hasClass("html5-social-email")) window.open("mailto:?subject=" + encodeURIComponent(i) + "&body=Check out this: " + encodeURIComponent(t));
                    return false
                })
            }
            if (v.options.fullscreenmode) {
                v.$lightbox.append("<div class='html5-next-fullscreen' style='cursor:pointer;position:absolute;right:" + v.options.bordersize + "px;top:50%;margin-top:-16px;z-index:1;'><img alt='' src='" + v.options.fullscreennextimage + "'></div>" + "<div class='html5-prev-fullscreen' style='cursor:pointer;position:absolute;left:" + v.options.bordersize + "px;top:50%;margin-top:-16px;z-index:1;'><img alt='' src='" + v.options.fullscreenprevimage + "'></div>");
                v.$next = M(".html5-next-fullscreen", v.$lightbox);
                v.$prev = M(".html5-prev-fullscreen", v.$lightbox);
                v.$lightboxBox.append("<div class='html5-next-bottom-fullscreen' style='cursor:pointer;position:absolute;top:100%;right:0;margin-top:8px;z-index:1;'><img alt='' src='" + v.options.fullscreennextimage + "'></div>" + "<div class='html5-prev-bottom-fullscreen' style='cursor:pointer;position:absolute;top:100%;left:0;margin-top:8px;z-index:1;'><img alt='' src='" + v.options.fullscreenprevimage + "'></div>");
                v.$nextbottom = M(".html5-next-bottom-fullscreen", v.$lightbox);
                v.$prevbottom = M(".html5-prev-bottom-fullscreen", v.$lightbox);
                v.$nextbottom.click(function() {
                    v.nextArrowClicked()
                });
                v.$prevbottom.click(function() {
                    v.prevArrowClicked()
                });
                v.$lightbox.append("<div id='html5-close-fullscreen' style='display:block;cursor:pointer;position:absolute;top:0;right:0;margin-top:0;margin-right:0;'><img alt='' src='" + v.options.fullscreencloseimage + "'></div>");
                v.$close = M("#html5-close-fullscreen", v.$lightbox)
            } else {
                v.$lightboxBox.append("<div class='html5-next' style='display:none;cursor:pointer;position:absolute;right:" + v.options.bordersize + "px;top:50%;margin-top:-32px;z-index:1;'><img alt='' src='" + v.options.nextimage + "'></div>" + "<div class='html5-prev' style='display:none;cursor:pointer;position:absolute;left:" + v.options.bordersize + "px;top:50%;margin-top:-32px;z-index:1;'><img alt='' src='" + v.options.previmage + "'></div>");
                v.$next = M(".html5-next", v.$lightbox);
                v.$prev = M(".html5-prev", v.$lightbox);
                if (v.options.isTouch && v.options.navarrowsalwaysshowontouch || v.options.alwaysshownavarrows) {
                    v.$lightboxBox.append("<div class='html5-next-touch' style='display:block;cursor:pointer;position:absolute;z-index:1;'><img alt='' src='" + v.options.nextimage + "'></div>" + "<div class='html5-prev-touch' style='display:block;cursor:pointer;position:absolute;z-index:1;'><img alt='' src='" + v.options.previmage + "'></div>");
                    v.$nexttouch = M(".html5-next-touch", v.$lightbox);
                    v.$prevtouch = M(".html5-prev-touch", v.$lightbox);
                    v.$nexttouch.click(function() {
                        v.nextArrowClicked()
                    });
                    v.$prevtouch.click(function() {
                        v.prevArrowClicked()
                    })
                }
                v.$lightboxBox.append("<div id='html5-close' style='display:none;cursor:pointer;position:absolute;top:0;right:0;margin-top:-16px;margin-right:-16px;'><img alt='' src='" + v.options.closeimage + "'></div>");
                v.$close = M("#html5-close", v.$lightbox)
            }
            if (v.options.titlestyle == "inside" && v.options.showonmouseoverinside) v.$lightboxBox.hover(function() {
                if (v.currentElem[m] == 0 || !v.options.showinsidetitleforimageonly) v.$elemData.animate({
                    opacity: 1
                }, 400)
            }, function() {
                v.$elemData.animate({
                    opacity: 0
                }, 400)
            });
            if (v.options.closeonoverlay) M("#html5-lightbox-overlay", v.$lightbox).click(v.finish);
            v.$close.click(v.finish);
            v.$next.click(function() {
                v.nextArrowClicked()
            });
            v.$prev.click(function() {
                v.prevArrowClicked()
            });
            M(window).resize(function() {
                if (v.options.isIOS && !v.options.mobileresizeevent) return;
                clearTimeout(v.options.resizeTimeout);
                v.options.resizeTimeout = setTimeout(function() {
                    v.resizeWindow()
                }, v.options.resizedelay)
            });
            M(window).scroll(function() {
                if (v.options.isIOS && !v.options.mobileresizeevent) return;
                v.scrollBox()
            });
            M(window).on("orientationchange", function(t) {
                if (v.options.isMobile) {
                    clearTimeout(v.options.resizeTimeout);
                    v.options.resizeTimeout = setTimeout(function() {
                        v.resizeWindow()
                    }, v.options.resizedelay)
                }
            });
            if (v.options.enabletouchswipe) v.enableSwipe()
        };
        v.html2Text = function(t) {
            var i = document.createElement("div");
            i.innerHTML = t;
            return i.innerText
        };
        v.slideTimer = function(t, i, e) {
            var o = this;
            o.timeout = t;
            var s = 50;
            var n = null;
            var a = 0;
            var r = false;
            var l = false;
            var h = false;
            this.pause = function() {
                if (l) {
                    r = true;
                    clearInterval(n)
                }
            };
            this.resume = function(t) {
                if (h && !t) return;
                h = false;
                if (l && r) {
                    r = false;
                    n = setInterval(function() {
                        a += s;
                        if (a > o.timeout) {
                            clearInterval(n);
                            if (i) i()
                        }
                        if (e) e(a / o.timeout)
                    }, s)
                }
            };
            this.stop = function() {
                clearInterval(n);
                if (e) e(-1);
                a = 0;
                r = false;
                l = false
            };
            this.start = function() {
                a = 0;
                r = false;
                l = true;
                n = setInterval(function() {
                    a += s;
                    if (a > o.timeout) {
                        clearInterval(n);
                        if (i) i()
                    }
                    if (e) e(a / o.timeout)
                }, s)
            };
            this.startandpause = function() {
                a = 0;
                r = true;
                l = true;
                h = true
            };
            return this
        };
        v.updateTimer = function(t) {
            var i = Math.round(t * 100);
            if (i > 100) i = 100;
            if (i < 0) i = 0;
            M(".html5-timer", v.$lightbox).css({
                display: "block",
                width: i + "%"
            })
        };
        v.initSlide = function() {
            v.autosliding = false;
            v.slideTimeout = v.slideTimer(v.options.slideinterval, function() {
                v.gotoSlide(-1)
            }, v.options.showtimer ? function(t) {
                v.updateTimer(t)
            } : null);
            if (v.options.autoslide) {
                v.slideTimeout.stop();
                v.autosliding = true
            }
        };
        v.nextArrowClicked = function() {
            if (v.options.nextElem <= v.options.curElem)
                if (v.options.onlastarrowclicked && window[v.options.onlastarrowclicked] && typeof window[v.options.onlastarrowclicked] == "function") window[v.options.onlastarrowclicked]();
            v.gotoSlide(-1)
        };
        v.prevArrowClicked = function() {
            if (v.options.prevElem >= v.options.curElem)
                if (v.options.onfirstarrowclicked && window[v.options.onfirstarrowclicked] && typeof window[v.options.onfirstarrowclicked] == "function") window[v.options.onfirstarrowclicked]();
            v.gotoSlide(-2)
        };
        v.calcNextPrevElem = function() {
            v.options.nextElem = -1;
            v.options.prevElem = -1;
            v.options.inGroup = false;
            v.options.groupIndex = 0;
            v.options.groupCount = 0;
            var t = v.elemArray[v.options.curElem][p];
            for (var i = 0; i < v.elemArray.length; i++)
                if (v.matchGroup(t, v.elemArray[i][p])) {
                    if (i == v.options.curElem) v.options.groupIndex = v.options.groupCount;
                    v.options.groupCount++
                } var e, o = v.elemArray[v.options.curElem][p];
            if (o != undefined && o != null) {
                for (e = v.options.curElem + 1; e < v.elemArray.length; e++)
                    if (v.matchGroup(o, v.elemArray[e][p])) {
                        v.options.nextElem = e;
                        break
                    } if (v.options.nextElem < 0)
                    for (e = 0; e < v.options.curElem; e++)
                        if (v.matchGroup(o, v.elemArray[e][p])) {
                            v.options.nextElem = e;
                            break
                        } if (v.options.nextElem >= 0) {
                    for (e = v.options.curElem - 1; e >= 0; e--)
                        if (v.matchGroup(o, v.elemArray[e][p])) {
                            v.options.prevElem = e;
                            break
                        } if (v.options.prevElem < 0)
                        for (e = v.elemArray.length - 1; e > v.options.curElem; e--)
                            if (v.matchGroup(o, v.elemArray[e][p])) {
                                v.options.prevElem = e;
                                break
                            }
                }
            }
            if (v.options.nextElem >= 0 || v.options.prevElem >= 0) v.options.inGroup = true
        };
        v.calcBoxPosition = function(t, i) {
            var e = t + 2 * v.options.bordersize;
            var o = i + 2 * v.options.bordersize;
            var s = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
            var n = M(window).height();
            var a = Math.round((n - s) / 2 - o / 2);
            if (v.options.titlestyle == "bottom") a -= Math.round(v.options.barheight / 2);
            var r = M(window).height() < v.options.smallscreenheight ? v.options.bordertopmarginsmall : v.options.bordertopmargin;
            if (a < r) a = r;
            if (v.options.insideiframe && window.self != window.top)
                if (M("#" + v.options.iframeid).length) {
                    var l = M("#" + v.options.iframeid).offset().top;
                    var h = parent.window.document.body.scrollTop;
                    a = r;
                    a += h > l ? h - l : 0
                } return [e, o, a]
        };
        v.hideNavArrows = function() {
            var t = false;
            var i = false;
            if (v.options.inGroup) {
                if (v.options.arrowloop || !v.options.arrowloop && v.options.prevElem < v.options.curElem) t = true;
                if (v.options.arrowloop || !v.options.arrowloop && v.options.nextElem > v.options.curElem) i = true
            }
            if (t) {
                v.$prev.removeClass("html5-hide");
                if (v.$prevbottom) v.$prevbottom.removeClass("html5-hide");
                if (v.$prevtouch) v.$prevtouch.removeClass("html5-hide")
            } else {
                v.$prev.addClass("html5-hide");
                if (v.$prevbottom) v.$prevbottom.addClass("html5-hide");
                if (v.$prevtouch) v.$prevtouch.addClass("html5-hide")
            }
            if (i) {
                v.$next.removeClass("html5-hide");
                if (v.$nextbottom) v.$nextbottom.removeClass("html5-hide");
                if (v.$nexttouch) v.$nexttouch.removeClass("html5-hide")
            } else {
                v.$next.addClass("html5-hide");
                if (v.$nextbottom) v.$nextbottom.addClass("html5-hide");
                if (v.$nexttouch) v.$nexttouch.addClass("html5-hide")
            }
        };
        v.resizePositionFixed = function() {
            if (!v.options.positionFixed) v.$lightbox.css({
                "padding-top": M(window).scrollTop() + "px",
                height: Math.max(M(document).height(), M(window).height()) + "px"
            })
        };
        v.adjustLightboxPos = function(t, i) {
            var e = M(window).width();
            var o = v.calcBoxPosition(t, i);
            var s = o[0];
            var n = o[1];
            var a = o[2];
            if (v.options.iequirksmode) v.$lightboxBox.css({
                top: a
            });
            else v.$lightboxBox.css({
                "margin-top": a
            });
            v.resizePositionFixed();
            if ((v.options.titlestyle == "left" || v.options.titlestyle == "right") && e > v.options.sidetobottomscreenwidth) {
                v.$lightboxBox.css({
                    width: s,
                    height: n
                });
                v.$elemWrap.css({
                    width: v.options.imagepercentage + "%",
                    height: "100%"
                })
            } else {
                v.$lightboxBox.css({
                    width: s,
                    height: "auto"
                });
                v.$elemWrap.css({
                    width: s,
                    height: n
                })
            }
        };
        v.clickHandler = function() {
            var t = M(this);
            var e = {};
            M.each(t.data(), function(t, i) {
                e[t.toLowerCase()] = i
            });
            v.options = M.extend(v.options, v.defaultoptions, e);
            M(window).trigger("html5lightbox.lightboxshow");
            v.init();
            if (v.elemArray.length <= 0) return true;
            v.hideObjects();
            for (var i = 0; i < v.elemArray.length; i++)
                if (v.elemArray[i][d] == t.attr("href")) break;
            if (i == v.elemArray.length) return true;
            v.options.curElem = i;
            v.calcNextPrevElem();
            v.reset();
            v.$lightbox.show();
            v.adjustLightboxPos(v.options.loadingwidth, v.options.loadingheight);
            v.loadCurElem();
            return false
        };
        v.loadThumbnail = function(i, e, o) {
            var t = new Image;
            M(t).on("load", function() {
                var t;
                if (this.width / this.height <= v.options.thumbwidth / v.options.thumbheight) t = "width:100%;";
                else t = "height:100%;";
                M(".html5-nav-thumb").eq(e).html("<img alt='" + v.html2Text(o) + "' style='" + t + "' src='" + i + "' />")
            });
            t.src = i
        };
        v.matchGroup = function(t, i) {
            if (v.options.showall) return true;
            if (!t || !i) return false;
            var e = t.split(":");
            var o = i.split(":");
            var s = false;
            for (var n in e)
                if (M.inArray(e[n], o) > -1) {
                    s = true;
                    break
                } return s
        };
        v.showNavigation = function() {
            if (!v.options.shownavigation) return;
            if (!v.currentElem || !v.currentElem[p]) return;
            var t;
            var i = false;
            var e = v.currentElem[p];
            for (t = 0; t < v.elemArray.length; t++)
                if (v.matchGroup(e, v.elemArray[t][p]))
                    if (v.elemArray[t][c] && v.elemArray[t][c].length > 0) {
                        i = true;
                        break
                    } if (!i) return;
            v.options.navheight = v.options.thumbheight + v.options.thumbtopmargin + v.options.thumbbottommargin;
            if (M(".html5-nav").length > 0) return;
            var o = v.options.hidenavdefault ? "top:100%;bottom:auto;left:0;right:0;" : "top:auto;bottom:0;left:0;right:0;";
            var s = v.options.positionFixed ? "fixed" : "absolute";
            M("body").append("<div class='html5-nav' style='display:block;position:" + s + ";" + o + "width:100%;height:" + v.options.navheight + "px;z-index:9999999;" + (v.options.navbgcolor ? "background-color:" + v.options.navbgcolor + ";" : "") + "'>" + "<div class='html5-nav-container' style='position:relative;margin:" + v.options.thumbtopmargin + "px auto " + v.options.thumbbottommargin + "px;'>" + "<div class='html5-nav-prev' style='display:block;position:absolute;cursor:pointer;width:" + v.options.navbuttonwidth + 'px;height:100%;left:0;top:0;background:url("' + v.options.navarrowsprevimage + "\") no-repeat left center;'></div>" + "<div class='html5-nav-mask' style='display:block;position:relative;margin:0 auto;overflow:hidden;'>" + "<div class='html5-nav-list'></div>" + "</div>" + "<div class='html5-nav-next' style='display:block;position:absolute;cursor:pointer;width:" + v.options.navbuttonwidth + 'px;height:100%;right:0;top:0;background:url("' + v.options.navarrowsnextimage + "\") no-repeat right center;'></div>" + "</div>" + "</div>");
            v.navvisible = v.options.hidenavdefault ? false : true;
            if (v.options.shownavcontrol) {
                M(".html5-nav").append('<div class="html5-nav-showcontrol" style="position:absolute;display:block;cursor:pointer;bottom:100%;right:12px;margin:0;padding:0;"><img alt="" src="' + v.options.navcontrolimage + '"></div>');
                M(".html5-nav-showcontrol").click(function() {
                    var t = M(window).height();
                    var i = M(".html5-nav").height();
                    if (v.navvisible) {
                        v.navvisible = false;
                        M(".html5-nav").css({
                            top: t - i + "px",
                            bottom: "auto"
                        }).animate({
                            top: t + "px"
                        }, function() {
                            M(this).css({
                                top: "100%",
                                bottom: "auto"
                            })
                        })
                    } else {
                        v.navvisible = true;
                        var i = M(".html5-nav").height();
                        M(".html5-nav").css({
                            top: t + "px",
                            bottom: "auto"
                        }).animate({
                            top: t - i + "px"
                        }, function() {
                            M(this).css({
                                top: "auto",
                                bottom: 0
                            })
                        })
                    }
                    v.resizeWindow()
                })
            }
            var n = 0;
            for (t = 0; t < v.elemArray.length; t++)
                if (v.matchGroup(e, v.elemArray[t][p]))
                    if (v.elemArray[t][c] && v.elemArray[t][c].length > 0) {
                        M(".html5-nav-list").append("<div class='html5-nav-thumb' data-arrayindex='" + t + "' style='float:left;overflow:hidden;cursor:pointer;opacity:" + v.options.thumbopacity + ";margin: 0 " + v.options.thumbgap / 2 + "px;width:" + v.options.thumbwidth + "px;height:" + v.options.thumbheight + "px;border:" + v.options.thumbborder + "px solid " + v.options.thumbbordercolor + ";'></div>");
                        this.loadThumbnail(v.elemArray[t][c], n, v.elemArray[t][u]);
                        n++
                    } M(".html5-nav-thumb").hover(function() {
                M(this).css({
                    opacity: 1
                });
                M(this).css({
                    border: v.options.thumbborder + "px solid " + v.options.thumbhighlightbordercolor
                })
            }, function() {
                M(this).css({
                    opacity: v.options.thumbopacity
                });
                M(this).css({
                    border: v.options.thumbborder + "px solid " + v.options.thumbbordercolor
                })
            });
            M(".html5-nav-thumb").click(function() {
                var t = M(this).data("arrayindex");
                if (t >= 0) v.gotoSlide(t)
            });
            v.options.totalwidth = n * (v.options.thumbgap + v.options.thumbwidth + 2 * v.options.thumbborder);
            M(".html5-nav-list").css({
                display: "block",
                position: "relative",
                "margin-left": 0,
                width: v.options.totalwidth + "px"
            }).append("<div style='clear:both;'></div>");
            var a = M(".html5-nav-mask");
            var r = M(".html5-nav-prev");
            var l = M(".html5-nav-next");
            r.click(function() {
                var t = M(".html5-nav-list");
                var i = M(".html5-nav-next");
                var e = M(window).width();
                var o = e - 2 * v.options.navbuttonwidth;
                var s = parseInt(t.css("margin-left")) + o;
                if (s >= 0) {
                    s = 0;
                    M(this).css({
                        "background-position": "center left"
                    })
                } else M(this).css({
                    "background-position": "center right"
                });
                if (s <= o - v.options.totalwidth) i.css({
                    "background-position": "center left"
                });
                else i.css({
                    "background-position": "center right"
                });
                t.animate({
                    "margin-left": s
                })
            });
            l.click(function() {
                var t = M(".html5-nav-list");
                var i = M(".html5-nav-prev");
                var e = M(window).width();
                var o = e - 2 * v.options.navbuttonwidth;
                var s = parseInt(t.css("margin-left")) - o;
                if (s <= o - v.options.totalwidth) {
                    s = o - v.options.totalwidth;
                    M(this).css({
                        "background-position": "center left"
                    })
                } else M(this).css({
                    "background-position": "center right"
                });
                if (s >= 0) i.css({
                    "background-position": "center left"
                });
                else i.css({
                    "background-position": "center right"
                });
                t.animate({
                    "margin-left": s
                })
            });
            var h = M(window).width();
            if (v.options.totalwidth <= h) {
                a.css({
                    width: v.options.totalwidth + "px"
                });
                r.hide();
                l.hide()
            } else {
                a.css({
                    width: h - 2 * v.options.navbuttonwidth + "px"
                });
                r.show();
                l.show()
            }
        };
        v.loadElem = function(t) {
            v.currentElem = t;
            v.showing = true;
            if (v.options.bodynoscroll) M("html,body").addClass("bodynoscroll");
            if (!(v.options.showtitle && v.currentElem[u] && v.currentElem[u].length > 0 || v.options.showdescription && v.currentElem[b] && v.currentElem[b].length > 0 || v.options.inGroup && (v.options.showplaybutton || v.options.showtitleprefix))) v.options.barheight = 0;
            v.showNavigation();
            v.$elem.off("mouseenter").off("mouseleave").off("mousemove");
            v.$loading.show();
            if (v.options.onshowitem && window[v.options.onshowitem] && typeof window[v.options.onshowitem] == "function") window[v.options.onshowitem](t);
            if ((v.options.transition == "slide" || v.options.transition == "crossfade") && v.existingElem >= 0) {
                M(".html5-elem-box-previous").remove();
                var i = v.$elem.clone();
                i.insertAfter(v.$elem);
                v.$prevelem = v.$elem;
                v.$elem = i;
                v.$prevelem.addClass("html5-elem-box-previous");
                v.$elem.addClass("html5-elem-box-current");
                v.$elemWrap = M(".html5-elem-wrap", v.$elem);
                v.$loading = M(".html5-loading", v.$elem);
                v.$error = M(".html5-error-box", v.$elem);
                v.$image = M(".html5-image", v.$elem);
                if (v.options.titlestyle != "outside") {
                    v.$elemData = M(".html5-elem-data-box", v.$elem);
                    v.$text = M(".html5-text", v.$elem)
                }
                v.$elem.css({
                    position: "absolute",
                    top: 0,
                    left: v.options.transition == "slide" ? v.direction == -1 ? "100%" : "-100%" : 0,
                    opacity: 0,
                    height: "auto"
                });
                v.$prevelem.css({
                    width: v.$prevelem.width() + "px",
                    height: v.$prevelem.height() + "px"
                })
            }
            switch (t[m]) {
                case 0:
                    var e = new Image;
                    M(e).on("load", function() {
                        t[h] = e.width;
                        t[w] = e.height;
                        v.showImage(t, e.width, e.height)
                    });
                    M(e).on("error", function() {
                        v.showError()
                    });
                    e.src = t[d];
                    break;
                case 1:
                    v.showSWF(t);
                    break;
                case 2:
                case 8:
                    v.showVideo(t);
                    break;
                case 3:
                case 4:
                case 9:
                case 11:
                case 12:
                    v.showYoutubeVimeo(t);
                    break;
                case 5:
                    v.showPDF(t);
                    break;
                case 6:
                    v.showMP3(t);
                    break;
                case 7:
                    v.showWeb(t);
                    break;
                case 10:
                    v.showDiv(t);
                    break
            }
            if (v.options.googleanalyticsaccount && window._gaq) window._gaq.push(["_trackEvent", "Lightbox", "Open", t[d]]);
            if (v.options.preload) {
                if (v.options.nextElem >= 0 && v.elemArray[v.options.nextElem][m] == 0)(new Image).src = v.elemArray[v.options.nextElem][d];
                if (v.options.prevElem >= 0 && v.elemArray[v.options.prevElem][m] == 0)(new Image).src = v.elemArray[v.options.prevElem][d]
            }
        };
        v.loadCurElem = function() {
            v.loadElem(v.elemArray[v.options.curElem])
        };
        v.showError = function() {
            v.$loading.hide();
            v.resizeLightbox(v.options.errorwidth, v.options.errorheight, true, function() {
                v.$loading.hide();
                v.$error.show();
                v.$elem.fadeIn(v.options.fadespeed, function() {
                    v.showData()
                })
            })
        };
        v.calcTextWidth = function(t) {
            return t - 36
        };
        v.showTitle = function(t, i) {
            var e = "";
            if (v.options.showtitle)
                if (t && t.length > 0) e += t;
            if (v.options.inGroup) {
                if (v.options.showtitleprefix) e = "<span class='html5-title-prefix'>" + v.options.titleprefix.replace("%NUM", v.options.groupIndex + 1).replace("%TOTAL", v.options.groupCount) + "</span> <span class='html5-title-caption'>" + e + "</span>";
                if (v.options.showplaybutton) e = "<div class='html5-playpause' style='display:inline-block;cursor:pointer;vertical-align:middle;width:" + v.options.playimagesize + "px;height:" + v.options.playimagesize + "px;'><div class='html5-play' style='display:block;'><img alt='' src='" + v.options.playimage + "'></div><div class='html5-pause' style='display:none;'><img alt='' src='" + v.options.pauseimage + "'></div></div> " + e
            }
            if (e.length > 0) e = '<div class="html5-title">' + e + "</div>";
            if (v.options.showdescription && i && i.length > 0) e += '<div class="html5-description">' + i + "</div>";
            v.$text.html(e);
            if (v.options.inGroup && v.options.showplaybutton) {
                if (v.autosliding) {
                    M(".html5-play", v.$lightbox).hide();
                    M(".html5-pause", v.$lightbox).show()
                } else {
                    M(".html5-play", v.$lightbox).show();
                    M(".html5-pause", v.$lightbox).hide()
                }
                M(".html5-play", v.$lightbox).click(function() {
                    M(".html5-play", v.$lightbox).hide();
                    M(".html5-pause", v.$lightbox).show();
                    if (v.slideTimeout) {
                        v.slideTimeout.stop();
                        v.slideTimeout.start();
                        v.autosliding = true
                    }
                });
                M(".html5-pause", v.$lightbox).click(function() {
                    M(".html5-play", v.$lightbox).show();
                    M(".html5-pause", v.$lightbox).hide();
                    if (v.slideTimeout) {
                        v.slideTimeout.stop();
                        v.autosliding = false
                    }
                })
            }
            M("#html5-social", v.$lightbox).show();
            if (v.options.showsocialmedia)
                if (v.currentElem[o])
                    if (M("#html5-socialmedia", v.$lightboxBox).length > 0) M("#html5-socialmedia", v.$lightboxBox).html(v.currentElem[o]);
                    else v.$lightboxBox.append('<div id="html5-socialmedia" style="' + v.options.socialmediaposition + '">' + v.currentElem[o] + "</div>");
            else if (M("#html5-socialmedia", v.$lightboxBox).length > 0) M("#html5-socialmedia", v.$lightboxBox).remove()
        }, v.showImage = function(n, t, i) {
            var e, o;
            if (n[g]) e = n[g];
            else {
                e = t;
                n[g] = t
            }
            if (n[f]) o = n[f];
            else {
                o = i;
                n[f] = i
            }
            v.showTitle(n[u], n[b]);
            var s = v.calcElemSize({
                w: e,
                h: o
            }, v.options.imagekeepratio);
            v.resizeLightbox(s.w, s.h, true, function() {
                v.$loading.hide();
                var t = !v.options.showtimer || !v.options.inGroup ? "" : "<div class='html5-timer' style='display:none;position:absolute;" + v.options.timerposition + ":0;left:0;width:0;height:" + v.options.timerheight + "px;background-color:" + v.options.timercolor + ";opacity:" + v.options.timeropacity + ";'></div>";
                var i = n[y] && n[y].length > 0 ? " title='" + n[y].replace(/'/g, "&#39;") + "'" : "";
                var e = n[x] && n[x].length > 0 ? " target='" + n[x] + "'" : "";
                var o = n[l] && n[l].length > 0 ? "<a href='" + n[l] + "'" + i + e + ">" : "";
                var s = n[l] && n[l].length > 0 ? "</a>" : "";
                v.$image.hide();
                v.$image.html("<div class='html5-image-container' style='display:block;position:relative;width:100%;height:100%;" + (v.options.imagekeepratio ? "overflow:hidden;" : "overflow:auto;") + "'>" + o + "<img class='html5-image-img' alt='" + v.html2Text(n[u]) + "' src='" + n[d] + "' width='100%' height='auto' />" + s + t + "</div>");
                v.$image.fadeIn(v.options.fadespeed);
                v.showData();
                if (v.autosliding) {
                    v.slideTimeout.stop();
                    v.slideTimeout.start()
                }
            })
        };
        v.showSWF = function(t) {
            var i = t[g] ? t[g] : v.options.defaultwidth;
            var e = t[f] ? t[f] : v.options.defaultheight;
            v.showTitle(t[u], t[b]);
            var o = v.calcElemSize({
                w: i,
                h: e
            }, true);
            i = o.w;
            e = o.h;
            v.resizeLightbox(i, e, true, function() {
                v.$loading.hide();
                v.$image.html("<div class='html5lightbox-swf' style='display:block;width:100%;height:100%;'></div>").show();
                v.embedFlash(M(".html5lightbox-swf", v.$image), t[d], "window", {
                    width: i,
                    height: e
                });
                v.$elem.show();
                v.showData();
                if (v.autosliding) {
                    v.slideTimeout.stop();
                    v.slideTimeout.start()
                }
            })
        };
        v.showVideo = function(o) {
            v.slideTimeout.stop();
            v.showTitle(o[u], o[b]);
            var s = o[g] ? o[g] : v.options.defaultwidth;
            var n = o[f] ? o[f] : v.options.defaultheight;
            var t = v.calcElemSize({
                w: s,
                h: n
            }, true);
            s = t.w;
            n = t.h;
            v.resizeLightbox(s, n, true, function() {
                v.$loading.hide();
                v.$image.html("<div class='html5lightbox-video' style='display:block;width:100%;height:100%;overflow:hidden;background-color:" + v.options.videobgcolor + ";'></div>").show();
                var t = false;
                if (v.options.isIE678 || o[m] == 8 || v.options.isIE9 && v.options.useflashonie9 || v.options.isIE10 && v.options.useflashonie10 || v.options.isIE11 && v.options.useflashonie11) t = false;
                else if (v.options.isMobile) t = true;
                else if ((v.options.html5player || !v.options.flashInstalled) && v.options.html5VideoSupported) {
                    t = true;
                    if (v.options.isFirefox || v.options.isOpera)
                        if (!o[a] && !o[r] && (!v.options.canplaymp4 || v.options.useflashformp4onfirefox)) t = false
                }
                if (t) {
                    var i = o[d];
                    if (v.options.isFirefox || v.options.isOpera)
                        if (o[a]) i = o[a];
                        else if (o[r]) i = o[r];
                    v.embedHTML5Video(M(".html5lightbox-video", v.$image), i, v.options.autoplay, v.options.mutevideo, v.options.loopvideo);
                    if (o[l] && o[l].length > 0) M(".html5-lightbox-video", v.$image).css({
                        cursor: "pointer"
                    }).click(function() {
                        if (o[x] && o[x].length > 0) window.open(o[l], o[x]);
                        else window.open(o[l])
                    })
                } else {
                    var e = o[d];
                    if (e.charAt(0) != "/" && e.substring(0, 5) != "http:" && e.substring(0, 6) != "https:") e = v.options.htmlfolder + e;
                    v.embedFlash(M(".html5lightbox-video", v.$image), v.options.jsfolder + "html5boxplayer.swf", "transparent", {
                        width: s,
                        height: n,
                        jsobjectname: "html5Lightbox",
                        hidecontrols: v.options.videohidecontrols ? "1" : "0",
                        hideplaybutton: "0",
                        videofile: e,
                        hdfile: "",
                        ishd: "0",
                        defaultvolume: v.options.defaultvideovolume,
                        autoplay: v.options.autoplay ? "1" : "0",
                        loop: v.options.loopvideo ? "1" : "0",
                        errorcss: ".html5box-error" + v.options.errorcss,
                        id: 0
                    })
                }
                v.$elem.show();
                v.showData()
            })
        };
        v.loadNext = function() {
            M(window).trigger("html5lightbox.videofinished");
            if (v.autosliding) v.gotoSlide(-1);
            else if (v.options.autoclose) setTimeout(function() {
                v.finish()
            }, v.options.autoclosedelay)
        };
        v.getYoutubeParams = function(t) {
            var i = {};
            if (t.indexOf("?") < 0) return i;
            var e = t.substring(t.indexOf("?") + 1).split("&");
            for (var o = 0; o < e.length; o++) {
                var s = e[o].split("=");
                if (s && s.length == 2 && s[0].toLowerCase() != "v") i[s[0].toLowerCase()] = s[1]
            }
            return i
        };
        v.getYoutubeId = function(t) {
            var i = "";
            var e = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\??v?=?))([^#\&\?]*).*/;
            var o = t.match(e);
            if (o && o[7] && o[7].length == 11) i = o[7];
            return i
        };
        v.prepareYoutubeHref = function(t) {
            var i = v.getYoutubeId(t);
            var e = "https:";
            var o = e + "//www.youtube.com/embed/" + i;
            var s = this.getYoutubeParams(t);
            var n = true;
            for (var a in s) {
                if (n) {
                    o += "?";
                    n = false
                } else o += "&";
                o += a + "=" + s[a]
            }
            return o
        };
        v.prepareDailymotionHref = function(t) {
            if (t.match(/\:\/\/.*(dai\.ly)/i)) {
                var i = "https:";
                var e = t.match(/(dai\.ly\/)([a-zA-Z0-9\-\_]+)/)[2];
                t = i + "//www.dailymotion.com/embed/video/" + e
            }
            return t
        };
        v.showYoutubeVimeo = function(t) {
            v.slideTimeout.stop();
            v.showTitle(t[u], t[b]);
            var i = t[g] ? t[g] : v.options.defaultwidth;
            var e = t[f] ? t[f] : v.options.defaultheight;
            var o = v.calcElemSize({
                w: i,
                h: e
            }, true);
            i = o.w;
            e = o.h;
            if (v.options.noresizecallback) {
                v.resizeLightbox(i, e, true, function() {
                    v.showData()
                });
                v.showYouTubeVimeoCallback(t, o)
            } else v.resizeLightbox(i, e, true, function() {
                v.showYouTubeVimeoCallback(t, o);
                v.showData()
            })
        };
        v.showYouTubeVimeoCallback = function(t, i) {
            v.$loading.hide();
            v.$image.html("<div class='html5lightbox-video' style='display:block;width:100%;height:100%;overflow:hidden;'></div>").show();
            var e = t[d];
            var o = "";
            if (t[m] == 3) {
                o = v.getYoutubeId(e);
                e = v.prepareYoutubeHref(e)
            }
            if (t[m] == 9) e = v.prepareDailymotionHref(e);
            if (v.options.autoplay) {
                e += e.indexOf("?") < 0 ? "?" : "&";
                if (t[m] == 11) e += "autoPlay=true";
                else e += "autoplay=1"
            }
            if (v.options.loopvideo) {
                e += e.indexOf("?") < 0 ? "?" : "&";
                switch (t[m]) {
                    case 3:
                        e += "loop=1&playlist=" + o;
                        break;
                    case 4:
                    case 9:
                        e += "loop=1";
                        break;
                    case 11:
                        e += "endVideoBehavior=loop";
                        break
                }
            }
            if (t[m] == 3) {
                if (e.indexOf("?") < 0) e += "?wmode=transparent&rel=0";
                else e += "&wmode=transparent&rel=0";
                if (v.options.videohidecontrols) e += "&controls=0&showinfo=0";
                if (v.options.mutevideo) e += "&mute=1";
                e += "&enablejsapi=1&origin=" + document.location.protocol + "//" + document.location.hostname
            } else if (t[m] == 4) {
                e += e.indexOf("?") < 0 ? "?" : "&";
                e += "api=1&player_id=html5boxiframevideo" + v.options.curElem;
                if (v.options.mutevideo) e += "&muted=1"
            }
            M(".html5lightbox-video", v.$image).html("<iframe style='margin:0;padding:0;border:0;' class='html5boxiframevideo' id='html5boxiframevideo" + v.options.curElem + "' width='100%' height='100%' src='" + e + "' frameborder='0' allow='autoplay' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>");
            v.$elem.show();
            if (t[m] == 3) {
                if (v.options.inityoutube) {
                    v.youtubeFinishCount = 0;
                    v.initYoutubeFinishCallback()
                }
            } else if (t[m] == 4)
                if (v.options.initvimeo) {
                    v.vimeoFinishCount = 0;
                    v.initVimeoFinishCallback()
                }
        };
        v.initYoutubeFinishCallback = function() {
            if (typeof YT === "object" && typeof YT.Player === "function") v.ytplayer = new YT.Player("html5boxiframevideo" + v.options.curElem, {
                events: {
                    onStateChange: function(t) {
                        if (t.data == YT.PlayerState.ENDED) {
                            M(window).trigger("html5lightbox.videofinished");
                            if (v.autosliding) v.gotoSlide(-1);
                            else if (v.options.autoclose) setTimeout(function() {
                                v.finish()
                            }, v.options.autoclosedelay)
                        }
                    }
                }
            });
            else setTimeout(function() {
                if (v.youtubeFinishCount < 10) {
                    v.youtubeFinishCount++;
                    v.initYoutubeFinishCallback()
                }
            }, 300)
        };
        v.initVimeoFinishCallback = function() {
            if (typeof $f === "function") {
                var t = M("#html5boxiframevideo" + v.options.curElem)[0];
                v.vimeoPlayer = $f(t);
                v.vimeoPlayer.addEvent("ready", function() {
                    v.vimeoPlayer.addEvent("finish", function(t) {
                        M(window).trigger("html5lightbox.videofinished");
                        if (v.autosliding) v.gotoSlide(-1);
                        else if (v.options.autoclose) setTimeout(function() {
                            v.finish()
                        }, v.options.autoclosedelay)
                    })
                })
            } else setTimeout(function() {
                if (v.vimeoFinishCount < 10) {
                    v.vimeoFinishCount++;
                    v.initVimeoFinishCallback()
                }
            }, 300)
        };
        v.showPDF = function(t) {
            if (v.options.enablepdfjs) {
                if (v.options.isIPhone && v.options.openpdfinnewtaboniphone || v.options.isIPad && v.options.openpdfinnewtabonipad) {
                    var i = window.open(t[d], "_blank");
                    i.focus();
                    v.finish();
                    return
                }
                if (!v.options.pdfjsengine) v.options.pdfjsengine = v.options.jsfolder + "pdfjs/web/viewer.html";
                var e = t[d];
                if (e.substring(0, 5) != "http:" && e.substring(0, 6) != "https:") e = v.absoluteUrl(e);
                var o = e.indexOf("#");
                if (o > 0) e = encodeURIComponent(e.substring(0, o)) + e.substring(o);
                else e = encodeURIComponent(e);
                var s = M.extend(true, {}, t);
                s[d] = v.options.pdfjsengine + (v.options.pdfjsengine.indexOf("?") < 0 ? "?" : "&") + "file=" + e;
                v.showWeb(s)
            } else if (v.options.isIPhone || v.options.isIPad || v.options.isAndroid || v.options.isIE || v.options.isIE11) {
                var i = window.open(t[d], "_blank");
                i.focus();
                v.finish();
                return
            } else v.showWeb(t)
        };
        v.showMP3 = function(t) {};
        v.showDiv = function(i) {
            v.showTitle(i[u], i[b]);
            var t = M(window).width();
            var e = M(window).height();
            var o = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
            var s = i[g] ? i[g] : v.options.usedefaultsizeforcontent ? v.options.defaultwidth : t;
            var n = i[f] ? i[f] : v.options.usedefaultsizeforcontent ? v.options.defaultheight : e - o;
            var a = v.calcElemSize({
                w: s,
                h: n
            }, false);
            s = a.w;
            n = a.h;
            v.resizeLightbox(s, n, true, function() {
                v.$loading.hide();
                v.$image.html("<div class='html5lightbox-div' id='html5lightbox-div" + v.options.curElem + "' style='display:block;width:100%;height:" + (v.options.autoresizecontent ? "auto" : "100%") + ";" + (v.options.isIOS ? "-webkit-overflow-scrolling:touch;overflow-y:scroll;" : "overflow:auto;") + "'></div>").show();
                var t = i[d];
                if (M(t).length > 0) M(t).children().appendTo(M("#html5lightbox-div" + v.options.curElem, v.$image));
                else M("#html5lightbox-div" + v.options.curElem, v.$image).html("<div class='html5-error'>The specified div ID does not exist.</div>");
                v.$elem.show();
                v.showData();
                if (v.options.autoresizecontent) v.resizeWindow();
                if (v.autosliding) {
                    v.slideTimeout.stop();
                    v.slideTimeout.start()
                }
            })
        };
        v.isSameDomain = function(t) {
            if (t.substring(0, 5) != "http:" && t.substring(0, 6) != "https:") return true;
            var i = document.createElement("a");
            i.setAttribute("href", t);
            var e = i.protocol == document.location.protocol && i.host == document.location.host && i.port == document.location.port;
            i = null;
            return e
        };
        v.showWeb = function(t) {
            v.showTitle(t[u], t[b]);
            var i = M(window).width();
            var e = M(window).height();
            var o = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
            var s = t[g] ? t[g] : v.options.usedefaultsizeforcontent ? v.options.defaultwidth : i;
            var n = t[f] ? t[f] : v.options.usedefaultsizeforcontent ? v.options.defaultheight : e - o;
            var a = v.calcElemSize({
                w: s,
                h: n
            }, false);
            s = a.w;
            n = a.h;
            v.resizeLightbox(s, n, true, function() {
                v.$loading.hide();
                v.$image.html("<div class='html5lightbox-web' style='display:block;width:100%;height:100%;" + (v.options.isIOS ? "-webkit-overflow-scrolling:touch;overflow-y:scroll;" : "") + "'></div>").show();
                M(".html5lightbox-web", v.$image).html("<iframe style='margin:0;padding:0;border:0;' class='html5lightbox-web-iframe' width='100%' height='100%' src='" + t[d] + "' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>");
                v.$elem.show();
                v.showData();
                if (v.options.autoresizecontent && v.isSameDomain(t[d])) {
                    M(".html5lightbox-web-iframe", v.$image).data("sameorigin", true);
                    M(".html5lightbox-web-iframe", v.$image).on("load", function() {
                        M(this).data("sameoriginloaded", true);
                        v.resizeWindow()
                    })
                }
                if (v.autosliding) {
                    v.slideTimeout.stop();
                    v.slideTimeout.start()
                }
            })
        };
        v.scrollBox = function() {};
        v.resizeWindow = function() {
            if (!v.currentElem) return;
            if (!v.options.responsive) return;
            var t = M(window).width();
            var i = M(window).height();
            if (!(v.options.showtitle && v.currentElem[u] && v.currentElem[u].length > 0 || v.options.showdescription && v.currentElem[b] && v.currentElem[b].length > 0 || v.options.inGroup && (v.options.showplaybutton || v.options.showtitleprefix))) v.options.barheight = 0;
            var e, o, s;
            if (v.currentElem[m] == 5 || v.currentElem[m] == 7 || v.currentElem[m] == 10) {
                var n = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
                e = v.currentElem[g] ? v.currentElem[g] : v.options.usedefaultsizeforcontent ? v.options.defaultwidth : t;
                o = v.currentElem[f] ? v.currentElem[f] : v.options.usedefaultsizeforcontent ? v.options.defaultheight : i - n;
                s = false
            } else {
                e = v.currentElem[g] ? v.currentElem[g] : v.options.defaultwidth;
                o = v.currentElem[f] ? v.currentElem[f] : v.options.defaultheight;
                if (v.currentElem[m] == 0) s = v.options.imagekeepratio;
                else s = true
            }
            var a = v.calcElemSize({
                w: e,
                h: o
            }, s);
            v.adjustLightboxPos(a.w, a.h);
            v.adjustDataHeight();
            if (v.options.autoresizecontent && (v.currentElem[m] == 5 || v.currentElem[m] == 7 || v.currentElem[m] == 10)) {
                var r = false;
                if (v.currentElem[m] == 7 && M(".html5lightbox-web-iframe", v.$lightbox).length > 0 && M(".html5lightbox-web-iframe", v.$lightbox).data("sameoriginloaded")) {
                    var l = M(".html5lightbox-web-iframe", v.$lightbox)[0];
                    if (l && l.contentWindow && l.contentWindow.document && l.contentWindow.document.documentElement.offsetHeight)
                        if (o > l.contentWindow.document.documentElement.offsetHeight) {
                            o = l.contentWindow.document.documentElement.offsetHeight;
                            r = true
                        }
                } else if (v.currentElem[m] == 10 && M(".html5lightbox-div", v.$lightbox).length > 0) {
                    var h = M(".html5lightbox-div", v.$lightbox).height();
                    if (o > h) {
                        o = h;
                        r = true
                    }
                }
                if (r) {
                    a = v.calcElemSize({
                        w: e,
                        h: o
                    }, s);
                    v.adjustLightboxPos(a.w, a.h)
                }
            }
            if (M(".html5-nav").length <= 0) return;
            M(".html5-nav-list").css({
                "margin-left": 0
            });
            var p = M(".html5-nav-mask");
            var d = M(".html5-nav-prev");
            var c = M(".html5-nav-next");
            var t = M(window).width();
            if (v.options.totalwidth <= t) {
                p.css({
                    width: v.options.totalwidth + "px"
                });
                d.hide();
                c.hide()
            } else {
                p.css({
                    width: t - 2 * v.options.navbuttonwidth + "px"
                });
                d.show();
                c.show()
            }
        };
        v.calcElemSize = function(t, i) {
            if (!v.options.responsive) return t;
            var e = M(window).width();
            var o = M(window).height();
            o = o ? o : M(document).height();
            if (v.options.resizeleftright && (v.options.titlestyle == "left" || v.options.titlestyle == "right") && e > v.options.sidetobottomscreenwidth) t.w = t.w * 100 / v.options.imagepercentage;
            var s = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
            var n = M(window).height() < v.options.smallscreenheight ? v.options.bordertopmarginsmall : v.options.bordertopmargin;
            var a = o - s - 2 * v.options.bordersize - 2 * n;
            if (v.options.responsivebarheight)
                if (o <= v.options.smallscreenheight) v.options.barheight = v.options.barheightonsmallheight;
                else v.options.barheight = v.options.barheightoriginal;
            if (v.options.titlestyle == "bottom") a -= v.options.barheight;
            else if (v.options.titlestyle == "outside") a -= v.$elemData.outerHeight();
            var r = e - 2 * v.options.bordersize - 2 * v.options.bordermargin;
            if (v.options.resizeleftright && (v.options.titlestyle == "left" || v.options.titlestyle == "right") && e > v.options.sidetobottomscreenwidth) r -= 2 * v.options.bordersize;
            if (v.options.fullscreenmode && e > v.options.navarrowsbottomscreenwidth || (v.options.isTouch && v.options.navarrowsalwaysshowontouch || v.options.alwaysshownavarrows) && e > v.options.navarrowsbottomscreenwidth) r -= 64;
            if (v.options.notkeepratioonsmallheight && o <= v.options.smallscreenheight) i = false;
            if (v.currentElem[m] == 0 && i) {
                var l = v.currentElem[h] / v.currentElem[w];
                if (v.options.resizeleftright && (v.options.titlestyle == "left" || v.options.titlestyle == "right") && e > v.options.sidetobottomscreenwidth) l *= 100 / v.options.imagepercentage;
                t.h = Math.round(t.w / l);
                if (t.h > a) {
                    t.w = Math.round(l * a);
                    t.h = a
                }
                if (t.w > r) {
                    t.h = Math.round(r / l);
                    t.w = r
                }
            } else {
                if (t.h > a) {
                    if (i) t.w = Math.round(t.w * a / t.h);
                    t.h = a
                } else if (v.options.maxheight) t.h = a;
                if (t.w > r) {
                    if (i) t.h = Math.round(t.h * r / t.w);
                    t.w = r
                }
            }
            if (v.options.resizeleftright && (v.options.titlestyle == "left" || v.options.titlestyle == "right") && e > v.options.sidetobottomscreenwidth) t.w += 2 * v.options.bordersize;
            return t
        };
        v.adjustDataHeight = function() {
            var t = M(window).width();
            var i = M(window).height();
            var e = v.options.titlestyle == "bottom" || v.options.titlestyle == "outside" || (v.options.titlestyle == "left" || v.options.titlestyle == "right") && t <= v.options.sidetobottomscreenwidth;
            if (v.options.responsivebarheight)
                if (i <= v.options.smallscreenheight) v.options.barheight = v.options.barheightonsmallheight;
                else v.options.barheight = v.options.barheightoriginal;
            if (e) {
                var o = M(window).height() < v.options.smallscreenheight ? v.options.bordertopmarginsmall : v.options.bordertopmargin;
                var s = v.options.shownavigation && v.navvisible ? v.options.navheight : 0;
                var i = M(window).height();
                var n = i - o - s;
                var a = v.options.barautoheight ? v.$elemData.outerHeight() : v.options.barheight;
                var r = v.$elemWrap.outerHeight() + a;
                var l = Math.min(n, r);
                var h = (i - s - l) / 2;
                v.$elem.css({
                    "max-height": l + "px"
                });
                v.$lightboxBox.css({
                    "margin-top": h + "px"
                })
            } else v.$elem.css({
                "max-height": "none"
            });
            if (v.options.titlestyle == "bottom" || v.options.titlestyle == "inside") v.$lightboxBox.css({
                height: "auto"
            });
            if (v.options.positionFixed) M("#html5-lightbox-overlay", v.$lightbox).css({
                height: Math.max(M(window).height(), M(document).height())
            });
            else M("#html5-lightbox-overlay", v.$lightbox).css({
                height: "100%"
            })
        };
        v.showData = function() {
            if (v.$text.text().length > 0) v.$elemData.show();
            v.adjustDataHeight();
            M(window).trigger("html5lightbox.lightboxopened")
        };
        v.resizeLightbox = function(t, i, e, o) {
            v.hideNavArrows();
            var s = v.calcBoxPosition(t, i);
            var n = s[0];
            var a = s[1];
            var r = s[2];
            v.$loading.hide();
            if (v.options.nextElem <= v.options.curElem)
                if (v.options.onlastitem && window[v.options.onlastitem] && typeof window[v.options.onlastitem] == "function") window[v.options.onlastitem](v.currentElem);
            if (v.options.prevElem >= v.options.curElem)
                if (v.options.onfirstitem && window[v.options.onfirstitem] && typeof window[v.options.onfirstitem] == "function") window[v.options.onfirstitem](v.currentElem);
            if (!v.options.fullscreenmode && (!v.options.isTouch || !v.options.navarrowsalwaysshowontouch) && !v.options.alwaysshownavarrows) {
                v.$lightboxBox.on("mouseenter mousemove", function() {
                    if (v.options.arrowloop && v.options.prevElem >= 0 || !v.options.arrowloop && v.options.prevElem >= 0 && v.options.prevElem < v.options.curElem) v.$prev.fadeIn();
                    if (v.options.arrowloop && v.options.nextElem >= 0 || !v.options.arrowloop && v.options.nextElem >= 0 && v.options.nextElem > v.options.curElem) v.$next.fadeIn()
                });
                v.$lightboxBox.on("mouseleave", function() {
                    v.$next.fadeOut();
                    v.$prev.fadeOut()
                })
            }
            var l = parseInt(v.$lightboxBox.css("margin-top"));
            v.$lightboxBox.css({
                "margin-top": r
            });
            v.resizePositionFixed();
            var h = e ? v.options.resizespeed : 0;
            if (v.options.fullscreenmode && v.options.fullscreennotransition) h = 0;
            if ((v.options.transition == "slide" || v.options.transition == "crossfade") && v.existingElem >= 0) h = 0;
            var p = M(window).width();
            if ((v.options.titlestyle == "left" || v.options.titlestyle == "right") && p > v.options.sidetobottomscreenwidth) {
                if (n == v.$lightboxBox.width() && a == v.$lightboxBox.height()) h = 0;
                v.$lightboxBox.animate({
                    width: n
                }, h).animate({
                    height: a
                }, h, function() {
                    v.onAnimateFinish(o)
                })
            } else {
                if (n == v.$elemWrap.width() && a == v.$elemWrap.height()) h = 0;
                v.$lightboxBox.css({
                    width: n,
                    height: "auto"
                });
                v.$elemWrap.animate({
                    width: n
                }, h).animate({
                    height: a
                }, h, function() {
                    v.onAnimateFinish(o)
                })
            }
        };
        v.onAnimateFinish = function(t) {
            v.$loading.show();
            v.$close.show();
            v.$elem.css({
                "background-color": v.options.bgcolor
            });
            v.resizePositionFixed();
            t();
            v.finishCallback()
        };
        v.finishCallback = function() {
            if ((v.options.transition == "slide" || v.options.transition == "crossfade") && v.existingElem >= 0)
                if (v.options.transition == "slide") {
                    v.$prevelem.animate({
                        left: v.direction == -1 ? "-100%" : "100%",
                        opacity: 0
                    }, {
                        duration: v.options.transitionduration
                    });
                    v.$elem.animate({
                        left: 0,
                        opacity: 1
                    }, {
                        duration: v.options.transitionduration,
                        always: function() {
                            v.$prevelem.remove();
                            v.$elem.removeClass("html5-elem-box-current").css({
                                position: "relative",
                                height: "100%"
                            })
                        }
                    })
                } else {
                    v.$prevelem.animate({
                        opacity: 0
                    }, {
                        duration: v.options.transitionduration
                    });
                    v.$elem.animate({
                        opacity: 1
                    }, {
                        duration: v.options.transitionduration,
                        always: function() {
                            v.$prevelem.remove();
                            v.$elem.removeClass("html5-elem-box-current").css({
                                position: "relative",
                                height: "100%"
                            })
                        }
                    })
                }
        }, v.resetDiv = function(t) {
            if (v.elemArray.length > 0 && t >= 0)
                if (v.elemArray[t][m] == 10) {
                    var i = v.elemArray[t][d];
                    if (M(i).length > 0) M("#html5lightbox-div" + t).children().appendTo(M(i))
                }
        };
        v.reset = function() {
            v.showing = false;
            v.$image.empty();
            v.$text.empty();
            v.$error.hide();
            v.$loading.hide();
            v.$image.hide();
            if (v.options.titlestyle == "bottom" || v.options.titlestyle == "inside") v.$elemData.hide();
            if (!v.options.fullscreenmode) v.$close.hide();
            v.$elem.css({
                "background-color": ""
            })
        };
        v.resetNavigation = function() {
            v.options.navheight = 0;
            M(".html5-nav").remove();
            v.navvisible = false
        };
        v.finish = function() {
            if (v.options.exitanimation == "fadeOut" || v.options.exitanimation == "fadeOutDown") {
                v.$lightbox.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                    v.$lightboxBox.removeClass("html5box-animated html5box-" + v.options.exitanimation);
                    v.$lightbox.removeClass("html5box-animated html5box-fadeOut");
                    v.finishDone()
                });
                v.$lightbox.addClass("html5box-animated html5box-fadeOut");
                v.$lightboxBox.addClass("html5box-animated html5box-" + v.options.exitanimation)
            } else v.finishDone()
        };
        v.finishDone = function() {
            v.existingElem = -1;
            v.resetDiv(v.options.curElem);
            if (M(".html5-lightbox-video", v.$lightbox).length) M(".html5-lightbox-video", v.$lightbox).attr("src", "");
            M("head").find("style").each(function() {
                if (M(this).data("creator") == "slider-html5-lightbox") M(this).remove()
            });
            if (v.options.bodynoscroll) M("html,body").removeClass("bodynoscroll");
            v.slideTimeout.stop();
            v.reset();
            v.resetNavigation();
            v.$lightbox.remove();
            M("#slider-html5-lightbox").remove();
            v.showObjects();
            if (v.options.oncloselightbox && window[v.options.oncloselightbox] && typeof window[v.options.oncloselightbox] == "function") window[v.options.oncloselightbox](v.currentElem);
            if (v.onLightboxClosed && typeof v.onLightboxClosed == "function") v.onLightboxClosed(v.currentElem);
            M(window).trigger("html5lightbox.lightboxclosed")
        };
        v.pauseSlide = function() {};
        v.playSlide = function() {};
        v.gotoSlide = function(t) {
            v.existingElem = v.options.curElem;
            v.direction = t;
            v.resetDiv(v.options.curElem);
            if (t == -1) {
                if (v.options.nextElem < 0) return;
                v.options.curElem = v.options.nextElem
            } else if (t == -2) {
                if (v.options.prevElem < 0) return;
                v.options.curElem = v.options.prevElem
            } else if (t >= 0) {
                v.direction = t > v.options.curElem ? -1 : -2;
                v.options.curElem = t
            }
            if (v.autosliding) v.slideTimeout.stop();
            v.calcNextPrevElem();
            if (v.options.transition != "slide" && v.options.transition != "crossfade") v.reset();
            v.loadCurElem();
            if (v.options.titlestyle == "inside" && v.options.showonmouseoverinside && v.currentElem[m] !== 0 && v.options.showinsidetitleforimageonly) v.$elemData.css({
                opacity: 0
            })
        };
        v.enableSwipe = function() {
            var t = v.options.isAndroid && (v.options.swipepreventdefaultonandroid || v.options.androidVersion >= 0 && v.options.androidVersion <= 5) ? true : false;
            v.$lightboxBox.sliderTouchSwipe({
                preventWebBrowser: t,
                swipeDistance: v.options.swipedistance,
                swipeLeft: function() {
                    v.gotoSlide(-1)
                },
                swipeRight: function() {
                    v.gotoSlide(-2)
                }
            })
        };
        v.hideObjects = function() {
            M("select, embed, object").css({
                visibility: "hidden"
            })
        };
        v.showObjects = function() {
            M("select, embed, object").css({
                visibility: "visible"
            })
        };
        v.embedHTML5Video = function(t, i, e, o, s) {
            t.html("<div style='display:block;width:100%;height:100%;position:relative;'><video class='html5-lightbox-video' width='100%' height='100%'" + (v.options.html5videoposter && v.options.html5videoposter.length > 0 ? "poster='" + v.options.html5videoposter + "'" : "") + (e ? " autoplay" : "") + (s ? " loop" : "") + (o ? " muted" : "") + (v.options.nativehtml5controls && !v.options.videohidecontrols ? " controls='controls'" : "") + (v.options.nativecontrolsnodownload ? ' controlsList="nodownload"' : "") + " src='" + i + "'></div>");
            if (o) v.options.defaultvideovolume = 0;
            if (!v.options.nativehtml5controls && !v.options.videohidecontrols) {
                M("video", t).data("src", i);
                M("video", t).asHTML5VideoControls(v.options.skinsfolder, v, ".html5-lightbox-video", v.options.videohidecontrols, false, v.options.defaultvideovolume, v.options.nativecontrolsonfullscreen, v.options.nativecontrolsnodownload, null)
            }
            M("video", t).off("ended").on("ended", function() {
                M(window).trigger("html5lightbox.videofinished");
                if (v.autosliding) v.gotoSlide(-1);
                else if (v.options.autoclose) setTimeout(function() {
                    v.finish()
                }, v.options.autoclosedelay)
            })
        };
        v.embedFlash = function(t, i, e, o) {
            if (v.options.flashInstalled) {
                var s = {
                    pluginspage: "http://www.adobe.com/go/getflashplayer",
                    quality: "high",
                    allowFullScreen: "true",
                    allowScriptAccess: "always",
                    type: "application/x-shockwave-flash"
                };
                s.width = "100%";
                s.height = "100%";
                s.src = i;
                s.flashVars = M.param(o);
                s.wmode = e;
                var n = "";
                for (var a in s) n += a + "=" + s[a] + " ";
                t.html("<embed " + n + "/>")
            } else t.html("<div class='html5lightbox-flash-error' style='display:block; position:relative;text-align:center; width:100%; left:0px; top:40%;'><div class='html5-error'><div>The required Adobe Flash Player plugin is not installed</div><br /><div style='display:block;position:relative;text-align:center;width:112px;height:33px;margin:0px auto;'><a href='http://www.adobe.com/go/getflashplayer'><img src='http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash player' width='112' height='33'></img></a></div></div>")
        };
        v.checkType = function(t) {
            if (!t) return -1;
            if (t.match(/\.(jpg|gif|png|bmp|jpeg)(.*)?$/i)) return 0;
            if (t.match(/[^\.]\.(swf)\s*$/i)) return 1;
            if (t.match(/\.(mp4|m4v|ogv|ogg|webm)(.*)?$/i)) return 2;
            if (t.match(/\:\/\/.*(youtube\.com)/i) || t.match(/\:\/\/.*(youtu\.be)/i)) return 3;
            if (t.match(/\:\/\/.*(vimeo\.com)/i)) return 4;
            if (t.match(/\:\/\/.*(dailymotion\.com)/i) || t.match(/\:\/\/.*(dai\.ly)/i)) return 9;
            if (t.match(/[^\.]\.(pdf)/i)) return 5;
            if (t.match(/[^\.]\.(mp3)\s*$/i)) return 6;
            if (t.match(/[^\.]\.(flv)\s*$/i)) return 8;
            if (t.match(/\#\w+/i)) return 10;
            if (t.match(/\:\/\/.*(wistia)/i)) return 11;
            return 7
        };
        v.getURLParams = function() {
            var t = {};
            var i = window.location.search.substring(1).split("&");
            for (var e = 0; e < i.length; e++) {
                var o = i[e].split("=");
                if (o && o.length == 2) t[o[0].toLowerCase()] = unescape(o[1])
            }
            return t
        };
        v.absoluteUrl = function(t) {
            var i = document.createElement("a");
            i.href = t;
            return i.protocol + "//" + i.host + i.pathname + i.search + i.hash
        };
        v.showLightboxObject = function(t) {
            if (t) v.showLightbox(t.type, t.href, t.title, t.width, t.height, t.webm, t.ogg, t.thumbnail, t.description, t.div, t.originalwidth, t.originalheight, t.socialmedia, t.weblink, t.weblinktarget, t.weblinktext, t.group)
        };
        v.showLightbox = function(t, i, e, o, s, n, a, r, l, h, p, d, c, m, u, g, f) {
            v.options = M.extend(v.options, v.defaultoptions);
            M(window).trigger("html5lightbox.lightboxshow");
            v.init();
            v.reset();
            v.$lightbox.show();
            v.adjustLightboxPos(v.options.loadingwidth, v.options.loadingheight);
            v.loadElem(new Array(t, i, e, f, o, s, n, a, r, l, h, p, d, c, m, u, g))
        };
        v.addItemNoDuplicate = function(t, i, e, o, s, n, a, r, l, h) {
            for (var p = 0; p < v.elemArray.length; p++)
                if (v.elemArray[p][d] == t) return;
            v.addItem(t, i, e, o, s, n, a, r, l, h)
        };
        v.addItem = function(t, i, e, o, s, n, a, r, l, h) {
            type = h && h >= 0 ? h : v.checkType(t);
            v.elemArray.push(new Array(type, t, i, e, o, s, n, a, r, l))
        };
        v.showItem = function(t) {
            v.options = M.extend(v.options, v.defaultoptions);
            M(window).trigger("html5lightbox.lightboxshow");
            v.init();
            if (v.elemArray.length <= 0) return true;
            v.hideObjects();
            for (var i = 0; i < v.elemArray.length; i++)
                if (v.elemArray[i][d] == t) break;
            if (i == v.elemArray.length) return true;
            v.options.curElem = i;
            v.calcNextPrevElem();
            v.reset();
            v.$lightbox.show();
            v.adjustLightboxPos(v.options.loadingwidth, v.options.loadingheight);
            v.loadCurElem();
            return false
        };
        v.each(function() {
            var t = M(this);
            var i = this.nodeName.toLowerCase();
            if (i == "a" || i == "area") t.off("click").click(v.clickHandler);
            else t.find("a,area").each(function() {
                M(this).off("click").click(v.clickHandler)
            });
            var e = false;
            var o = 0;
            var s = false;
            var n = 0;
            if (typeof html5lightbox_options != "undefined" && html5lightbox_options) {
                if ("autoopen" in html5lightbox_options) e = html5lightbox_options.autoopen;
                if ("autoopendelay" in html5lightbox_options) o = html5lightbox_options.autoopendelay;
                if ("autoopenonce" in html5lightbox_options) s = html5lightbox_options.autoopenonce;
                if ("autoopenonceexpire" in html5lightbox_options) n = html5lightbox_options.autoopenonceexpire
            }
            e = t.data("autoopen") ? t.data("autoopen") : e;
            o = t.data("autoopendelay") ? t.data("autoopendelay") : o;
            s = t.data("autoopenonce") ? t.data("autoopenonce") : s;
            n = t.data("autoopenonceexpire") ? t.data("autoopenonceexpire") : n;
            autocookie = "html5lightboxpopup=1;path=/";
            if (n > 0) {
                var a = new Date;
                a.setTime(a.getTime() + n * 60 * 60 * 1e3);
                autocookie += ";expires=" + a.toUTCString()
            }
            if (e) {
                var r = false;
                if (s) {
                    var l = document.cookie ? document.cookie.split(";") : [];
                    for (var h in l) {
                        var p = M.trim(l[h]).split("=");
                        if (p.length && p[0] == "html5lightboxpopup") {
                            r = true;
                            break
                        }
                    }
                }
                if (!r) {
                    setTimeout(function() {
                        t.click();
                        document.cookie = autocookie
                    }, o);
                    return false
                }
            }
            if (t.data("preloadonpageload")) {
                var d = "mediatype" in t.data() ? t.data("mediatype") : v.checkType(t.attr("href"));
                if (d == 0) {
                    var c = t.data("preloaddelay") ? t.data("preloaddelay") : 0;
                    setTimeout(function() {
                        (new Image).src = t.attr("href")
                    }, c)
                }
            }
        });
        if (v.options.preloadallonpageload) setTimeout(function() {
            v.each(function() {
                if (this.nodeName.toLowerCase() != "a" && this.nodeName.toLowerCase() != "area") return;
                var t = "mediatype" in M(this).data() ? M(this).data("mediatype") : v.checkType(M(this).attr("href"));
                if (t !== 0) return;
                (new Image).src = M(this).attr("href");
                if (M(this).data("thumbnail"))(new Image).src = M(this).data("thumbnail")
            })
        }, v.options.preloadalldelay);
        return v
    }
})(jQuery);

function L(t, i, e) {
    var o = this;
    o.timeout = t;
    var s = 50;
    var n = null;
    var a = 0;
    var r = false;
    var l = false;
    var h = false;
    this.pause = function() {
        if (l) {
            r = true;
            clearInterval(n)
        }
    };
    this.resume = function(t) {
        if (h && !t) return;
        h = false;
        if (l && r) {
            r = false;
            n = setInterval(function() {
                a += s;
                if (a > o.timeout) {
                    clearInterval(n);
                    if (i) i()
                }
                if (e) e(a / o.timeout)
            }, s)
        }
    };
    this.stop = function() {
        clearInterval(n);
        if (e) e(-1);
        a = 0;
        r = false;
        l = false
    };
    this.start = function() {
        a = 0;
        r = false;
        l = true;
        n = setInterval(function() {
            a += s;
            if (a > o.timeout) {
                clearInterval(n);
                if (i) i()
            }
            if (e) e(a / o.timeout)
        }, s)
    };
    this.startandpause = function() {
        a = 0;
        r = true;
        l = true;
        h = true
    };
    this.unsetstartandpause = function() {
        h = false
    }
}
var az_ = {
    flashInstalled: function() {
        var t = false;
        try {
            if (new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) t = true
        } catch (i) {
            if (navigator.mimeTypes["application/x-shockwave-flash"]) t = true
        }
        return t
    },
    html5VideoSupported: function() {
        return !!document.createElement("video").canPlayType
    },
    canPlayMP4: function() {
        var t = document.createElement("video");
        return t && t.canPlayType && t.canPlayType("video/mp4").replace(/no/, "")
    },
    isQt: function() {
        return navigator.userAgent.match(/\sQt\//i) != null
    },
    isChrome: function() {
        return navigator.userAgent.match(/Chrome/i) != null
    },
    isFirefox: function() {
        return navigator.userAgent.match(/Firefox/i) != null
    },
    isOpera: function() {
        return navigator.userAgent.match(/Opera/i) != null || navigator.userAgent.match(/OPR\//i) != null
    },
    isSafari: function() {
        return navigator.userAgent.match(/Safari/i) != null
    },
    isAndroid: function() {
        return navigator.userAgent.match(/Android/i) != null
    },
    isIPad: function() {
        return navigator.userAgent.match(/iPad/i) != null
    },
    isIPhone: function() {
        return navigator.userAgent.match(/iPod/i) != null || navigator.userAgent.match(/iPhone/i) != null
    },
    isIOS: function() {
        return this.isIPad() || this.isIPhone()
    },
    isMobile: function() {
        return this.isAndroid() || this.isIPad() || this.isIPhone()
    },
    isIE11: function() {
        return navigator.userAgent.match(/Trident\/7/) != null && navigator.userAgent.match(/rv:11/) != null
    },
    isIE: function() {
        return (navigator.userAgent.match(/MSIE/i) != null || this.isIE11()) && !this.isOpera()
    },
    isIE10: function() {
        return navigator.userAgent.match(/MSIE 10/i) != null && !this.isOpera()
    },
    isIE9: function() {
        return navigator.userAgent.match(/MSIE 9/i) != null && !this.isOpera()
    },
    isIE8: function() {
        return navigator.userAgent.match(/MSIE 8/i) != null && !this.isOpera()
    },
    isIE7: function() {
        return navigator.userAgent.match(/MSIE 7/i) != null && !this.isOpera()
    },
    isIE6: function() {
        return navigator.userAgent.match(/MSIE 6/i) != null && !this.isOpera()
    },
    isIE678: function() {
        return this.isIE6() || this.isIE7() || this.isIE8()
    },
    isIE6789: function() {
        return this.isIE6() || this.isIE7() || this.isIE8() || this.isIE9()
    },
    isTouch: function() {
        return "ontouchstart" in window
    },
    css33dTransformSupported: function() {
        return !this.isIE() && !this.isOpera()
    },
    applyBrowserStyles: function(t, i) {
        var e = {};
        for (var o in t) {
            e[o] = t[o];
            e["-webkit-" + o] = i ? "-webkit-" + t[o] : t[o];
            e["-moz-" + o] = i ? "-moz-" + t[o] : t[o];
            e["-ms-" + o] = i ? "-ms-" + t[o] : t[o];
            e["-o-" + o] = i ? "-o-" + t[o] : t[o]
        }
        return e
    }
};
(function(P) {
    P.fn.amazingslider72 = function(b) {
        var c = 0,
            m = 1,
            k = 2,
            z = 3,
            v = 4,
            u = 5,
            x = 6,
            y = 7,
            A = 8,
            s = 9,
            n = 10,
            a = 11,
            r = 12,
            l = 13,
            h = 14,
            E = 15,
            I = 16,
            M = 17,
            g = 18;
        var t = 1,
            i = 2,
            e = 3,
            o = 4,
            p = 5,
            T = 6,
            d = 7,
            S = 8,
            f = 9,
            $ = 10,
            C = 11;
        var B = function(t, i, e, o) {
            this.container = t;
            this.options = i;
            this.textoptions = e;
            this.id = o;
            this.transitionTimeout = null;
            this.arrowTimeout = null;
            this.socialTimeout = null;
            this.lightboxArray = [];
            this.elemArray = [];
            this.container.children().hide();
            this.container.css({
                display: "block",
                position: "relative"
            });
            P(".amazingslider-engine").css({
                display: "none"
            });
            if (az_.isMobile() && !this.options.navshowpreviewontouch) this.options.navshowpreview = false;
            this.container.trigger("amazingslider.initstart");
            this.initData(this.init)
        };
        B.prototype = {
            initData: function(t) {
                this.readTags();
                t(this)
            },
            readTags: function() {
                var E = this;
                P(".amazingslider-slides", this.container).find("li").each(function() {
                    var t = P("img.amazingsliderimg", P(this));
                    if (t.length <= 0) t = P("img", P(this));
                    if (P("video", P(this)).length > 0) {
                        var i = [];
                        var e = P("video", P(this));
                        var o = P("source[type='video/mp4']", e).attr("src");
                        var s = T;
                        i.push({
                            href: o,
                            type: s
                        });
                        if (s == T)
                            if (e.data("webm") && e.data("webm").length > 0) i.push({
                                href: e.data("webm"),
                                type: S
                            });
                        var n = new Array(E.elemArray.length, "", "", "", "", "", i, "", false, 0, 0, "", "", "", 0, "", s, "");
                        E.elemArray.push(n)
                    } else if (t.length > 0) {
                        var a = "";
                        var r = ["src", "class", "title", "alt", "data-description", "data-duration", "data-texteffect"];
                        var l = t.attr("src");
                        var h = E.options.lazyloadtags.split(",");
                        for (var p = 0; p < h.length; p++) {
                            r.push("data-" + h[p]);
                            if (t.data(h[p]) && t.data(h[p]).length > 0) {
                                l = t.data(h[p]);
                                break
                            }
                        }
                        var d = t.attr("title") && t.attr("title").length > 0 ? t.attr("title") : "";
                        if (!d && E.options.titleusealt) d = t.attr("alt") && t.attr("alt").length > 0 ? t.attr("alt") : "";
                        var c = t.data("description") && t.data("description").length > 0 ? t.data("description") : "";
                        var m = t.parent() && t.parent().is("a") ? t.parent().attr("href") : "";
                        var u = t.parent() && t.parent().is("a") ? t.parent().attr("target") : "";
                        var g = t.parent() && t.parent().is("a") ? t.parent().hasClass("html5lightbox") : false;
                        var f = t.parent() && g ? t.parent().data("width") : 0;
                        var v = t.parent() && g ? t.parent().data("height") : 0;
                        var b = t.parent() && t.parent().is("a") ? t.parent().data("webm") : "";
                        var w = t.parent() && t.parent().is("a") ? t.parent().data("ogg") : "";
                        var x = t.data("texteffect") && t.data("texteffect").length > 0 ? t.data("texteffect") : "";
                        var y = t.data("duration") ? t.data("duration") : 0;
                        var k = t.attr("alt") && t.attr("alt").length > 0 ? t.attr("alt") : d;
                        if (E.options.addextraattributes) P.each(t.get(0).attributes, function(t, i) {
                            if (r.indexOf(i.name) == -1) a += " " + i.name + '="' + i.value + '"'
                        });
                        var z = "";
                        var A = P("button.amazingsliderbutton", P(this));
                        if (A.length > 0)
                            if (A.parent().is("a")) z = A.parent().clone().wrapAll("<div/>").parent().html();
                            else z = A.clone().wrapAll("<div/>").parent().html();
                        var i = [];
                        var s = g && t.parent() && t.parent().data("mediatype") ? t.parent().data("mediatype") : E.checkVideoType(m);
                        if (P("video", P(this)).length > 0) {
                            var e = P("video", P(this));
                            var o = e.attr("src");
                            if (!o && e.data("src") && e.data("src").length > 0) o = e.data("src");
                            s = T;
                            i.push({
                                href: o,
                                type: s
                            });
                            if (s == T)
                                if (e.data("webm") && e.data("webm").length > 0) i.push({
                                    href: e.data("webm"),
                                    type: S
                                })
                        }
                        var n = new Array(E.elemArray.length, l, d, c, m, u, i, "", g, f, v, b, w, x, y, z, s, k, a);
                        E.elemArray.push(n);
                        if (g) E.lightboxArray.push(n)
                    }
                });
                P(".amazingslider-thumbnails", this.container).find("li").each(function(t) {
                    var i = P("img.amazingsliderthumbnailimg", P(this));
                    if (i.length <= 0) i = P("img", P(this));
                    if (i.length > 0 && E.elemArray.length > t) {
                        var e = i.attr("src");
                        var o = E.options.lazyloadtags.split(",");
                        for (var s = 0; s < o.length; s++)
                            if (i.data(o[s]) && i.data(o[s]).length > 0) {
                                e = i.data(o[s]);
                                break
                            } E.elemArray[t][y] = e
                    }
                });
                if (this.options.shownumbering)
                    for (var t = 0; t < this.elemArray.length; t++) {
                        var i = this.options.numberingformat.replace("%NUM", t + 1).replace("%TOTAL", this.elemArray.length);
                        this.elemArray[t][k] = i + this.elemArray[t][k]
                    }
            },
            init: function(t) {
                if (t.elemArray.length <= 0) return;
                var i;
                var e = t.elemArray.length;
                if (t.options.randomplay) {
                    for (i = e - 1; i > 0; i--) {
                        if (i == 1 && Math.random() < .5) break;
                        var o = Math.floor(Math.random() * i);
                        var s = t.elemArray[o];
                        t.elemArray[o] = t.elemArray[i];
                        t.elemArray[i] = s
                    }
                    for (i = 0; i < e; i++) t.elemArray[i][c] = i
                }
                t.isAnimating = false;
                t.isPaused = !t.options.autoplay;
                t.videoPaused = false;
                t.lightboxPaused = false;
                t.isPausedOnMouseover = false;
                t.initSocial();
                t.initVideoApi();
                t.createMarkup();
                t.createStyle();
                t.createNav();
                t.createArrows();
                t.createBottomShadow();
                t.createBackgroundImage();
                t.createText();
                t.createSliderTimeout();
                t.createRibbon();
                t.showSocial();
                t.initHtml5Lightbox();
                t.googleFontsCreated = false;
                t.curElem = -1;
                t.prevElem = -1;
                t.nextElem = -1;
                t.firstslide = true;
                t.loopCount = 0;
                t.pauseCarousel = false;
                t.curImageMarginTop = 0;
                t.curImageMarginLeft = 0;
                t.curImageMaxWidth = 100;
                t.prevImageMarginTop = 0;
                t.prevImageMarginLeft = 0;
                t.prevImageMaxWidth = 100;
                t.prevtextstyle = "";
                t.html5Volume = 1;
                t.videoAutoplayMode = true;
                t.vimeoAPILoadCount = 0;
                var n = 0;
                var a = t.getParams();
                var r = parseInt(a["firstslideid"]);
                if (!isNaN(r) && r >= 1 && r <= t.elemArray.length) n = r - 1;
                r = parseInt(a["slidershareid"]);
                if (!isNaN(r) && r >= 0 && r < t.elemArray.length) n = r;
                t.slideRun(n);
                t.container.trigger("amazingslider.inited", [n]);
                if ("html5lightboxshare" in a) {
                    var l = decodeURIComponent(a["html5lightboxshare"]);
                    var h = P('.html5lightbox[href="' + l + '"]');
                    if (h.length > 0) {
                        if (!t.isPaused) {
                            t.lightboxPaused = true;
                            t.isPaused = true;
                            t.sliderTimeout.pause()
                        }
                        t.html5Lightbox.showItem(l)
                    }
                }
                t.productZoomImage()
            },
            getParams: function() {
                var t = {};
                var i = window.location.search.substring(1).split("&");
                for (var e = 0; e < i.length; e++) {
                    var o = i[e].split("=");
                    if (o && o.length == 2) t[o[0].toLowerCase()] = unescape(o[1])
                }
                return t
            },
            initHtml5Lightbox: function() {
                var t;
                if (this.lightboxArray.length > 0) {
                    var i = this.options.skinsfoldername.length > 0 ? this.options.skinsfoldername + "/" : "";
                    var e = {
                        jsfolder: this.options.jsfolder,
                        skinsfoldername: i,
                        nativehtml5controls: this.options.nativehtml5controls,
                        barheight: this.options.lightboxbarheight,
                        responsive: this.options.lightboxresponsive,
                        showtitle: this.options.lightboxshowtitle,
                        showdescription: this.options.lightboxshowdescription,
                        shownavigation: this.options.lightboxshownavigation,
                        thumbwidth: this.options.lightboxthumbwidth,
                        thumbheight: this.options.lightboxthumbheight,
                        thumbtopmargin: this.options.lightboxthumbtopmargin,
                        thumbbottommargin: this.options.lightboxthumbbottommargin,
                        titlebottomcss: this.options.lightboxtitlebottomcss,
                        descriptionbottomcss: this.options.lightboxdescriptionbottomcss,
                        fullscreenmode: this.options.lightboxfullscreenmode,
                        closeonoverlay: this.options.lightboxcloseonoverlay,
                        videohidecontrols: this.options.lightboxvideohidecontrols,
                        titlestyle: this.options.lightboxtitlestyle,
                        imagepercentage: this.options.lightboximagepercentage,
                        defaultvideovolume: this.options.lightboxdefaultvideovolume,
                        overlaybgcolor: this.options.lightboxoverlaybgcolor,
                        overlayopacity: this.options.lightboxoverlayopacity,
                        bgcolor: this.options.lightboxbgcolor,
                        titleprefix: this.options.lightboxtitleprefix,
                        titleinsidecss: this.options.lightboxtitleinsidecss,
                        descriptioninsidecss: this.options.lightboxdescriptioninsidecss,
                        autoslide: this.options.lightboxautoslide,
                        slideinterval: this.options.lightboxslideinterval,
                        showtimer: this.options.lightboxshowtimer,
                        timerposition: this.options.lightboxtimerposition,
                        timerheight: this.options.lightboxtimerheight,
                        timercolor: this.options.lightboxtimercolor,
                        timeropacity: this.options.lightboxtimeropacity,
                        showplaybutton: this.options.lightboxshowplaybutton,
                        alwaysshownavarrows: this.options.lightboxalwaysshownavarrows,
                        bordersize: this.options.lightboxbordersize,
                        showtitleprefix: this.options.lightboxshowtitleprefix,
                        borderradius: this.options.lightboxborderradius,
                        showsocial: this.options.lightboxshowsocial,
                        socialposition: this.options.lightboxsocialposition,
                        socialpositionsmallscreen: this.options.lightboxsocialpositionsmallscreen,
                        socialdirection: this.options.lightboxsocialdirection,
                        socialbuttonsize: this.options.lightboxsocialbuttonsize,
                        socialbuttonfontsize: this.options.lightboxsocialbuttonfontsize,
                        socialrotateeffect: this.options.lightboxsocialrotateeffect,
                        showfacebook: this.options.lightboxshowfacebook,
                        showtwitter: this.options.lightboxshowtwitter,
                        showpinterest: this.options.lightboxshowpinterest,
                        html5player: !this.options.forceflash,
                        useflashonie10: this.options.forceflashonie10,
                        useflashonie11: this.options.forceflashonie11,
                        id: this.id
                    };
                    if (P("#wpsliderlightbox_advanced_options").length) P.each(P("#wpsliderlightbox_advanced_options").data(), function(t, i) {
                        e[t.toLowerCase()] = i
                    });
                    if (P("#wpsliderlightbox_advanced_options_" + this.options.sliderid).length) P.each(P("#wpsliderlightbox_advanced_options_" + this.options.sliderid).data(), function(t, i) {
                        e[t.toLowerCase()] = i
                    });
                    this.html5Lightbox = P([]).ashtml5lightbox(e);
                    html5Lightbox = this.html5Lightbox;
                    for (t = 0; t < this.lightboxArray.length; t++) this.html5Lightbox.addItem(this.lightboxArray[t][v], this.lightboxArray[t][k], this.options.lightboxnogroup ? "" : "amazingslider" + this.id, this.lightboxArray[t][s], this.lightboxArray[t][n], this.lightboxArray[t][a], this.lightboxArray[t][r], this.lightboxArray[t][y], this.lightboxArray[t][z], this.lightboxArray[t][I] == C ? 9 : -1);
                    var o = this;
                    this.html5Lightbox.onLightboxClosed = function() {
                        if (o.lightboxPaused) {
                            o.lightboxPaused = false;
                            o.isPaused = false;
                            o.sliderTimeout.resume()
                        }
                    }
                }
            },
            createGoogleFonts: function() {
                this.googleFontsCreated = true;
                if (this.options.previewmode) return;
                if (this.textoptions.addgooglefonts && this.textoptions.googlefonts && this.textoptions.googlefonts.length > 0) {
                    var t = "https://fonts.googleapis.com/css?family=" + this.textoptions.googlefonts;
                    var i = document.createElement("link");
                    i.setAttribute("rel", "stylesheet");
                    i.setAttribute("type", "text/css");
                    i.setAttribute("href", t);
                    i.setAttribute("data-creator", "amazingslidercreator" + this.id);
                    document.getElementsByTagName("head")[0].appendChild(i)
                }
            },
            createRibbon: function() {
                if (!this.options.showribbon || this.options.ribbonimage.length <= 0) return;
                P(".amazingslider-ribbon-" + this.id, this.container).html("<img src='" + this.options.ribbonimage + "' alt='' style='border:none;' />")
            },
            absoluteUrl: function(t) {
                var i = document.createElement("a");
                i.href = t;
                return i.protocol + "//" + i.host + i.pathname + i.search + i.hash
            },
            initSocial: function() {
                if (!this.options.initsocial) return;
                P("head").append('<link rel="stylesheet" href="' + this.options.jsfolder + 'icons/css/fontello.css" type="text/css" />')
            },
            showSocial: function() {
                if (!this.options.showsocial) return;
                var s = this;
                var t = '<div class="amazingslider-social-' + this.id + '" style="display:' + (this.options.socialmode == "mouseover" ? "none" : "block") + ";" + this.options.socialposition + '">';
                var i = (this.options.socialdirection == "horizontal" ? "display:inline-block;" : "display:block;") + "margin:4px;";
                var e = "display:table-cell;width:" + this.options.socialbuttonsize + "px;height:" + this.options.socialbuttonsize + "px;font-size:" + this.options.socialbuttonfontsize + "px;border-radius:50%;color:#fff;vertical-align:middle;text-align:center;cursor:pointer;padding:0;";
                if (this.options.showfacebook) t += '<div class="amazingslider-social-btn' + (this.options.socialrotateeffect ? " amazingslider-rotate" : "") + ' amazingslider-social-facebook" style="' + i + '"><div class="mh-icon-facebook" style="' + e + 'background-color:#3b5998;"></div></div>';
                if (this.options.showtwitter) t += '<div class="amazingslider-social-btn' + (this.options.socialrotateeffect ? " amazingslider-rotate" : "") + ' amazingslider-social-twitter" style="' + i + '"><div class="mh-icon-twitter" style="' + e + 'background-color:#03b3ee;"></div></div>';
                if (this.options.showpinterest) t += '<div class="amazingslider-social-btn' + (this.options.socialrotateeffect ? " amazingslider-rotate" : "") + ' amazingslider-social-pinterest" style="' + i + '"><div class="mh-icon-pinterest" style="' + e + 'background-color:#c92228;"></div></div>';
                t += '<div style="clear:both;"></div></div>';
                P(".amazingslider-wrapper-" + this.id, this.container).append(t);
                if (this.options.socialmode == "mouseover") P(".amazingslider-wrapper-" + this.id, this.container).hover(function() {
                    clearTimeout(s.socialTimeout);
                    P(".amazingslider-social-" + s.id, s.container).fadeIn()
                }, function() {
                    s.socialTimeout = setTimeout(function() {
                        P(".amazingslider-social-" + s.id, s.container).fadeOut()
                    }, s.options.arrowhideonmouseleave)
                });
                P(".amazingslider-social-btn", this.container).click(function() {
                    var t = window.location.href + (window.location.href.indexOf("?") < 0 ? "?" : "&") + "slidershareid=" + s.elemArray[s.curElem][c];
                    var i = s.elemArray[s.curElem][k];
                    var e = s.absoluteUrl(s.elemArray[s.curElem][m]);
                    var o = s.elemArray[s.curElem][x].length > 0;
                    if (P(this).hasClass("amazingslider-social-facebook")) window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(t) + "&t=" + encodeURIComponent(i), "_blank");
                    else if (P(this).hasClass("amazingslider-social-twitter")) window.open("https://twitter.com/share?url=" + encodeURIComponent(t) + "&text=" + encodeURIComponent(i), "_blank");
                    else if (P(this).hasClass("amazingslider-social-pinterest")) window.open("https://pinterest.com/pin/create/bookmarklet/?media=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(t) + "&description=" + encodeURIComponent(i) + "&is_video=" + (o ? "true" : "false"), "_blank");
                    return false
                })
            },
            initVideoApi: function() {
                var t, i, e;
                var o = false,
                    s = false;
                for (t = 0; t < this.elemArray.length; t++) {
                    e = this.elemArray[t][x];
                    for (i = 0; i < e.length; i++)
                        if (e[i].type == f) o = true;
                        else if (e[i].type == $) s = true
                }
                if (o) {
                    var n = document.createElement("script");
                    n.src = "https://www.youtube.com/iframe_api";
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(n, a)
                }
                if (s) {
                    var n = document.createElement("script");
                    n.src = this.options.jsfolder + "froogaloop2.min.js";
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(n, a)
                }
            },
            createSliderTimeout: function() {
                var i = this;
                this.sliderTimeout = new L(this.options.slideinterval, function() {
                    i.slideRun(-1)
                }, this.options.showtimer ? function(t) {
                    i.updateTimer(t)
                } : null);
                if (i.options.pauseonmouseover) P(".amazingslider-slider-" + this.id, this.container).hover(function() {
                    if (!i.isPaused) {
                        i.sliderTimeout.pause();
                        i.isPausedOnMouseover = true
                    }
                }, function() {
                    if (!i.isPaused) {
                        i.sliderTimeout.resume(false);
                        i.isPausedOnMouseover = false
                    }
                });
                if (i.options.showtimer) P(".amazingslider-timer-" + i.id, i.container).css({
                    display: "block",
                    position: "absolute",
                    left: "0px",
                    top: i.options.timerposition == "bottom" ? "" : "0px",
                    bottom: i.options.timerposition == "bottom" ? "0px" : "",
                    width: "0%",
                    height: i.options.timerheight + "px",
                    "background-color": i.options.timercolor,
                    opacity: i.options.timeropacity,
                    filter: "alpha(opacity=" + Math.round(100 * i.options.timeropacity) + ")"
                })
            },
            updateTimer: function(t) {
                w = Math.round(t * 100);
                if (w > 100) w = 100;
                if (w < 0) w = 0;
                P(".amazingslider-timer-" + this.id, this.container).css({
                    width: w + "%"
                })
            },
            createMarkup: function() {
                this.$zoom = P("" + '<div id="zoom-modal" class="thin-scrollbar" onclick="document.getElementById(\'zoom-modal\').style.display = \'none\'; /*enableScroll();*/ document.body.style.overflow = null; document.body.style.paddingRight = null;"' + '   style="display:none; position: fixed; z-index: 2000; left:0; top: 0; width: 100%; height: 100%; overflow: scroll; background-color: #FFF;">' + '<div id="zoom-modal-content"' + '     style="margin: 40px auto; padding: 10px; width: 96%; max-width: 1600px; border: 0px;">' + "<span class=\"zoom-close\" onclick=\"document.getElementById('zoom-modal').style.display = 'none'; /*enableScroll();*/\"" + '      style="width: 20px; color: #000; position: fixed; cursor: pointer; top: 6px; right: 10px;">' + '<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>' + "</span>" + '<div id="zoom-pic" style="margin:auto; cursor: zoom-out;">' + '<img style="width: 100%" src="">' + '<video style="display: none;" muted="" playsinline="" autoplay="" loop="" type="video/mp4" width="100%" src=""></video>' + "</div>" + "</div>" + "</div>");
                this.$zoom.appendTo(this.container.closest("section"));
                this.$wrapper = P("" + "<div class='amazingslider-wrapper-" + this.id + "'>" + "<div class='amazingslider-background-image-" + this.id + "'></div>" + (this.options.navposition == "left" || this.options.navposition == "top" ? "<div class='amazingslider-nav-" + this.id + "'><div class='amazingslider-nav-container-" + this.id + "'></div></div>" : "") + "<div class='amazingslider-slider-" + this.id + "'>" + "<div class='amazingslider-bottom-shadow-" + this.id + "'></div>" + "<div class='amazingslider-box-" + this.id + "'>" + "<div class='amazingslider-swipe-box-" + this.id + "'>" + "<div class='amazingslider-space-" + this.id + "'></div>" + "<div class='amazingslider-img-box-" + this.id + "'></div>" + "<div class='amazingslider-lightbox-play-" + this.id + "'></div>" + "<div class='amazingslider-timer-" + this.id + "'></div>" + "</div>" + "<div class='amazingslider-text-box-" + this.id + "'></div>" + "</div>" + "<div class='amazingslider-play-" + this.id + "'></div>" + "<div class='amazingslider-video-wrapper-" + this.id + "'></div>" + "<div class='amazingslider-ribbon-" + this.id + "'></div>" + "<div class='as-slide-arrow amazingslider-arrow-left-" + this.id + "'>" + (this.options.arrowimagesvg ? this.options.arrowimagesvg : "") + "</div>" + "<div class='as-slide-arrow amazingslider-arrow-right-" + this.id + "'>" + (this.options.arrowimagesvg ? this.options.arrowimagesvg : "") + "</div>" + "</div>" + (this.options.navposition == "right" || this.options.navposition == "bottom" ? "<div class='amazingslider-nav-" + this.id + "'><div class='amazingslider-nav-container-" + this.id + "'></div></div>" : "") + "</div>");
                this.$wrapper.appendTo(this.container);
                P(".amazingslider-slider-" + this.id, this.container).data("sliderid", this.id);
                var t = this;
                if (this.options.enabletouchswipe) {
                    var i = this.options.swipeonimageonly ? P(".amazingslider-swipe-box-" + this.id, this.container) : P(".amazingslider-box-" + this.id, this.container);
                    i.sliderTouchSwipe({
                        preventWebBrowser: false,
                        swipeLeft: function() {
                            t.container.trigger("amazingslider.touchswipe", [t.curElem, -1]);
                            t.videoAutoplayMode = false;
                            t.slideRun(-1)
                        },
                        swipeRight: function() {
                            t.container.trigger("amazingslider.touchswipe", [t.curElem, -2]);
                            t.videoAutoplayMode = false;
                            t.slideRun(-2)
                        }
                    })
                }
                P(".amazingslider-play-" + this.id, this.container).click(function() {
                    t.videoAutoplayMode = false;
                    t.playVideo(true)
                })
            },
            playVideo: function(t) {
                var i = this.elemArray[this.curElem][x];
                if (i.length <= 0) return;
                P(".amazingslider-img-" + this.id, this.container).empty();
                this.sliderTimeout.stop();
                this.videoPaused = true;
                var e = false;
                var o = false;
                if (t && this.options.playmutedandinlinewhenautoplay && this.videoAutoplayMode) {
                    e = true;
                    o = true
                }
                var s = i[0].href;
                var n = i[0].type;
                if (n == f) this.playYoutubeVideo(s, t, e, o);
                else if (n == $) this.playVimeoVideo(s, t, e, o);
                else if (n == T) {
                    var a = i.length > 1 ? i[1].href : "";
                    this.playMp4Video(s, a, t, e, o, this.options.loopvideo)
                } else if (n == C) this.playIframeVideo(s, t)
            },
            playMp4Video: function(t, i, e, o, s, n) {
                var a = P(".amazingslider-video-wrapper-" + this.id, this.container);
                a.css({
                    display: "block",
                    width: "100%",
                    height: "100%"
                });
                var r = true;
                if (this.options.forceflash && az_.flashInstalled()) r = false;
                if (!az_.html5VideoSupported()) r = false;
                if (az_.isIE6789()) r = false;
                if (az_.isFirefox() || az_.isOpera())
                    if (!az_.canPlayMP4() && !i) r = false;
                if (az_.isIE10() && this.options.forceflashonie10 || az_.isIE11() && this.options.forceflashonie11) r = false;
                if (az_.isQt()) r = true;
                if (r) {
                    var l = t;
                    if (az_.isFirefox() || az_.isOpera())
                        if (i) l = i;
                    this.embedHTML5Video(a, l, e, o, s, n)
                } else {
                    var h = t;
                    if (h.charAt(0) != "/" && h.substring(0, 5) != "http:" && h.substring(0, 6) != "https:") h = this.options.htmlfolder + h;
                    this.embedFlash(a, "100%", "100%", this.options.jsfolder + "html5boxplayer.swf", "transparent", {
                        width: "100%",
                        height: "100%",
                        jsobjectname: "amazingsliderObjects",
                        hidecontrols: this.options.videohidecontrols ? "1" : "0",
                        hideplaybutton: this.options.videohideplaybutton ? "1" : "0",
                        videofile: h,
                        hdfile: "",
                        ishd: "0",
                        autoplay: e ? "1" : "0",
                        errorcss: ".amazingslider-error" + this.options.errorcss,
                        id: this.id
                    })
                }
            },
            embedHTML5Video: function(t, i, e, o, s, n) {
                if (this.options.savevolumetocookie) {
                    var a = document.cookie ? document.cookie.split(";") : [];
                    for (var r in a) {
                        var l = P.trim(a[r]).split("=");
                        if (l.length && l[0] == "amazingslidervideovolume") {
                            this.options.defaultvideovolume = l[1];
                            break
                        }
                    }
                }
                if (az_.isFirefox() && this.options.nativecontrolsonfirefox || (az_.isIE6789() || az_.isIE10() || az_.isIE11()) && this.options.nativecontrolsonie || az_.isIPhone() && this.options.nativecontrolsoniphone || az_.isIPad() && this.options.nativecontrolsonipad || az_.isAndroid() && this.options.nativecontrolsonandroid) this.options.nativehtml5controls = true;
                if (az_.isIOS() || az_.isAndroid()) this.options.nativecontrolsonfullscreen = true;
                t.html("<div class='amazingslider-video-container-" + this.id + "' style='position:relative;display:block;width:100%;height:100%;'>" + "<video class='slider-inline-video' style='width:100%;height:100%;'" + (this.options.nativehtml5controls && !this.options.videohidecontrols ? " controls='controls'" : "") + (this.options.nativecontrolsnodownload ? " controlsList='nodownload'" : "") + (o ? " muted" : "") + (n ? " loop" : "") + (s ? " playsinline" : "") + "></div>");
                P("video", t).get(0).setAttribute("src", i);
                if (e) P("video", t).get(0).play();
                if (!this.options.nativehtml5controls && !this.options.videohidecontrols) {
                    P("video", t).data("src", i);
                    P("video", t).asHTML5VideoControls(this.options.skinsfolder, this, ".slider-inline-video", this.options.videohidecontrols, this.options.videohideplaybutton, o ? 0 : this.options.defaultvideovolume, this.options.nativecontrolsonfullscreen, this.options.nativecontrolsnodownload, null)
                }
                var h = this;
                P("video", t).off("ended").on("ended", function() {
                    h.videoPaused = false;
                    if (!h.isPaused) h.slideRun(-1, true)
                });
                P("video", t).get(0).onvolumechange = function() {
                    if (!this.muted && this.volume > 0) h.videoAutoplayMode = false
                }
            },
            embedFlash: function(t, i, e, o, s, n) {
                if (az_.flashInstalled()) {
                    var a = {
                        pluginspage: "http://www.adobe.com/go/getflashplayer",
                        quality: "high",
                        allowFullScreen: "true",
                        allowScriptAccess: "always",
                        type: "application/x-shockwave-flash"
                    };
                    a.width = i;
                    a.height = e;
                    a.src = o;
                    a.wmode = s;
                    a.flashVars = P.param(n);
                    var r = "";
                    for (var l in a) r += l + "=" + a[l] + " ";
                    t.html("<embed " + r + "/>")
                } else t.html("<div class='amazingslider-error-" + this.id + "' style='display:block; position:absolute; text-align:center; width:" + this.options.width + "px; left:0px; top:" + Math.round(this.options.height / 2 - 10) + "px;'><div>The required Adobe Flash Player plugin is not installed</div><br /><div style='display:block;position:relative;text-align:center;width:112px;height:33px;margin:0px auto;'><a href='http://www.adobe.com/go/getflashplayer'><img src='https://www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash player' width='112' height='33'></img></a></div>")
            },
            playVimeoVideo: function(t, i, e, o) {
                var s = P(".amazingslider-video-wrapper-" + this.id, this.container);
                s.css({
                    display: "block",
                    width: "100%",
                    height: "100%"
                });
                if (this.options.previewmode) {
                    s.html("<div class='amazingslider-error-" + this.id + "'>To view Vimeo video, publish the slider then open it in your web browser</div>");
                    return
                } else {
                    var n = t + (t.indexOf("?") < 0 ? "?" : "&") + "autoplay=" + (i && !az_.isAndroid() ? "1" : "0") + (e ? "&muted=1" : "") + (o ? "&playsinline=1" : "") + "&api=1&player_id=amazingslider_vimeo_" + this.id;
                    s.html("<iframe id='amazingslider_vimeo_" + this.id + "' width='" + this.options.width + "' height='" + this.options.height + "' src='" + n + "' frameborder='0' allow='autoplay' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>");
                    this.playVimeoAPICallback()
                }
            },
            playVimeoAPICallback: function() {
                var i = this;
                if (typeof $f === "function") {
                    var t = P("#amazingslider_vimeo_" + this.id)[0];
                    var e = $f(t);
                    e.addEvent("ready", function() {
                        e.addEvent("finish", function(t) {
                            i.videoPaused = false;
                            if (!i.isPaused) i.slideRun(-1, true)
                        });
                        e.addEvent("volumechange", function(t) {
                            i.videoAutoplayMode = false
                        })
                    })
                } else setTimeout(function() {
                    if (i.vimeoAPILoadCount < 10) {
                        i.vimeoAPILoadCount++;
                        i.playVimeoAPICallback()
                    }
                }, 300)
            },
            playIframeVideo: function(t, i) {
                var e = P(".amazingslider-video-wrapper-" + this.id, this.container);
                e.css({
                    display: "block",
                    width: "100%",
                    height: "100%"
                });
                if (this.options.previewmode) {
                    e.html("<div class='amazingslider-error-" + this.id + "'>To view the video, publish the slider then open it in your web browser</div>");
                    return
                } else {
                    var o = t;
                    e.html("<iframe id='amazingslider_iframevideo_" + this.id + "' width='" + this.options.width + "' height='" + this.options.height + "' src='" + o + "' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>")
                }
            },
            getYoutubeParams: function(t) {
                var i = {};
                if (t.indexOf("?") < 0) return i;
                var e = t.substring(t.indexOf("?") + 1).split("&");
                for (var o = 0; o < e.length; o++) {
                    var s = e[o].split("=");
                    if (s && s.length == 2 && s[0].toLowerCase() != "v") i[s[0].toLowerCase()] = s[1]
                }
                return i
            },
            playYoutubeVideo: function(t, i, e, o) {
                var s = P(".amazingslider-video-wrapper-" + this.id, this.container);
                s.css({
                    display: "block",
                    width: "100%",
                    height: "100%"
                });
                if (this.options.previewmode) {
                    s.html("<div class='amazingslider-error-" + this.id + "'>To view YouTube video, publish the slider then open it in your web browser</div>");
                    return
                }
                var n = this;
                if (!D) {
                    j += 100;
                    if (j < 3e3) {
                        setTimeout(function() {
                            n.playYoutubeVideo(t, i, e, o)
                        }, 100);
                        return
                    }
                }
                if (D) {
                    s.html("<div id='amazingslider-video-" + this.id + "' style='display:block;'></div>");
                    var a = this.getYoutubeParams(t);
                    a = P.extend({}, a, {
                        html5: 1,
                        autoplay: 1,
                        rel: 0,
                        autohide: 1,
                        wmode: "transparent"
                    });
                    if (n.options.videohidecontrols) a = P.extend({}, a, {
                        controls: 0,
                        showinfo: 0
                    });
                    if (e) a["mute"] = 1;
                    if (o) a["playsinline"] = 1;
                    var r = t.match(/(\?v=|\/\d\/|\/embed\/|\/v\/|\.be\/)([a-zA-Z0-9\-\_]+)/)[2];
                    new YT.Player("amazingslider-video-" + this.id, {
                        width: n.options.width,
                        height: n.options.height,
                        videoId: r,
                        playerVars: a,
                        events: {
                            onVolumeChange: function(t) {
                                if (!t.target.isMuted() && t.target.getVolume() > 0) n.videoAutoplayMode = false
                            },
                            onReady: function(t) {
                                t.target.playVideo()
                            },
                            onStateChange: function(t) {
                                if (t.data == YT.PlayerState.ENDED) {
                                    n.videoPaused = false;
                                    if (!n.isPaused) n.slideRun(-1, true)
                                }
                            }
                        }
                    })
                } else {
                    var l = t + (t.indexOf("?") < 0 ? "?" : "&") + "autoplay=1&wmode=transparent&rel=0&autohide=1";
                    if (n.options.videohidecontrols) l += "&controls=0&showinfo=0";
                    if (e) l += "&mute=1";
                    if (o) l += "&playsinline=1";
                    s.html("<iframe width='" + n.options.width + "' height='" + n.options.height + "' src='" + l + "' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>")
                }
            },
            checkVideoType: function(t) {
                if (!t) return -1;
                if (t.match(/\.(flv)(.*)?$/i)) return p;
                if (t.match(/\.(mp4|m4v)(.*)?$/i)) return T;
                if (t.match(/\.(ogv|ogg)(.*)?$/i)) return d;
                if (t.match(/\.(webm)(.*)?$/i)) return S;
                if (t.match(/\:\/\/.*(youtube\.com)/i) || t.match(/\:\/\/.*(youtu\.be)/i)) return f;
                if (t.match(/\:\/\/.*(vimeo\.com)/i)) return $;
                return 0
            },
            showTexteffect: function(t) {
                var i = P(this).data("sliderid");
                P(".amazingslider-text-box-" + i, this).fadeIn()
            },
            hideTexteffect: function(t) {
                var i = P(this).data("sliderid");
                P(".amazingslider-text-box-" + i, this).fadeOut()
            },
            createText: function() {
                if (!this.options.showtext || this.textoptions.textstyle == "none") return;
                var y = this;
                this.container.on("amazingslider.switchtext", function(t, i, g) {
                    P("head").find("style").each(function() {
                        if (P(this).data("creator") == "amazingslidercreator" + y.id && P(this).data("csstype") == "texteffect") P(this).remove()
                    });
                    var e = "<style type='text/css' data-creator='amazingslidercreator" + y.id + "' data-csstype='texteffect'>" + ".amazingslider-text-" + y.id + " {" + y.textoptions.textcss + "} " + ".amazingslider-text-bg-" + y.id + " {" + y.textoptions.textbgcss + "} " + ".amazingslider-title-" + y.id + " {" + y.textoptions.titlecss + "} " + ".amazingslider-description-" + y.id + " {" + y.textoptions.descriptioncss + "} " + ".amazingslider-button-" + y.id + " {" + y.textoptions.buttoncss + "} ";
                    if (y.textoptions.texteffectresponsive) e += "@media (max-width: " + y.textoptions.texteffectresponsivesize + "px) {" + ".amazingslider-title-" + y.id + " {" + y.textoptions.titlecssresponsive + "} " + ".amazingslider-description-" + y.id + " {" + y.textoptions.descriptioncssresponsive + "} " + ".amazingslider-button-" + y.id + " {" + y.textoptions.buttoncssresponsive + "} " + "} ";
                    e += "</style>";
                    P("head").append(e);
                    var o = P(".amazingslider-text-box-" + y.id, y.container);
                    o.html("<div class='amazingslider-text-wrapper-" + y.id + "'></div>");
                    P(".amazingslider-slider-" + y.id, y.container).off("mouseenter", y.showTexteffect).off("mouseleave", y.hideTexteffect);
                    var f = P(".amazingslider-text-wrapper-" + y.id, y.container);
                    var s = y.options.outputtext ? y.options.titletag : "div";
                    var n = y.options.outputtext ? y.options.descriptiontag : "div";
                    if (y.textoptions.textstyle == "static") {
                        f.html("<div class='amazingslider-text-" + y.id + "'>" + "<div class='amazingslider-text-bg-" + y.id + "'></div>" + "<" + s + " class='amazingslider-title-" + y.id + "'></" + s + ">" + "<" + n + " class='amazingslider-description-" + y.id + "'></" + n + ">" + "<div class='amazingslider-button-" + y.id + "'></div>" + "</div>");
                        if (!y.textoptions.textautohide) o.css({
                            display: "block"
                        });
                        else if (y.prevtextstyle != "static") o.css({
                            display: y.textoptions.textautohide ? "none" : "block"
                        });
                        if (y.textoptions.textautohide) P(".amazingslider-slider-" + y.id, y.container).hover(y.showTexteffect, y.hideTexteffect);
                        switch (y.textoptions.textpositionstatic) {
                            case "top":
                                f.css({
                                    width: "100%",
                                    height: "auto",
                                    position: "absolute",
                                    left: "0px",
                                    top: "0px",
                                    "margin-top": y.textoptions.textpositionmarginstatic + "px"
                                });
                                break;
                            case "bottom":
                                f.css({
                                    width: "100%",
                                    height: "auto",
                                    position: "absolute",
                                    left: "0px",
                                    bottom: "0px",
                                    "margin-bottom": y.textoptions.textpositionmarginstatic + "px"
                                });
                                break;
                            case "left":
                                f.css({
                                    width: y.textoptions.textleftrightpercentforstatic + "%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0px",
                                    top: "0px",
                                    margin: y.textoptions.textpositionmarginstatic + "px"
                                });
                                break;
                            case "right":
                                f.css({
                                    width: y.textoptions.textleftrightpercentforstatic + "%",
                                    height: "100%",
                                    position: "absolute",
                                    right: "0px",
                                    top: "0px",
                                    margin: y.textoptions.textpositionmarginstatic + "px"
                                });
                                break;
                            case "topoutside":
                                f.css({
                                    width: "100%",
                                    height: "auto",
                                    position: "absolute",
                                    left: "0px",
                                    bottom: "100%",
                                    "margin-bottom": y.textoptions.textpositionmarginstatic + "px"
                                });
                                break;
                            case "bottomoutside":
                                f.css({
                                    width: "100%",
                                    height: "auto",
                                    position: "absolute",
                                    left: "0px",
                                    top: "100%",
                                    "margin-top": y.textoptions.textpositionmarginstatic + "px"
                                });
                                break
                        }
                    } else {
                        o.css({
                            display: "block"
                        });
                        f.html("<div class='amazingslider-text-holding-" + y.id + "' style='visibility:hidden;" + y.textoptions.textcss + "'>" + "<div class='amazingslider-text-bg-" + y.id + "'></div>" + "<" + s + " class='amazingslider-title-" + y.id + "'></" + s + ">" + "<" + n + " class='amazingslider-description-" + y.id + "'></" + n + ">" + "<div class='amazingslider-button-" + y.id + "'></div>" + "</div>" + "<div class='amazingslider-text-" + y.id + "' style='position:absolute;top:0%;left:0%;" + (az_.isIE678() ? "opacity:inherit;filter:inherit;" : "") + "'>" + "<div class='amazingslider-text-bg-" + y.id + "'></div>" + "<" + s + " class='amazingslider-title-" + y.id + "'></" + s + ">" + "<" + n + " class='amazingslider-description-" + y.id + "'></" + n + ">" + "<div class='amazingslider-button-" + y.id + "'></div>" + "</div>");
                        f.css({
                            display: "none",
                            position: "absolute"
                        })
                    }
                    y.prevtextstyle = y.textoptions.textstyle;
                    var a = P(".amazingslider-text-bg-" + y.id, y.container);
                    var v = P(".amazingslider-text-" + y.id, y.container);
                    var b = P(".amazingslider-title-" + y.id, y.container);
                    var w = P(".amazingslider-description-" + y.id, y.container);
                    var x = P(".amazingslider-button-" + y.id, y.container);
                    if (y.textoptions.textstyle == "static") {
                        b.html(y.elemArray[g][k]);
                        if (y.elemArray[g][z].length > 0) w.html(y.elemArray[g][z]).css({
                            display: "block"
                        });
                        else w.css({
                            display: "none"
                        }).html("");
                        if (y.elemArray[g][E].length > 0) x.html(y.elemArray[g][E]).css({
                            display: "block"
                        });
                        else x.css({
                            display: "none"
                        }).html("");
                        if (!y.elemArray[g][k] && !y.elemArray[g][z] && !y.elemArray[g][E]) a.hide();
                        else a.show()
                    } else if (y.textoptions.textstyle == "dynamic")
                        if (!y.elemArray[g][k] && !y.elemArray[g][z] && !y.elemArray[g][E]) f.fadeOut();
                        else f.fadeOut(function() {
                            b.html(y.elemArray[g][k]);
                            if (y.elemArray[g][z].length > 0) w.html(y.elemArray[g][z]).css({
                                display: "block"
                            });
                            else w.css({
                                display: "none"
                            }).html("");
                            if (y.elemArray[g][E].length > 0) x.html(y.elemArray[g][E]).css({
                                display: "block"
                            });
                            else x.css({
                                display: "none"
                            }).html("");
                            var t = "bottomleft";
                            var i = y.textoptions.textpositiondynamic;
                            if (i) {
                                i = i.split(",");
                                t = i[Math.floor(Math.random() * i.length)];
                                t = P.trim(t.toLowerCase())
                            }
                            switch (t) {
                                case "topleft":
                                    f.css({
                                        left: "0px",
                                        right: "",
                                        top: "0px",
                                        bottom: ""
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmargintop + "px " + y.textoptions.textpositionmarginleft + "px"
                                    });
                                    break;
                                case "topright":
                                    f.css({
                                        left: "",
                                        right: "0px",
                                        top: "0px",
                                        bottom: ""
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmargintop + "px " + y.textoptions.textpositionmarginright + "px"
                                    });
                                    break;
                                case "bottomleft":
                                    f.css({
                                        left: "0px",
                                        right: "",
                                        top: "",
                                        bottom: "0px"
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmarginbottom + "px " + y.textoptions.textpositionmarginleft + "px"
                                    });
                                    break;
                                case "bottomright":
                                    f.css({
                                        left: "",
                                        right: "0px",
                                        top: "",
                                        bottom: "0px"
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmarginbottom + "px " + y.textoptions.textpositionmarginright + "px"
                                    });
                                    break;
                                case "topcenter":
                                    v.css({
                                        left: "0px",
                                        right: "0px"
                                    });
                                    f.css({
                                        left: "0px",
                                        right: "0px",
                                        top: "0px",
                                        bottom: ""
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmargintop + "px " + y.textoptions.textpositionmarginleft + "px"
                                    });
                                    break;
                                case "bottomcenter":
                                    v.css({
                                        left: "0px",
                                        right: "0px"
                                    });
                                    f.css({
                                        left: "0px",
                                        right: "0px",
                                        top: "",
                                        bottom: "0px"
                                    });
                                    f.css({
                                        margin: y.textoptions.textpositionmarginbottom + "px " + y.textoptions.textpositionmarginleft + "px"
                                    });
                                    break;
                                case "centercenter":
                                    v.css({
                                        left: "0px",
                                        right: "0px"
                                    });
                                    f.css({
                                        left: "0px",
                                        right: "0px",
                                        top: "50%",
                                        bottom: "",
                                        margin: 0
                                    });
                                    f.css({
                                        transform: "translateY(-50%)"
                                    });
                                    break;
                                case "centerleft":
                                    v.css({
                                        left: "0px",
                                        right: ""
                                    });
                                    f.css({
                                        left: "0px",
                                        right: "",
                                        top: "50%",
                                        bottom: "",
                                        margin: 0
                                    });
                                    f.css({
                                        transform: "translateY(-50%)"
                                    });
                                    break;
                                case "centerright":
                                    v.css({
                                        left: "",
                                        right: "0px"
                                    });
                                    f.css({
                                        left: "",
                                        right: "0px",
                                        top: "50%",
                                        bottom: "",
                                        margin: 0
                                    });
                                    f.css({
                                        transform: "translateY(-50%)"
                                    });
                                    break
                            }
                            var e = ["left", "right", "top", "bottom"];
                            var o = null;
                            var s = y.textoptions.texteffect;
                            if (s) {
                                s = s.split(",");
                                o = s[Math.floor(Math.random() * s.length)];
                                o = P.trim(o.toLowerCase())
                            }
                            var n = y.textoptions.texteffectseparate ? P(".amazingslider-title-" + y.id, y.container) : P(".amazingslider-text-" + y.id, y.container);
                            switch (o) {
                                case "fade":
                                    n.css({
                                        opacity: 0
                                    });
                                    n.delay(y.textoptions.texteffectdelay).fadeTo(y.textoptions.texteffectduration, 1);
                                    break;
                                case "slide":
                                    var a = y.textoptions.texteffectslidedirection;
                                    if (a == "random") a = e[Math.floor(Math.random() * e.length)];
                                    if (a == "left") {
                                        n.css({
                                            left: "-" + y.textoptions.texteffectslidedistance + "px",
                                            opacity: 0
                                        });
                                        n.delay(y.textoptions.texteffectdelay).animate({
                                            left: "0px",
                                            opacity: 1
                                        }, y.textoptions.texteffectduration, y.textoptions.texteffecteasing)
                                    } else if (a == "right") {
                                        n.css({
                                            left: y.textoptions.texteffectslidedistance + "px",
                                            opacity: 0
                                        });
                                        n.delay(y.textoptions.texteffectdelay).animate({
                                            left: "0px",
                                            opacity: 1
                                        }, y.textoptions.texteffectduration, y.textoptions.texteffecteasing)
                                    } else if (a == "top") {
                                        n.css({
                                            top: "-" + y.textoptions.texteffectslidedistance + "px",
                                            opacity: 0
                                        });
                                        n.delay(y.textoptions.texteffectdelay).animate({
                                            top: "0px",
                                            opacity: 1
                                        }, y.textoptions.texteffectduration, y.textoptions.texteffecteasing)
                                    } else if (a == "bottom") {
                                        n.css({
                                            top: y.textoptions.texteffectslidedistance + "px",
                                            opacity: 0
                                        });
                                        n.delay(y.textoptions.texteffectdelay).animate({
                                            top: "0px",
                                            opacity: 1
                                        }, y.textoptions.texteffectduration, y.textoptions.texteffecteasing)
                                    }
                                    break;
                                default:
                                    n.delay(y.textoptions.texteffectdelay).show()
                            }
                            if (y.textoptions.texteffectseparate && y.elemArray[g][z].length > 0) {
                                var r = null;
                                var l = y.textoptions.texteffect1;
                                if (l) {
                                    l = l.split(",");
                                    r = l[Math.floor(Math.random() * l.length)];
                                    r = P.trim(r.toLowerCase())
                                }
                                var h = P(".amazingslider-description-" + y.id, y.container);
                                switch (r) {
                                    case "fade":
                                        h.css({
                                            opacity: 0
                                        });
                                        h.delay(y.textoptions.texteffectdelay1).fadeTo(y.textoptions.texteffectduration1, 1);
                                        break;
                                    case "slide":
                                        var p = y.textoptions.texteffectslidedirection1;
                                        if (p == "random") p = e[Math.floor(Math.random() * e.length)];
                                        if (p == "left") {
                                            h.css({
                                                left: "-" + y.textoptions.texteffectslidedistance1 + "px",
                                                opacity: 0
                                            });
                                            h.delay(y.textoptions.texteffectdelay1).animate({
                                                left: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration1, y.textoptions.texteffecteasing1)
                                        } else if (p == "right") {
                                            h.css({
                                                left: y.textoptions.texteffectslidedistance1 + "px",
                                                opacity: 0
                                            });
                                            h.delay(y.textoptions.texteffectdelay1).animate({
                                                left: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration1, y.textoptions.texteffecteasing1)
                                        } else if (p == "top") {
                                            h.css({
                                                top: "-" + y.textoptions.texteffectslidedistance1 + "px",
                                                opacity: 0
                                            });
                                            h.delay(y.textoptions.texteffectdelay1).animate({
                                                top: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration1, y.textoptions.texteffecteasing1)
                                        } else if (p == "bottom") {
                                            h.css({
                                                top: y.textoptions.texteffectslidedistance1 + "px",
                                                opacity: 0
                                            });
                                            h.delay(y.textoptions.texteffectdelay1).animate({
                                                top: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration1, y.textoptions.texteffecteasing1)
                                        }
                                        break;
                                    default:
                                        h.delay(y.textoptions.texteffectdelay).show()
                                }
                            }
                            if (y.textoptions.texteffectseparate && y.elemArray[g][E].length > 0) {
                                var d = null;
                                var c = y.textoptions.texteffect2;
                                if (c) {
                                    c = c.split(",");
                                    d = c[Math.floor(Math.random() * c.length)];
                                    d = P.trim(d.toLowerCase())
                                }
                                var m = P(".amazingslider-button-" + y.id, y.container);
                                switch (d) {
                                    case "fade":
                                        m.css({
                                            opacity: 0
                                        });
                                        m.delay(y.textoptions.texteffectdelay2).fadeTo(y.textoptions.texteffectduration2, 1);
                                        break;
                                    case "slide":
                                        var u = y.textoptions.texteffectslidedirection2;
                                        if (u == "random") u = e[Math.floor(Math.random() * e.length)];
                                        if (u == "left") {
                                            m.css({
                                                left: "-" + y.textoptions.texteffectslidedistance2 + "px",
                                                opacity: 0
                                            });
                                            m.delay(y.textoptions.texteffectdelay2).animate({
                                                left: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration2, y.textoptions.texteffecteasing2)
                                        } else if (u == "right") {
                                            m.css({
                                                left: y.textoptions.texteffectslidedistance2 + "px",
                                                opacity: 0
                                            });
                                            m.delay(y.textoptions.texteffectdelay2).animate({
                                                left: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration2, y.textoptions.texteffecteasing2)
                                        } else if (u == "top") {
                                            m.css({
                                                top: "-" + y.textoptions.texteffectslidedistance2 + "px",
                                                opacity: 0
                                            });
                                            m.delay(y.textoptions.texteffectdelay2).animate({
                                                top: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration2, y.textoptions.texteffecteasing2)
                                        } else if (u == "bottom") {
                                            m.css({
                                                top: y.textoptions.texteffectslidedistance2 + "px",
                                                opacity: 0
                                            });
                                            m.delay(y.textoptions.texteffectdelay2).animate({
                                                top: "0px",
                                                opacity: 1
                                            }, y.textoptions.texteffectduration2, y.textoptions.texteffecteasing2)
                                        }
                                        break;
                                    default:
                                        m.delay(y.textoptions.texteffectdelay).show()
                                }
                            }
                            f.show()
                        });
                    if (!y.googleFontsCreated) y.createGoogleFonts()
                })
            },
            resizeFullscreenImage: function(t) {
                if (t.data("originalwidth") <= 0 || t.data("originalheight") <= 0) return;
                var i = t.data("originalheight") / t.data("originalwidth");
                var e = this.options.height / this.options.width;
                this.prevImageMarginTop = this.curImageMarginTop;
                this.prevImageMarginLeft = this.curImageMarginLeft;
                this.prevImageMaxWidth = this.curImageMaxWidth;
                this.curImageMarginTop = 0;
                this.curImageMarginLeft = 0;
                this.curImageMaxWidth = 100;
                if (e < i)
                    if (this.options.scalemode == "fit") {
                        this.curImageMaxWidth = e / i * 100;
                        this.curImageMarginLeft = 50 - this.curImageMaxWidth / 2
                    } else this.curImageMarginTop = -1 * (i - e) * 50;
                else if (this.options.scalemode == "fit") this.curImageMarginTop = (e - i) * 50;
                else {
                    this.curImageMarginLeft = (1 / e - 1 / i) * e * 50;
                    this.curImageMaxWidth = 100 - 2 * this.curImageMarginLeft
                }
                if (Math.abs(this.curImageMarginLeft) > 0) t.css({
                    "max-width": this.curImageMaxWidth + "%",
                    width: this.curImageMaxWidth + "%",
                    height: "100%",
                    "margin-left": this.curImageMarginLeft + "%",
                    "margin-top": 0
                });
                else t.css({
                    "max-width": this.curImageMaxWidth + "%",
                    width: this.curImageMaxWidth + "%",
                    height: "auto",
                    "margin-left": 0,
                    "margin-top": this.curImageMarginTop + "%"
                })
            },
            resizeSlider: function() {
                if (!this.container.parent() || !this.container.parent().width()) return;
                if (this.options.fullbrowserwidth && this.options.usejsforfullbrowserwidth) {
                    var t = this.container.closest(".amazingslider-wrapper");
                    if (t.length > 0) {
                        var i = t.get(0).getBoundingClientRect();
                        if (i.left != 0) {
                            var e = P(window).width();
                            var o = t.offsetParent();
                            var s = o.get(0).getBoundingClientRect();
                            var n = -s.left;
                            var a = s.left + s.width - e;
                            t.css({
                                "margin-left": n + "px",
                                "margin-right": a + "px"
                            })
                        }
                    }
                }
                this.options.width = this.container.parent().width();
                if (this.options.width % 2 !== 0 && this.options.forcewidthtoevenforslice)
                    if (this.options.increasewhenforcetoeven) this.options.width++;
                    else this.options.width--;
                if (this.options.isfullscreen) {
                    this.options.height = this.container.parent().height();
                    if (P(".amazingslider-img-elem-" + this.id).length > 0) this.resizeFullscreenImage(P(".amazingslider-img-elem-" + this.id))
                } else {
                    if (this.options.scalemode == "flexheight") this.options.height = this.options.width * this.options.flexratio;
                    else this.options.height = Math.round(this.options.width * this.options.originalheight / this.options.originalwidth);
                    if (this.options.ratioresponsive) {
                        var e = this.options.isMobile ? Math.max(P(window).width(), P(document).width()) : P(window).width();
                        if (e <= this.options.ratiosmallscreen) this.options.height *= this.options.ratiosmallheight;
                        else if (e <= this.options.ratiomediumscreen) this.options.height *= this.options.ratiomediumheight
                    }
                }
                var r = 0;
                if (this.options.navdirection == "vertical" && this.options.navlocation == "outside") r = this.options.navwidth + this.options.navfeaturedarrowimagewidth;
                this.container.css({
                    width: this.options.width,
                    height: this.options.navdirection == "horizontal" && this.options.navmultirows ? "auto" : Math.round(this.options.height * (this.options.width - r) / this.options.width)
                });
                var l = P(".amazingslider-space-" + this.id, this.container);
                P(".amazingslider-space-" + this.id, this.container).css({
                    width: this.options.width - r,
                    height: Math.round(this.options.height * (this.options.width - r) / this.options.width)
                });
                if (this.options.navstyle == "thumbnails" && this.options.navthumbresponsive) this.resizeNavBullets();
                var h = P(".amazingslider-nav-" + this.id, this.container);
                var p = P(".amazingslider-nav-container-" + this.id, this.container);
                var d = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                var c = P(".amazingslider-car-left-arrow-" + this.id, this.container);
                var m = P(".amazingslider-car-right-arrow-" + this.id, this.container);
                if (this.options.navdirection == "vertical") {
                    var u = this.options.navstyle == "none" ? 0 : this.elemArray.length * this.options.navheight + (this.elemArray.length - 1) * this.options.navspacing;
                    if (this.options.navshowbuttons) {
                        if (this.options.navshowarrow) {
                            u += u > 0 ? this.options.navspacing : 0;
                            u += 2 * this.options.navheight + this.options.navspacing
                        }
                        if (this.options.navshowplaypause && !this.options.navshowplaypausestandalone) {
                            u += u > 0 ? this.options.navspacing : 0;
                            u += this.options.navheight
                        }
                    }
                    d.css({
                        height: u + "px",
                        width: "auto"
                    })
                } else if (this.options.navmultirows) d.css({
                    width: "100%",
                    height: "auto"
                });
                else {
                    var u = this.options.navstyle == "none" ? 0 : this.elemArray.length * this.options.navwidth + (this.elemArray.length - 1) * this.options.navspacing;
                    if (this.options.navshowbuttons) {
                        if (this.options.navshowarrow) {
                            u += u > 0 ? this.options.navspacing : 0;
                            u += 2 * this.options.navwidth + this.options.navspacing
                        }
                        if (this.options.navshowplaypause && !this.options.navshowplaypausestandalone) {
                            u += u > 0 ? this.options.navspacing : 0;
                            u += this.options.navwidth
                        }
                    }
                    d.css({
                        width: u + "px",
                        height: "auto"
                    })
                }
                if (this.options.navmultirows && this.options.navdirection == "horizontal" && this.options.navthumbresponsivemode == "samecolumn") {
                    var g = P(".amazingslider-bullet-" + this.id, this.container);
                    for (var f = 1; f < g.length; f++)
                        if ((f + 1) % this.options.navthumbcolumn == 0) g.eq(f).css({
                            "margin-right": 0
                        });
                        else g.eq(f).css({
                            "margin-right": this.options.navspacing + "px"
                        })
                }
                if (this.options.navthumbnavigationstyle != "auto") {
                    if (this.options.navmultirows) {
                        if (this.options.navdirection == "horizontal") {
                            var v = Math.floor(h.width() / (this.options.navwidth + this.options.navspacing));
                            if (v <= 0) v = 1;
                            w = Math.floor((h.width() - v * this.options.navwidth - (v - 1) * this.options.navspacing) / 2) - 2;
                            if (this.options.navthumbresponsivemode == "samecolumn") w = 0;
                            p.css({
                                width: "100%",
                                "margin-left": w + "px"
                            })
                        }
                    } else if (this.options.navdirection == "vertical" && d.height() > p.height() || this.options.navdirection == "horizontal" && d.width() > p.width()) {
                        if (this.options.navthumbnavigationstyle != "arrowinside") {
                            c.css({
                                display: "flex"
                            });
                            m.css({
                                display: "flex"
                            })
                        }
                        var b = 0;
                        if (this.options.navdirection == "vertical") {
                            b = isNaN(parseInt(d.css("margin-top"))) ? 0 : parseInt(d.css("margin-top"));
                            if (b <= p.height() - d.height()) b = p.height() - d.height();
                            if (b >= 0) b = 0;
                            d.css({
                                "margin-top": b
                            })
                        } else {
                            var w = 0;
                            if (this.options.navthumbnavigationstyle == "arrow") {
                                w = this.options.navthumbnavigationarrowimagewidth + this.options.navspacing;
                                if (this.options.navdirection == "horizontal") {
                                    var v = Math.floor((h.width() - 2 * w + this.options.navspacing) / (this.options.navwidth + this.options.navspacing));
                                    if (v <= 0) v = 1;
                                    w = Math.floor((h.width() - v * this.options.navwidth - (v - 1) * this.options.navspacing) / 2);
                                    p.css({
                                        "margin-left": w + "px",
                                        "margin-right": w + "px"
                                    })
                                } else p.css({
                                    "margin-top": w + "px",
                                    "margin-bottom": w + "px"
                                })
                            }
                            b = isNaN(parseInt(d.css("margin-left"))) ? 0 : parseInt(d.css("margin-left"));
                            if (b <= p.width() - d.width()) b = p.width() - d.width();
                            if (b >= 0) b = 0;
                            d.css({
                                "margin-left": b
                            })
                        }
                        this.updateCarouselLeftRightArrow(b)
                    } else {
                        c.css({
                            display: "none"
                        });
                        m.css({
                            display: "none"
                        });
                        if (this.options.navdirection == "vertical") d.css({
                            "margin-top": 0
                        });
                        else d.css({
                            "margin-left": "auto"
                        })
                    }
                    if (this.options.navstyle == "thumbnails" && this.options.navthumbresponsive) {
                        var x = 0;
                        var y = this.options.navdirection == "vertical" ? this.options.navwidth : this.options.navheight;
                        if (this.options.navstyle == "thumbnails" && this.options.navshowfeaturedarrow) {
                            y += this.options.navdirection == "vertical" ? this.options.navfeaturedarrowimagewidth : this.options.navfeaturedarrowimageheight;
                            x = this.options.navdirection == "vertical" ? this.options.navfeaturedarrowimagewidth : this.options.navfeaturedarrowimageheight
                        }
                        var k = this.options.navdirection == "vertical" ? this.options.navwidth / 2 - this.options.navthumbnavigationarrowimagewidth / 2 : this.options.navheight / 2 - this.options.navthumbnavigationarrowimageheight / 2;
                        if (this.options.navposition == "bottomleft" || this.options.navposition == "bottomright" || this.options.navposition == "bottom" || this.options.navposition == "right") k += x;
                        if (this.options.navdirection == "vertical") {
                            c.css({
                                top: this.options.navthumbnavigationstyle == "arrowoutside" ? "-" + this.options.navthumbnavigationarrowimageheight + "px" : "0px",
                                left: "0px",
                                "margin-left": k + "px"
                            });
                            m.css({
                                bottom: this.options.navthumbnavigationstyle == "arrowoutside" ? "-" + this.options.navthumbnavigationarrowimageheight + "px" : "0px",
                                left: "0px",
                                "margin-left": k + "px"
                            })
                        } else {
                            c.css({
                                left: this.options.navthumbnavigationstyle == "arrowoutside" ? "-" + this.options.navthumbnavigationarrowimagewidth + "px" : "0px",
                                top: "0px",
                                "margin-top": k + "px"
                            });
                            m.css({
                                right: this.options.navthumbnavigationstyle == "arrowoutside" ? "-" + this.options.navthumbnavigationarrowimagewidth + "px" : "0px",
                                top: "0px",
                                "margin-top": k + "px"
                            })
                        }
                    }
                }
                if (this.curElem >= 0 && this.options.navstyle != "none" && P("#amazingslider-bullet-" + this.id + "-" + this.curElem, this.container).length > 0) this.adjustNav(P("#amazingslider-bullet-" + this.id + "-" + this.curElem, this.container))
            },
            createStyle: function() {
                this.options.originalwidth = this.options.width;
                this.options.originalheight = this.options.height;
                this.options.flexratio = this.options.height / this.options.width;
                this.options.navoriginalwidth = this.options.navwidth;
                this.options.navoriginalheight = this.options.navheight;
                this.options.navthumboriginalcolumn = this.options.navthumbcolumn;
                this.options.navoriginalthumbtitleheight = this.options.navthumbtitleheight;
                this.options.navoriginalthumbtitlewidth = this.options.navthumbtitlewidth;
                if (!this.options.isresponsive) {
                    var t = 0;
                    if (this.options.navdirection == "vertical" && this.options.navlocation == "outside") t = this.options.navwidth + this.options.navfeaturedarrowimagewidth;
                    this.container.css({
                        width: this.options.width + t,
                        height: this.options.navdirection == "horizontal" && this.options.navmultirows ? "auto" : Math.round(this.options.height / this.options.width)
                    });
                    var i = P(".amazingslider-space-" + this.id, this.container);
                    P(".amazingslider-space-" + this.id, this.container).css({
                        width: this.options.width - t,
                        height: Math.round(this.options.height * (this.options.width - t) / this.options.width)
                    })
                } else {
                    this.resizeSlider();
                    var e = this;
                    P(window).resize(function() {
                        setTimeout(function() {
                            e.resizeSlider()
                        }, e.options.windowresizetimeout)
                    })
                }
                var o = ".amazingslider-wrapper-" + this.id + " {display:block;position:relative;width:100%;height:auto;";
                o += "}";
                o += ".amazingslider-slider-" + this.id + " {display:block;position:relative;left:0px;top:0px;/*width:100%;*/height:auto;max-height:100%;";
                if (this.options.showshadow) {
                    var s = "0px 0px " + this.options.shadowsize + "px " + this.options.shadowcolor;
                    o += "box-shadow:" + s + ";-moz-box-shadow:" + s + ";-webkit-box-shadow:" + s + ";";
                    if (az_.isIE678() || az_.isIE9) o += "filter:progid:DXImageTransform.Microsoft.Shadow(color=" + this.options.shadowcolor + ",direction=135,strength=" + this.options.shadowsize + ");"
                }
                if (this.options.navdirection == "vertical" && this.options.navposition == "left" && this.options.navlocation == "outside") o += "margin-left:" + Math.round(this.options.navwidth + this.options.navfeaturedarrowimagewidth) + "px;";
                o += "}";
                o += ".amazingslider-box-" + this.id + " {display:block;position:relative;left:0px;top:0px;width:100%;height:auto;";
                if (this.options.border > 0) o += "margin-left:-" + this.options.border + "px;border-width:" + this.options.border + "px;border-style:solid;border-color:" + this.options.bordercolor + ";";
                o += "}";
                o += ".amazingslider-swipe-box-" + this.id + " {display:block;position:relative;left:0px;top:0px;width:100%;height:auto;}";
                o += ".amazingslider-space-" + this.id + " {display:block;position:relative;left:0px;top:0px;width:100%;height:auto;visibility:hidden;line-height:0px;font-size:0px;}";
                o += ".amazingslider-img-box-" + this.id + " {display:block;position:absolute;left:0px;top:0px;width:100%;height:100%;}";
                o += ".amazingslider-lightbox-play-" + this.id + " {display:none;position:absolute;left:50%;top:50%;cursor:pointer;width:" + this.options.playvideoimagewidth + "px;height:" + this.options.playvideoimageheight + "px;margin-top:" + "-" + Math.round(this.options.playvideoimageheight / 2) + "px;margin-left:" + "-" + Math.round(this.options.playvideoimagewidth / 2) + "px; background:url('" + this.options.playvideoimage + "') no-repeat left top;}";
                o += ".amazingslider-play-" + this.id + " {display:none;position:absolute;left:50%;top:50%;cursor:pointer;width:" + this.options.playvideoimagewidth + "px;height:" + this.options.playvideoimageheight + "px;margin-top:" + "-" + Math.round(this.options.playvideoimageheight / 2) + "px;margin-left:" + "-" + Math.round(this.options.playvideoimagewidth / 2) + "px; background:url('" + this.options.playvideoimage + "') no-repeat left top;}";
                o += ".amazingslider-video-wrapper-" + this.id + " {display:none;position:absolute;left:0px;top:0px;background-color:#000;text-align:center;}";
                o += ".amazingslider-error-" + this.id + " {display:block;position:relative;margin:0 auto;width:80%;top:50%;color:#fff;font:16px Arial,Tahoma,Helvetica,sans-serif;}";
                if (this.options.showribbon) {
                    o += ".amazingslider-ribbon-" + this.id + " {display:block;position:absolute;";
                    switch (this.options.ribbonposition) {
                        case "topleft":
                            o += "left:" + this.options.ribbonimagex + "px;top:" + this.options.ribbonimagey + "px;";
                            break;
                        case "topright":
                            o += "right:" + this.options.ribbonimagex + "px;top:" + this.options.ribbonimagey + "px;";
                            break;
                        case "bottomleft":
                            o += "left:" + this.options.ribbonimagex + "px;bottom:" + this.options.ribbonimagey + "px;";
                            break;
                        case "bottomright":
                            o += "right:" + this.options.ribbonimagex + "px;bottom:" + this.options.ribbonimagey + "px;";
                            break;
                        case "top":
                            o += "width:100%;height:auto;margin:0 auto;top:" + this.options.ribbonimagey + "px;";
                        case "bottom":
                            o += "width:100%;height:auto;text-align:center;bottom:" + this.options.ribbonimagey + "px;"
                    }
                    o += "}"
                }
                o += ".amazingslider-video-wrapper-" + this.id + " video {max-width:100%;height:auto;}";
                o += ".amazingslider-video-wrapper-" + this.id + " iframe, " + ".amazingslider-video-wrapper-" + this.id + " object, " + ".amazingslider-video-wrapper-" + this.id + " embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
                if (this.options.navstyle == "thumbnails" && this.options.navthumbstyle != "imageonly") {
                    o += ".amazingslider-nav-thumbnail-tite-" + this.id + " {" + this.options.navthumbtitlecss + "}";
                    o += ".amazingslider-nav-thumbnail-tite-" + this.id + ":hover {" + this.options.navthumbtitlehovercss + "}";
                    o += ".amazingslider-bullet-selected .amazingslider-nav-thumbnail-tite-" + this.id + ", .amazingslider-bullet-highlighted .amazingslider-nav-thumbnail-tite-" + this.id + " {" + this.options.navthumbtitlehovercss + "}";
                    if (this.options.navthumbstyle == "imageandtitledescription" || this.options.navthumbstyle == "textonly") {
                        o += ".amazingslider-nav-thumbnail-description-" + this.id + " {" + this.options.navthumbdescriptioncss + "}";
                        o += ".amazingslider-nav-thumbnail-description-" + this.id + ":hover {" + this.options.navthumbdescriptionhovercss + "}";
                        o += ".amazingslider-bullet-selected .amazingslider-nav-thumbnail-description-" + this.id + ", .amazingslider-bullet-highlighted .amazingslider-nav-thumbnail-description-" + this.id + " {" + this.options.navthumbdescriptionhovercss + "}"
                    }
                }
                o += ".amazingslider-rotate { border-radius:50%; -webkit-transition:-webkit-transform .4s ease-in; transition: transform .4s ease-in; } .amazingslider-rotate:hover { -webkit-transform: rotate(360deg); transform: rotate(360deg); }";
                o += ".amazingslider" + " {height: auto !important;}";
                P("head").append("<style type='text/css' data-creator='amazingslidercreator" + this.id + "'>" + o + "</style>");
                if (this.options.customcss && this.options.customcss.length > 0) P("head").append("<style type='text/css' data-creator='amazingslidercreator" + this.id + "'>" + this.options.customcss + "</style>")
            },
            createBottomShadow: function() {
                if (!this.options.showbottomshadow) return;
                var t = P(".amazingslider-bottom-shadow-" + this.id, this.container);
                var i = (100 - this.options.bottomshadowimagewidth) / 2;
                t.css({
                    display: "block",
                    position: "absolute",
                    left: i + "%",
                    top: this.options.bottomshadowimagetop + "%",
                    width: this.options.bottomshadowimagewidth + "%",
                    height: "auto"
                });
                t.html("<img alt='' src='" + this.options.bottomshadowimage + "' style='display:block;position:relative;width:100%;height:auto;max-width:100%;' />")
            },
            createBackgroundImage: function() {
                if (!this.options.showbackgroundimage || !this.options.backgroundimage) return;
                var t = P(".amazingslider-background-image-" + this.id, this.container);
                var i = (100 - this.options.backgroundimagewidth) / 2;
                t.css({
                    display: "block",
                    position: "absolute",
                    left: i + "%",
                    top: this.options.backgroundimagetop + "%",
                    width: this.options.backgroundimagewidth + "%",
                    height: "auto"
                });
                t.html("<img alt='' src='" + this.options.backgroundimage + "' style='display:block;position:relative;width:100%;height:auto;' />")
            },
            createArrows: function() {
                if (this.options.arrowstyle == "none") return;
                var t = this;
                var i = P(".amazingslider-arrow-left-" + this.id, this.container);
                var e = P(".amazingslider-arrow-right-" + this.id, this.container);
                i.css({
                    overflow: "hidden",
                    position: "absolute",
                    cursor: "pointer",
                    width: this.options.arrowwidth + "px",
                    height: this.options.arrowheight + "px",
                    left: this.options.arrowmargin + "px",
                    top: this.options.arrowtop + "%",
                    "margin-top": "-" + this.options.arrowheight / 2 + "px"
                });
                if (az_.isIE678()) i.css({
                    opacity: "inherit",
                    filter: "inherit"
                });
                i.hover(function() {
                    P(this).css({
                        "background-position": "left bottom"
                    })
                }, function() {
                    P(this).css({
                        "background-position": "left top"
                    })
                });
                i.click(function() {
                    t.container.trigger("amazingslider.arrow", [t.curElem, -2]);
                    t.videoAutoplayMode = false;
                    t.slideRun(-2)
                });
                e.css({
                    overflow: "hidden",
                    position: "absolute",
                    cursor: "pointer",
                    width: this.options.arrowwidth + "px",
                    height: this.options.arrowheight + "px",
                    right: this.options.arrowmargin + "px",
                    top: this.options.arrowtop + "%",
                    "margin-top": "-" + this.options.arrowheight / 2 + "px"
                });
                if (az_.isIE678()) e.css({
                    opacity: "inherit",
                    filter: "inherit"
                });
                e.hover(function() {
                    P(this).css({
                        "background-position": "right bottom"
                    })
                }, function() {
                    P(this).css({
                        "background-position": "right top"
                    })
                });
                e.click(function() {
                    t.container.trigger("amazingslider.arrow", [t.curElem, -1]);
                    t.videoAutoplayMode = false;
                    t.slideRun(-1)
                });
                if (this.options.arrowimage != "") {
                    i.css({
                        background: "url('" + this.options.arrowimage + "') no-repeat left top"
                    });
                    e.css({
                        background: "url('" + this.options.arrowimage + "') no-repeat right top"
                    })
                }
                if (this.options.arrowstyle == "always") {
                    i.css({
                        display: "block"
                    });
                    e.css({
                        display: "block"
                    })
                } else {
                    P(".amazingslider-wrapper-" + this.id, this.container).hover(function() {
                        clearTimeout(t.arrowTimeout);
                        if (az_.isIE678()) {
                            P(".amazingslider-arrow-left-" + t.id, t.container).show();
                            P(".amazingslider-arrow-right-" + t.id, t.container).show()
                        } else {
                            P(".amazingslider-arrow-left-" + t.id, t.container).fadeIn();
                            P(".amazingslider-arrow-right-" + t.id, t.container).fadeIn()
                        }
                    }, function() {
                        t.arrowTimeout = setTimeout(function() {
                            if (az_.isIE678()) {
                                P(".amazingslider-arrow-left-" + t.id, t.container).hide();
                                P(".amazingslider-arrow-right-" + t.id, t.container).hide()
                            } else {
                                P(".amazingslider-arrow-left-" + t.id, t.container).fadeOut();
                                P(".amazingslider-arrow-right-" + t.id, t.container).fadeOut()
                            }
                        }, t.options.arrowhideonmouseleave)
                    })
                }
            },
            carMoveLeft: function() {
                var t = P(".amazingslider-nav-container-" + this.id, this.container);
                var i = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                if (t.width() >= i.width()) return;
                if (this.options.navshowpreview) P(".amazingslider-nav-preview-" + this.id, this.container).hide();
                var e = t.width() + this.options.navspacing;
                var o = (isNaN(parseInt(i.css("margin-left"))) ? 0 : parseInt(i.css("margin-left"))) - e;
                if (o <= t.width() - i.width()) o = t.width() - i.width();
                if (o >= 0) o = 0;
                i.animate({
                    "margin-left": o
                }, {
                    queue: false,
                    duration: 500,
                    easing: "easeOutCirc"
                });
                if (this.options.navthumbnavigationstyle != "auto") this.updateCarouselLeftRightArrow(o)
            },
            carMoveRight: function() {
                var t = P(".amazingslider-nav-container-" + this.id, this.container);
                var i = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                if (t.width() >= i.width()) return;
                if (this.options.navshowpreview) P(".amazingslider-nav-preview-" + this.id, this.container).hide();
                var e = t.width() + this.options.navspacing;
                var o = (isNaN(parseInt(i.css("margin-left"))) ? 0 : parseInt(i.css("margin-left"))) + e;
                if (o <= t.width() - i.width()) o = t.width() - i.width();
                if (o >= 0) o = 0;
                i.animate({
                    "margin-left": o
                }, {
                    queue: false,
                    duration: 500,
                    easing: "easeOutCirc"
                });
                if (this.options.navthumbnavigationstyle != "auto") this.updateCarouselLeftRightArrow(o)
            },
            carMoveBottom: function() {
                var t = P(".amazingslider-nav-container-" + this.id, this.container);
                var i = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                if (t.height() >= i.height()) return;
                if (this.options.navshowpreview) P(".amazingslider-nav-preview-" + this.id, this.container).hide();
                var e = t.height() + this.options.navspacing;
                var o = (isNaN(parseInt(i.css("margin-top"))) ? 0 : parseInt(i.css("margin-top"))) + e;
                if (o <= t.height() - i.height()) o = t.height() - i.height();
                if (o >= 0) o = 0;
                i.animate({
                    "margin-top": o
                }, {
                    queue: false,
                    duration: 500,
                    easing: "easeOutCirc"
                });
                if (this.options.navthumbnavigationstyle != "auto") this.updateCarouselLeftRightArrow(o)
            },
            carMoveTop: function() {
                var t = P(".amazingslider-nav-container-" + this.id, this.container);
                var i = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                if (t.height() >= i.height()) return;
                if (this.options.navshowpreview) P(".amazingslider-nav-preview-" + this.id, this.container).hide();
                var e = t.height() + this.options.navspacing;
                var o = (isNaN(parseInt(i.css("margin-top"))) ? 0 : parseInt(i.css("margin-top"))) - e;
                if (o <= t.height() - i.height()) o = t.height() - i.height();
                if (o >= 0) o = 0;
                i.animate({
                    "margin-top": o
                }, {
                    queue: false,
                    duration: 500,
                    easing: "easeOutCirc"
                });
                if (this.options.navthumbnavigationstyle != "auto") this.updateCarouselLeftRightArrow(o)
            },
            updateCarouselLeftRightArrow: function(t) {
                var i = P(".amazingslider-nav-container-" + this.id, this.container);
                var e = P(".amazingslider-bullet-wrapper-" + this.id, this.container);
                if (this.options.navdirection == "vertical") {
                    if (t == 0) {
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).css({
                            "background-position": "left bottom",
                            cursor: ""
                        });
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).data("disabled", true);
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).attr("readonly", "true")
                    } else {
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).css({
                            "background-position": "left top",
                            cursor: "pointer"
                        });
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).data("disabled", false);
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).removeAttr("readonly")
                    }
                    if (t == i.height() - e.height()) {
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).css({
                            "background-position": "right bottom",
                            cursor: ""
                        });
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).data("disabled", true);
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).attr("readonly", "true")
                    } else {
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).css({
                            "background-position": "right top",
                            cursor: "pointer"
                        });
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).data("disabled", false);
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).removeAttr("readonly")
                    }
                } else {
                    if (t == 0) {
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).css({
                            "background-position": "left bottom",
                            cursor: ""
                        });
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).data("disabled", true);
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).attr("readonly", "true")
                    } else {
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).css({
                            "background-position": "left top",
                            cursor: "pointer"
                        });
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).data("disabled", false);
                        P(".amazingslider-car-left-arrow-" + this.id, this.container).removeAttr("readonly")
                    }
                    if (t == i.width() - e.width()) {
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).css({
                            "background-position": "right bottom",
                            cursor: ""
                        });
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).data("disabled", true);
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).attr("readonly", "true")
                    } else {
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).css({
                            "background-position": "right top",
                            cursor: "pointer"
                        });
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).data("disabled", false);
                        P(".amazingslider-car-right-arrow-" + this.id, this.container).removeAttr("readonly")
                    }
                }
            },
            calcNavThumbSize: function() {
                var t = P(window).width();
                if (t < this.options.navthumbsmallsize) {
                    if (this.options.navthumbresponsivemode == "samecolumn" && this.options.navdirection == "horizontal") {
                        this.options.navwidth = (this.options.width - this.options.navspacing * (this.options.navthumbsmallcolumn - 1)) / this.options.navthumbsmallcolumn;
                        this.options.navheight = this.options.navwidth * this.options.navoriginalheight / this.options.navoriginalwidth;
                        this.options.navthumbcolumn = this.options.navthumbsmallcolumn
                    } else {
                        this.options.navwidth = this.options.navthumbsmallwidth;
                        this.options.navheight = this.options.navthumbsmallheight
                    }
                    this.options.navthumbtitleheight = this.options.navthumbsmalltitleheight;
                    this.options.navthumbtitlewidth = this.options.navthumbsmalltitlewidth
                } else if (t < this.options.navthumbmediumsize) {
                    if (this.options.navthumbresponsivemode == "samecolumn" && this.options.navdirection == "horizontal") {
                        this.options.navwidth = (this.options.width - this.options.navspacing * (this.options.navthumbmediumcolumn - 1)) / this.options.navthumbmediumcolumn;
                        this.options.navheight = this.options.navwidth * this.options.navoriginalheight / this.options.navoriginalwidth;
                        this.options.navthumbcolumn = this.options.navthumbmediumcolumn
                    } else {
                        this.options.navwidth = this.options.navthumbmediumwidth;
                        this.options.navheight = this.options.navthumbmediumheight
                    }
                    this.options.navthumbtitleheight = this.options.navthumbmediumtitleheight;
                    this.options.navthumbtitlewidth = this.options.navthumbmediumtitlewidth
                } else {
                    if (this.options.navthumbresponsivemode == "samecolumn" && this.options.navdirection == "horizontal") {
                        this.options.navwidth = (this.options.width - this.options.navspacing * (this.options.navthumboriginalcolumn - 1)) / this.options.navthumboriginalcolumn;
                        this.options.navheight = this.options.navwidth * this.options.navoriginalheight / this.options.navoriginalwidth;
                        this.options.navthumbcolumn = this.options.navthumboriginalcolumn
                    } else {
                        this.options.navwidth = this.options.navoriginalwidth;
                        this.options.navheight = this.options.navoriginalheight
                    }
                    this.options.navthumbtitleheight = this.options.navoriginalthumbtitleheight;
                    this.options.navthumbtitlewidth = this.options.navoriginalthumbtitlewidth
                }
            },
            createNav: function() {
                if (this.options.navstyle == "none" && !this.options.navshowbuttons) return;
                var s = this;
                var t;
                var n = P(".amazingslider-nav-" + this.id, this.container);
                var i = P(".amazingslider-nav-container-" + this.id, this.container);
                var a = P("<div class='amazingslider-bullet-wrapper-" + this.id + "' style='display:block;position:relative;'></div>");
                i.css({
                    overflow: "hidden"
                });
                if (this.options.navstyle == "thumbnails") {
                    if (this.options.navthumbresponsive || this.options.navthumbresponsivemode == "samecolumn") this.calcNavThumbSize();
                    this.options.navimagewidth = this.options.navwidth - this.options.navborder * 2;
                    this.options.navimageheight = this.options.navheight - this.options.navborder * 2;
                    if (this.options.navthumbstyle == "imageandtitle") this.options.navheight += this.options.navthumbtitleheight;
                    else if (this.options.navthumbstyle == "imageandtitledescription" || this.options.navthumbstyle == "textonly") this.options.navwidth += this.options.navthumbtitlewidth
                }
                if (this.options.navdirection == "vertical") {
                    var e = this.options.navstyle == "none" ? 0 : this.elemArray.length * this.options.navheight + (this.elemArray.length - 1) * this.options.navspacing;
                    if (this.options.navshowbuttons) {
                        if (this.options.navshowarrow) {
                            e += e > 0 ? this.options.navspacing : 0;
                            e += 2 * this.options.navheight + this.options.navspacing
                        }
                        if (this.options.navshowplaypause && !this.options.navshowplaypausestandalone) {
                            e += e > 0 ? this.options.navspacing : 0;
                            e += this.options.navheight
                        }
                    }
                    a.css({
                        height: e + "px",
                        width: "auto"
                    })
                } else if (this.options.navmultirows) {
                    a.css({
                        width: "100%",
                        height: "auto"
                    })
                } else {
                    var e = this.options.navstyle == "none" ? 0 : this.elemArray.length * this.options.navwidth + (this.elemArray.length - 1) * this.options.navspacing;
                    if (this.options.navshowbuttons) {
                        if (this.options.navshowarrow) {
                            e += e > 0 ? this.options.navspacing : 0;
                            e += 2 * this.options.navwidth + this.options.navspacing
                        }
                        if (this.options.navshowplaypause && !this.options.navshowplaypausestandalone) {
                            e += e > 0 ? this.options.navspacing : 0;
                            e += this.options.navwidth
                        }
                    }
                    a.css({
                        width: e + "px",
                        height: "auto"
                    })
                }
                i.append(a);
                var o = 0;
                var r = this.options.navdirection == "vertical" ? this.options.navwidth : this.options.navheight;
                if (this.options.navstyle == "thumbnails" && this.options.navshowfeaturedarrow) {
                    r += this.options.navdirection == "vertical" ? this.options.navfeaturedarrowimagewidth : this.options.navfeaturedarrowimageheight;
                    o = this.options.navdirection == "vertical" ? this.options.navfeaturedarrowimagewidth : this.options.navfeaturedarrowimageheight
                }
                var l = "navmarginx" in this.options ? this.options.navmarginx : this.options.navmargin;
                var h = "navmarginy" in this.options ? this.options.navmarginy : this.options.navmargin;
                n.css({
                    display: "block",
                    position: this.options.navlocation == "outside" && this.options.navdirection == "vertical" ? "absolute" : "relative",
                    height: "auto"
                });
                switch (this.options.navposition) {
                    case "top":
                        a.css({
                            "margin-left": "auto",
                            "margin-right": "auto",
                            height: r + "px"
                        });
                        n.css({
                            width: "100%",
                            top: "0%",
                            left: "0px",
                            "margin-top": h + "px"
                        });
                        break;
                    case "topleft":
                        a.css({
                            height: r + "px"
                        });
                        n.css({
                            "max-width": "100%",
                            top: "0px",
                            left: "0px",
                            "margin-top": h + "px",
                            "margin-left": l + "px"
                        });
                        break;
                    case "topright":
                        a.css({
                            height: r + "px"
                        });
                        n.css({
                            "max-width": "100%",
                            top: "0px",
                            right: "0px",
                            "margin-top": h + "px",
                            "margin-right": l + "px"
                        });
                        break;
                    case "bottom":
                        a.css({
                            "margin-left": "auto",
                            "margin-right": "auto",
                            "margin-top": o + "px"
                        });
                        n.css({
                            width: "100%",
                            top: this.options.navlocation == "outside" ? "100%" : "auto",
                            bottom: this.options.navlocation == "outside" ? "auto" : String(h - o) + "px",
                            left: "0px",
                            "margin-top": String(h - o) + "px"
                        });
                        break;
                    case "bottomleft":
                        a.css({
                            "margin-top": o + "px"
                        });
                        n.css({
                            "max-width": "100%",
                            bottom: "0px",
                            left: "0px",
                            "margin-bottom": h + "px",
                            "margin-top": String(h - o) + "px",
                            "margin-left": l + "px"
                        });
                        break;
                    case "bottomright":
                        a.css({
                            "margin-top": o + "px"
                        });
                        n.css({
                            "max-width": "100%",
                            bottom: "0px",
                            right: "0px",
                            "margin-bottom": h + "px",
                            "margin-top": String(h - o) + "px",
                            "margin-right": l + "px"
                        });
                        break;
                    case "left":
                        a.css({
                            width: r + "px"
                        });
                        i.css({
                            display: "block",
                            position: "absolute",
                            top: "0px",
                            bottom: "0px",
                            left: "0px",
                            right: "0px",
                            height: "auto"
                        });
                        if (a.height() > this.container.height()) n.css({
                            width: r + "px",
                            left: "0%",
                            "margin-left": l + "px",
                            "margin-left": this.options.navlocation == "outside" ? 0 : l + "px",
                            height: this.options.navthumbnavigationstyle == "arrowoutside" ? "calc(100% - 38px)" : "100%",
                            top: this.options.navthumbnavigationstyle == "arrowoutside" ? "50%" : 0,
                            transform: this.options.navthumbnavigationstyle == "arrowoutside" ? "translateY(-50%)" : "unset"
                        });
                        else n.css({
                            height: "100%",
                            width: r + "px",
                            top: "0%",
                            left: "0%",
                            "margin-left": l + "px",
                            "margin-left": this.options.navlocation == "outside" ? 0 : l + "px"
                        });
                        break;
                    case "right":
                        a.css({
                            "margin-left": o + "px"
                        });
                        n.css({
                            height: "100%",
                            width: r + "px",
                            top: "0%",
                            left: "100%",
                            "margin-left": String(l - o) + "px"
                        });
                        i.css({
                            display: "block",
                            position: "absolute",
                            top: "0px",
                            bottom: "0px",
                            left: "0px",
                            right: "0px",
                            height: "auto"
                        });
                        break
                }
                if (this.options.navstyle != "none") {
                    var p;
                    for (t = 0; t < this.elemArray.length; t++) {
                        p = this.createNavBullet(t);
                        a.append(p)
                    }
                    if (this.options.navmultirows) a.append('<div style="clear:both;"></div>');
                    n.mouseenter(function() {
                        s.pauseCarousel = true
                    });
                    n.mouseleave(function() {
                        s.pauseCarousel = false
                    });
                    if (s.options.navmultirows && s.options.navdirection == "horizontal" && s.options.navthumbresponsivemode == "samecolumn") {
                        var d = P(".amazingslider-bullet-" + s.id, s.container);
                        for (var t = 1; t < d.length; t++)
                            if ((t + 1) % s.options.navthumbcolumn == 0) d.eq(t).css({
                                "margin-right": 0
                            });
                            else d.eq(t).css({
                                "margin-right": s.options.navspacing + "px"
                            })
                    }
                    if (s.options.navthumbnavigationstyle == "auto") n.mousemove(function(t) {
                        if (s.options.navdirection == "vertical") {
                            if (n.height() >= a.height()) return;
                            var i = t.pageY - n.offset().top;
                            if (i < 10) i = 0;
                            if (i > n.height() - 10) i = n.height();
                            var e = i / n.height();
                            var o = (n.height() - a.height()) * e;
                            a.animate({
                                "margin-top": o
                            }, {
                                queue: false,
                                duration: 20,
                                easing: "easeOutCubic"
                            })
                        } else {
                            if (n.width() >= a.width()) return;
                            var i = t.pageX - n.offset().left;
                            if (i < 10) i = 0;
                            if (i > n.width() - 10) i = n.width();
                            var e = i / n.width();
                            var o = (n.width() - a.width()) * e;
                            a.animate({
                                "margin-left": o
                            }, {
                                queue: false,
                                duration: 20,
                                easing: "easeOutCubic"
                            })
                        }
                    });
                    else {
                        var c = 0;
                        if (s.options.navmultirows && s.options.navdirection == "horizontal") {
                            var m = Math.floor(n.width() / (s.options.navwidth + s.options.navspacing));
                            if (m <= 0) m = 1;
                            c = Math.floor((n.width() - m * s.options.navwidth - (m - 1) * s.options.navspacing) / 2);
                            if (s.options.navthumbresponsivemode == "samecolumn") c = 0;
                            i.css({
                                width: "100%",
                                "margin-left": c + "px"
                            })
                        } else if (s.options.navthumbnavigationstyle == "arrow") {
                            c = s.options.navthumbnavigationarrowimagewidth + s.options.navspacing;
                            if (s.options.navdirection == "horizontal") {
                                var m = Math.floor((n.width() - 2 * c + s.options.navspacing) / (s.options.navwidth + s.options.navspacing));
                                if (m <= 0) m = 1;
                                c = Math.floor((n.width() - m * s.options.navwidth - (m - 1) * s.options.navspacing) / 2);
                                i.css({
                                    "margin-left": s.options.navthumbnavigationarrowimagewidth + "px",
                                    "margin-right": s.options.navthumbnavigationarrowimagewidth + "px"
                                })
                            } else i.css({
                                "margin-top": c + "px",
                                "margin-bottom": c + "px"
                            })
                        } else if (s.options.navdirection == "horizontal") i.css({
                            "margin-left": "0px",
                            "margin-right": "0px"
                        });
                        else i.css({
                            "margin-top": "0px",
                            "margin-bottom": "0px"
                        });
                        var u = P("<div class='as-thumb-arrow amazingslider-car-left-arrow-" + s.id + "' style='display:none;'>" + s.options.navthumbnavigationarrowsvg + "</div>");
                        var g = P("<div class='as-thumb-arrow amazingslider-car-right-arrow-" + s.id + "' style='display:none;'>" + s.options.navthumbnavigationarrowsvg + "</div>");
                        n.append(u);
                        n.append(g);
                        u.css({
                            overflow: "hidden",
                            position: "absolute",
                            cursor: "pointer",
                            display: "none",
                            width: s.options.navthumbnavigationarrowimagewidth + "px",
                            height: s.options.navthumbnavigationarrowimageheight + "px"
                        });
                        g.css({
                            overflow: "hidden",
                            position: "absolute",
                            cursor: "pointer",
                            display: "none",
                            width: s.options.navthumbnavigationarrowimagewidth + "px",
                            height: s.options.navthumbnavigationarrowimageheight + "px"
                        });
                        if (s.options.navthumbnavigationarrowimage != "") {
                            u.css({
                                background: "url('" + s.options.navthumbnavigationarrowimage + "') no-repeat left top"
                            });
                            g.css({
                                background: "url('" + s.options.navthumbnavigationarrowimage + "') no-repeat right top"
                            })
                        }
                        var f = s.options.navdirection == "vertical" ? s.options.navwidth / 2 - s.options.navthumbnavigationarrowimagewidth / 2 : s.options.navheight / 2 - s.options.navthumbnavigationarrowimageheight / 2;
                        if (s.options.navposition == "bottomleft" || s.options.navposition == "bottomright" || s.options.navposition == "bottom" || s.options.navposition == "right") f += o;
                        if (s.options.navdirection == "vertical") {
                            u.css({
                                top: s.options.navthumbnavigationstyle == "arrowoutside" ? "-" + s.options.navthumbnavigationarrowimageheight + "px" : "0px",
                                left: "0px",
                                "margin-left": f + "px"
                            });
                            g.css({
                                bottom: s.options.navthumbnavigationstyle == "arrowoutside" ? "-" + s.options.navthumbnavigationarrowimageheight + "px" : "0px",
                                left: "0px",
                                "margin-left": f + "px"
                            })
                        } else {
                            u.css({
                                left: s.options.navthumbnavigationstyle == "arrowoutside" ? "-" + s.options.navthumbnavigationarrowimagewidth + "px" : "0px",
                                top: "0px",
                                "margin-top": f + "px"
                            });
                            g.css({
                                right: s.options.navthumbnavigationstyle == "arrowoutside" ? "-" + s.options.navthumbnavigationarrowimagewidth + "px" : "0px",
                                top: "0px",
                                "margin-top": f + "px"
                            })
                        }
                        if (az_.isIE678()) u.css({
                            opacity: "inherit",
                            filter: "inherit"
                        });
                        u.hover(function() {
                            if (!P(this).data("disabled")) P(this).css({
                                "background-position": "left center"
                            })
                        }, function() {
                            if (!P(this).data("disabled")) P(this).css({
                                "background-position": "left top"
                            })
                        });
                        u.click(function() {
                            if (s.options.navdirection == "vertical") s.carMoveBottom();
                            else s.carMoveRight()
                        });
                        if (az_.isIE678()) g.css({
                            opacity: "inherit",
                            filter: "inherit"
                        });
                        g.hover(function() {
                            if (!P(this).data("disabled")) P(this).css({
                                "background-position": "right center"
                            })
                        }, function() {
                            if (!P(this).data("disabled")) P(this).css({
                                "background-position": "right top"
                            })
                        });
                        g.click(function() {
                            if (s.options.navdirection == "vertical") s.carMoveTop();
                            else s.carMoveLeft()
                        });
                        if (s.options.navdirection == "vertical" && a.height() > i.height() || s.options.navdirection == "horizontal" && a.width() > i.width()) {
                            u.css({
                                display: "flex",
                                "background-position": "left bottom",
                                cursor: ""
                            });
                            u.data("disabled", true);
                            u.attr("readonly", "true");
                            g.css({
                                display: "flex"
                            })
                        }
                        if (s.options.navthumbnavigationstyle == "arrowinside") {
                            u.hide();
                            g.hide();
                            n.hover(function() {
                                if (s.options.navdirection == "vertical" && a.height() > i.height() || s.options.navdirection == "horizontal" && a.width() > i.width()) {
                                    u.fadeIn();
                                    g.fadeIn()
                                }
                            }, function() {
                                u.fadeOut();
                                g.fadeOut()
                            })
                        }
                    }
                    if (s.options.navdirection == "vertical") n.sliderTouchSwipe({
                        preventWebBrowser: true,
                        swipeTop: function(t) {
                            s.carMoveTop()
                        },
                        swipeBottom: function() {
                            s.carMoveBottom()
                        }
                    });
                    else n.sliderTouchSwipe({
                        preventWebBrowser: false,
                        swipeLeft: function(t) {
                            s.carMoveLeft()
                        },
                        swipeRight: function() {
                            s.carMoveRight()
                        }
                    });
                    this.container.on("amazingslider.switch", function(t, i, e) {
                        P("#amazingslider-bullet-" + s.id + "-" + i, s.container)["bulletNormal" + s.id]();
                        P("#amazingslider-bullet-" + s.id + "-" + e, s.container)["bulletSelected" + s.id]()
                    });
                    if (this.options.navshowpreview) {
                        var v = P("<div class='amazingslider-nav-preview-" + this.id + "' style='display:none;position:absolute;width:" + this.options.navpreviewwidth + "px;height:" + this.options.navpreviewheight + "px;background-color:" + this.options.navpreviewbordercolor + ";padding:" + s.options.navpreviewborder + "px;'></div>");
                        var b = P("<div class='amazingslider-nav-preview-arrow-" + this.id + "' style='display:block;position:absolute;width:" + this.options.navpreviewarrowwidth + "px;height:" + this.options.navpreviewarrowheight + "px;" + 'background:url("' + this.options.navpreviewarrowimage + "\") no-repeat center center;' ></div>");
                        switch (this.options.navpreviewposition) {
                            case "bottom":
                                b.css({
                                    left: "50%",
                                    bottom: "100%",
                                    "margin-left": "-" + Math.round(this.options.navpreviewarrowwidth / 2) + "px"
                                });
                                break;
                            case "top":
                                b.css({
                                    left: "50%",
                                    top: "100%",
                                    "margin-left": "-" + Math.round(this.options.navpreviewarrowwidth / 2) + "px"
                                });
                                break;
                            case "left":
                                b.css({
                                    top: "50%",
                                    left: "100%",
                                    "margin-top": "-" + Math.round(this.options.navpreviewarrowheight / 2) + "px"
                                });
                                break;
                            case "right":
                                b.css({
                                    top: "50%",
                                    right: "100%",
                                    "margin-top": "-" + Math.round(this.options.navpreviewarrowheight / 2) + "px"
                                });
                                break
                        }
                        var w = P("<div class='amazingslider-nav-preview-images-" + this.id + "' style='display:block;position:relative;width:100%;height:100%;overflow:hidden;' />");
                        v.append(b);
                        v.append(w);
                        if (this.options.navshowplayvideo) {
                            var x = P("<div class='amazingslider-nav-preview-play-" + this.id + "' style='display:none;position:absolute;left:0;top:0;width:100%;height:100%;" + 'background:url("' + this.options.navplayvideoimage + '") no-repeat center center;' + "' ></div>");
                            v.append(x)
                        }
                        P(".amazingslider-wrapper-" + this.id, this.container).append(v)
                    }
                    if (this.options.navshowfeaturedarrow) a.append("<div class='amazingslider-nav-featuredarrow-" + this.id + "' style='display:none;position:absolute;z-index:2;width:" + this.options.navfeaturedarrowimagewidth + "px;" + "height:" + this.options.navfeaturedarrowimageheight + "px;" + 'background:url("' + this.options.navfeaturedarrowimage + "\") no-repeat center center;'></div>")
                }
                if (this.options.navshowbuttons) {
                    var y = this.options.navdirection == "vertical" ? "top" : "left";
                    var k = this.options.navstyle == "none" ? 0 : this.options.navspacing;
                    if (this.options.navshowarrow) {
                        var z = P("<div class='amazingslider-nav-left-" + this.id + "' style='position:relative;float:" + y + ";margin-" + y + ":" + k + "px;width:" + this.options.navwidth + "px;height:" + this.options.navheight + "px;cursor:pointer;'></div>");
                        a.append(z);
                        if (this.options.navbuttonradius) z.css(az_.applyBrowserStyles({
                            "border-radius": this.options.navbuttonradius + "px"
                        }));
                        if (this.options.navbuttoncolor) z.css({
                            "background-color": this.options.navbuttoncolor
                        });
                        if (this.options.navarrowimage) z.css({
                            "background-image": "url('" + this.options.navarrowimage + "')",
                            "background-repeat": "no-repeat",
                            "background-position": "left top"
                        });
                        z.hover(function() {
                            if (s.options.navbuttonhighlightcolor) P(this).css({
                                "background-color": s.options.navbuttonhighlightcolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "left bottom"
                            })
                        }, function() {
                            if (s.options.navbuttoncolor) P(this).css({
                                "background-color": s.options.navbuttoncolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "left top"
                            })
                        });
                        z.click(function() {
                            s.videoAutoplayMode = false;
                            s.slideRun(-2)
                        });
                        k = this.options.navspacing
                    }
                    if (this.options.navshowplaypause) {
                        var A, E;
                        if (this.options.navshowplaypausestandalone) {
                            A = P("<div class='amazingslider-nav-play-" + this.id + "' style='position:absolute;width:" + this.options.navshowplaypausestandalonewidth + "px;height:" + this.options.navshowplaypausestandaloneheight + "px;'></div>");
                            this.$wrapper.append(A);
                            E = P("<div class='amazingslider-nav-pause-" + this.id + "' style='position:absolute;width:" + this.options.navshowplaypausestandalonewidth + "px;height:" + this.options.navshowplaypausestandaloneheight + "px;'></div>");
                            this.$wrapper.append(E);
                            switch (this.options.navshowplaypausestandaloneposition) {
                                case "topleft":
                                    A.css({
                                        top: 0,
                                        left: 0,
                                        "margin-left": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-top": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    E.css({
                                        top: 0,
                                        left: 0,
                                        "margin-left": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-top": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    break;
                                case "topright":
                                    A.css({
                                        top: 0,
                                        right: 0,
                                        "margin-right": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-top": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    E.css({
                                        top: 0,
                                        right: 0,
                                        "margin-right": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-top": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    break;
                                case "bottomleft":
                                    A.css({
                                        bottom: 0,
                                        left: 0,
                                        "margin-left": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-bottom": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    E.css({
                                        bottom: 0,
                                        left: 0,
                                        "margin-left": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-bottom": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    break;
                                case "bottomright":
                                    A.css({
                                        bottom: 0,
                                        right: 0,
                                        "margin-right": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-bottom": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    E.css({
                                        bottom: 0,
                                        right: 0,
                                        "margin-right": this.options.navshowplaypausestandalonemarginx + "px",
                                        "margin-bottom": this.options.navshowplaypausestandalonemarginy + "px"
                                    });
                                    break;
                                case "center":
                                    A.css({
                                        top: "50%",
                                        left: "50%",
                                        "margin-left": "-" + Math.round(this.options.navshowplaypausestandalonewidth / 2) + "px",
                                        "margin-top": "-" + Math.round(this.options.navshowplaypausestandaloneheight / 2) + "px"
                                    });
                                    E.css({
                                        top: "50%",
                                        left: "50%",
                                        "margin-left": "-" + Math.round(this.options.navshowplaypausestandalonewidth / 2) + "px",
                                        "margin-top": "-" + Math.round(this.options.navshowplaypausestandaloneheight / 2) + "px"
                                    });
                                    break
                            }
                        } else {
                            A = P("<div class='amazingslider-nav-play-" + this.id + "' style='position:relative;float:" + y + ";margin-" + y + ":" + k + "px;width:" + this.options.navwidth + "px;height:" + this.options.navheight + "px;cursor:pointer;'></div>");
                            a.append(A);
                            E = P("<div class='amazingslider-nav-pause-" + this.id + "' style='position:relative;float:" + y + ";margin-" + y + ":" + k + "px;width:" + this.options.navwidth + "px;height:" + this.options.navheight + "px;cursor:pointer;'></div>");
                            a.append(E)
                        }
                        if (this.options.navbuttonradius) A.css(az_.applyBrowserStyles({
                            "border-radius": this.options.navbuttonradius + "px"
                        }));
                        if (this.options.navbuttoncolor) A.css({
                            "background-color": this.options.navbuttoncolor
                        });
                        if (this.options.navarrowimage) A.css({
                            "background-image": "url('" + this.options.navplaypauseimage + "')",
                            "background-repeat": "no-repeat",
                            "background-position": "left top"
                        });
                        A.hover(function() {
                            if (s.options.navbuttonhighlightcolor) P(this).css({
                                "background-color": s.options.navbuttonhighlightcolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "left bottom"
                            })
                        }, function() {
                            if (s.options.navbuttoncolor) P(this).css({
                                "background-color": s.options.navbuttoncolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "left top"
                            })
                        });
                        A.click(function() {
                            s.isPaused = false;
                            s.loopCount = 0;
                            if (!s.videoPaused) s.sliderTimeout.start();
                            P(this).css({
                                display: "none"
                            });
                            P(".amazingslider-nav-pause-" + s.id, s.container).css({
                                display: "block"
                            })
                        });
                        if (this.options.navbuttonradius) E.css(az_.applyBrowserStyles({
                            "border-radius": this.options.navbuttonradius + "px"
                        }));
                        if (this.options.navbuttoncolor) E.css({
                            "background-color": this.options.navbuttoncolor
                        });
                        if (this.options.navarrowimage) E.css({
                            "background-image": "url('" + this.options.navplaypauseimage + "')",
                            "background-repeat": "no-repeat",
                            "background-position": "right top"
                        });
                        E.hover(function() {
                            if (s.options.navbuttonhighlightcolor) P(this).css({
                                "background-color": s.options.navbuttonhighlightcolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "right bottom"
                            })
                        }, function() {
                            if (s.options.navbuttoncolor) P(this).css({
                                "background-color": s.options.navbuttoncolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "right top"
                            })
                        });
                        E.click(function() {
                            s.isPaused = true;
                            s.sliderTimeout.stop();
                            P(this).css({
                                display: "none"
                            });
                            P(".amazingslider-nav-play-" + s.id, s.container).css({
                                display: "block"
                            })
                        });
                        if (this.options.navshowplaypausestandalone && this.options.navshowplaypausestandaloneautohide) {
                            A.css({
                                display: "none"
                            });
                            E.css({
                                display: "none"
                            });
                            this.$wrapper.hover(function() {
                                if (s.isPaused) {
                                    A.fadeIn();
                                    E.css({
                                        display: "none"
                                    })
                                } else {
                                    A.css({
                                        display: "none"
                                    });
                                    E.fadeIn()
                                }
                            }, function() {
                                A.fadeOut();
                                E.fadeOut()
                            })
                        } else {
                            A.css({
                                display: s.isPaused ? "block" : "none"
                            });
                            E.css({
                                display: s.isPaused ? "none" : "block"
                            })
                        }
                    }
                    if (this.options.navshowarrow) {
                        var I = P("<div class='amazingslider-nav-right-" + this.id + "' style='position:relative;float:" + y + ";margin-" + y + ":" + k + "px;width:" + this.options.navwidth + "px;height:" + this.options.navheight + "px;cursor:pointer;'></div>");
                        a.append(I);
                        if (this.options.navbuttonradius) I.css(az_.applyBrowserStyles({
                            "border-radius": this.options.navbuttonradius + "px"
                        }));
                        if (this.options.navbuttoncolor) I.css({
                            "background-color": this.options.navbuttoncolor
                        });
                        if (this.options.navarrowimage) I.css({
                            "background-image": "url('" + this.options.navarrowimage + "')",
                            "background-repeat": "no-repeat",
                            "background-position": "right top"
                        });
                        I.hover(function() {
                            if (s.options.navbuttonhighlightcolor) P(this).css({
                                "background-color": s.options.navbuttonhighlightcolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "right bottom"
                            })
                        }, function() {
                            if (s.options.navbuttoncolor) P(this).css({
                                "background-color": s.options.navbuttoncolor
                            });
                            if (s.options.navarrowimage) P(this).css({
                                "background-position": "right top"
                            })
                        });
                        I.click(function() {
                            s.videoAutoplayMode = false;
                            s.slideRun(-1)
                        })
                    }
                }
            },
            productZoomImage: function() {
                var i = this;
                if (window.innerWidth > 750) {
                    P(".amazingslider-img-box-" + this.id).click(function(t) {
                        if (t.currentTarget.hasAttribute("no_zoom") == true) return;
                        t.preventDefault();
                        if (P(".amazingslider-img-elem-" + i.id).length > 0) {
                            P("#zoom-modal img:eq(0)").attr("src", P(".amazingslider-img-elem-" + i.id).attr("src"));
                            P("#zoom-modal img:eq(0)").show();
                            P("#zoom-modal video:eq(0)").hide();
                            P("body").css("overflow", "hidden");
                            P("body").css("paddingRight", "17px")
                        } else {
                            P("#zoom-modal video:eq(0)").attr("src", P(".amazingslider-video-elem-" + i.id).attr("src"));
                            P("#zoom-modal img:eq(0)").hide();
                            P("#zoom-modal video:eq(0)").show();
                            P("body").css("overflow", "hidden");
                            P("body").css("paddingRight", "17px")
                        }
                        P("#zoom-modal").css("display", "block")
                    })
                }
            },
            resizeNavBullets: function() {
                if (this.options.navstyle != "thumbnails" || !this.options.navthumbresponsive) return;
                this.calcNavThumbSize();
                this.options.navimagewidth = this.options.navwidth - this.options.navborder * 2;
                this.options.navimageheight = this.options.navheight - this.options.navborder * 2;
                if (this.options.navthumbstyle == "imageandtitle") this.options.navheight += this.options.navthumbtitleheight;
                else if (this.options.navthumbstyle == "imageandtitledescription" || this.options.navthumbstyle == "textonly") this.options.navwidth += this.options.navthumbtitlewidth;
                var e = this;
                P(".amazingslider-bullet-" + this.id, this.container).each(function() {
                    var t = P(this).data("originalthumbwidth");
                    var i = P(this).data("originalthumbheight");
                    P(this).css({
                        width: String(e.options.navwidth) + "px",
                        height: String(e.options.navheight) + "px"
                    });
                    if (e.options.navthumbstyle != "textonly") {
                        P(".amazingslider-bullet-image-" + e.id, this).css({
                            width: e.options.navimagewidth + "px",
                            height: e.options.navimageheight + "px"
                        });
                        if (t / i <= e.options.navimagewidth / e.options.navimageheight) P(".amazingslider-bullet-img-" + e.id, this).css({
                            width: "100%",
                            height: "auto",
                            "margin-top": "-" + Math.floor(i / t * e.options.navimagewidth / 2 - e.options.navimageheight / 2) + "px"
                        });
                        else P(".amazingslider-bullet-img-" + e.id, this).css({
                            width: "auto",
                            height: "100%",
                            "margin-left": "-" + Math.floor(t / i * e.options.navimageheight / 2 - e.options.navimagewidth / 2) + "px"
                        })
                    }
                    if (e.options.navthumbstyle != "imageonly")
                        if (e.options.navthumbstyle == "imageandtitle") P(".amazingslider-bullet-text-" + e.id, this).css({
                            "margin-top": e.options.navimageheight + "px",
                            width: e.options.navimagewidth + "px",
                            height: e.options.navthumbtitleheight + "px"
                        });
                        else if (e.options.navthumbstyle == "imageandtitledescription") P(".amazingslider-bullet-text-" + e.id, this).css({
                        "margin-left": e.options.navimagewidth + "px",
                        width: e.options.navthumbtitlewidth + "px",
                        height: e.options.navimageheight + "px"
                    });
                    else if (e.options.navthumbstyle == "textonly") P(".amazingslider-bullet-text-" + e.id, this).css({
                        width: String(e.options.navthumbtitlewidth + e.options.navimagewidth) + "px",
                        height: e.options.navimageheight + "px"
                    })
                })
            },
            createNavBullet: function(e) {
                var f = this;
                var t = this.options.navdirection == "vertical" ? "top" : "left";
                var i = this.options.navdirection == "vertical" ? "bottom" : "right";
                var o = e == this.elemArray.length - 1 ? 0 : this.options.navspacing;
                var s = this.options.navstyle == "thumbnails" ? this.options.navwidth : this.options.navwidth;
                var n = this.options.navstyle == "thumbnails" ? this.options.navheight : this.options.navheight;
                var a = this.options.navdirection == "horizontal" && this.options.navmultirows ? "margin-bottom:" + this.options.navrowspacing + "px;" : "";
                var r = P("<div class='amazingslider-bullet-" + this.id + "' id='amazingslider-bullet-" + this.id + "-" + e + "' style='position:relative;float:" + t + ";" + a + "margin-" + i + ":" + o + "px;width:" + s + "px;height:" + n + "px;cursor:pointer;'></div>");
                r.data("index", e);
                r.hover(function() {
                    if (P(this).data("index") != f.curElem) P(this)["bulletHighlight" + f.id]();
                    var o = P(this).data("index");
                    if (f.options.navswitchonmouseover)
                        if (o != f.curElem) f.slideRun(o);
                    if (f.options.navshowpreview) {
                        var s = P(".amazingslider-nav-preview-" + f.id, f.container);
                        var n = P(".amazingslider-nav-preview-images-" + f.id, s);
                        if (f.options.navshowplayvideo) {
                            var t = P(".amazingslider-nav-preview-play-" + f.id, s);
                            if (f.elemArray[o][x].length > 0 || f.elemArray[o][v] && f.elemArray[o][A] && f.elemArray[o][I] > 0) t.show();
                            else t.hide()
                        }
                        var i = P(".amazingslider-nav-" + f.id, f.container);
                        var e = P(".amazingslider-bullet-wrapper-" + f.id, f.container);
                        var a = P(this).position();
                        var r = i.position();
                        var l = e.position();
                        a.left += r.left + l.left;
                        a.left += isNaN(parseInt(e.css("margin-left"))) ? 0 : parseInt(e.css("margin-left"));
                        a.left += isNaN(parseInt(i.css("margin-left"))) ? 0 : parseInt(i.css("margin-left"));
                        a.top += r.top + l.top;
                        a.top += isNaN(parseInt(e.css("margin-top"))) ? 0 : parseInt(e.css("margin-top"));
                        a.top += isNaN(parseInt(i.css("margin-top"))) ? 0 : parseInt(i.css("margin-top"));
                        if (f.options.navdirection == "vertical") {
                            var h = P(".amazingslider-nav-container-" + f.id, f.container);
                            a.top += isNaN(parseInt(h.css("margin-top"))) ? 0 : parseInt(h.css("margin-top"))
                        }
                        var p, d = a.left + f.options.navwidth / 2 - f.options.navpreviewwidth / 2 - f.options.navpreviewborder;
                        var c, m = a.top + f.options.navheight / 2 - f.options.navpreviewheight / 2 - f.options.navpreviewborder;
                        var u = {};
                        switch (f.options.navpreviewposition) {
                            case "bottom":
                                p = a.top + f.options.navheight + f.options.navpreviewarrowheight;
                                u = {
                                    left: d + "px",
                                    top: p + "px"
                                };
                                break;
                            case "top":
                                p = a.top - f.options.navpreviewheight - 2 * f.options.navpreviewborder - f.options.navpreviewarrowheight;
                                u = {
                                    left: d + "px",
                                    top: p + "px"
                                };
                                break;
                            case "left":
                                c = a.left - f.options.navpreviewwidth - 2 * f.options.navpreviewborder - f.options.navpreviewarrowwidth;
                                u = {
                                    left: c + "px",
                                    top: m + "px"
                                };
                                break;
                            case "right":
                                c = a.left + f.options.navwidth + f.options.navpreviewarrowwidth;
                                u = {
                                    left: c + "px",
                                    top: m + "px"
                                };
                                break
                        }
                        var g = new Image;
                        P(g).on("load", function() {
                            var t;
                            if (this.width / this.height <= f.options.navpreviewwidth / f.options.navpreviewheight) t = "width:" + f.options.navpreviewwidth + "px;max-width:" + f.options.navpreviewwidth + "px;height:auto;margin-top:-" + Math.floor(this.height / this.width * f.options.navpreviewwidth / 2 - f.options.navpreviewheight / 2) + "px;";
                            else t = "width:auto;max-width:none;height:" + f.options.navpreviewheight + "px;margin-left:-" + Math.floor(this.width / this.height * f.options.navpreviewheight / 2 - f.options.navpreviewwidth / 2) + "px;";
                            var i = P(".amazingslider-nav-preview-img-" + f.id, n);
                            if (f.options.navdirection == "vertical") {
                                var e = P("<div class='amazingslider-nav-preview-img-" + f.id + "' style='display:block;position:absolute;overflow:hidden;width:" + f.options.navpreviewwidth + "px;height:" + f.options.navpreviewheight + "px;left:0px;top:" + f.options.navpreviewheight + "px;'><img class='amazingslider-preview-elem' alt='" + f.elemArray[o][M] + "' src='" + f.elemArray[o][y] + "' style='display:block;position:absolute;left:0px;top:0px;" + t + "' /></div>");
                                n.append(e);
                                if (i.length > 0) i.animate({
                                    top: "-" + f.options.navpreviewheight + "px"
                                }, function() {
                                    i.remove()
                                });
                                if (s.is(":visible")) {
                                    e.animate({
                                        top: "0px"
                                    });
                                    s.stop(true, true).animate(u)
                                } else {
                                    e.css({
                                        top: "0px"
                                    });
                                    s.stop(true, true).css(u).fadeIn()
                                }
                            } else {
                                var e = P("<div class='amazingslider-nav-preview-img-" + f.id + "' style='display:block;position:absolute;overflow:hidden;width:" + f.options.navpreviewwidth + "px;height:" + f.options.navpreviewheight + "px;left:" + f.options.navpreviewheight + "px;top:0px;'><img class='amazingslider-preview-elem' alt='" + f.elemArray[o][M] + "' src='" + f.elemArray[o][y] + "' style='display:block;position:absolute;left:0px;top:0px;" + t + "' /></div>");
                                n.append(e);
                                if (i.length > 0) i.animate({
                                    left: "-" + f.options.navpreviewwidth + "px"
                                }, function() {
                                    i.remove()
                                });
                                if (s.is(":visible")) {
                                    e.animate({
                                        left: "0px"
                                    });
                                    s.stop(true, true).animate(u)
                                } else {
                                    e.css({
                                        left: "0px"
                                    });
                                    s.stop(true, true).css(u).fadeIn()
                                }
                            }
                        });
                        g.src = f.elemArray[o][y]
                    }
                }, function() {
                    if (P(this).data("index") != f.curElem) P(this)["bulletNormal" + f.id]();
                    if (f.options.navshowpreview) {
                        var t = P(".amazingslider-nav-preview-" + f.id, f.container);
                        t.delay(500).fadeOut()
                    }
                });
                r.click(function() {
                    f.videoAutoplayMode = false;
                    f.slideRun(P(this).data("index"), f.options.playvideoonclickthumb)
                });
                if (this.options.navstyle == "bullets") {
                    r.css({
                        background: "url('" + this.options.navimage + "') no-repeat left top"
                    });
                    P.fn["bulletNormal" + this.id] = function() {
                        P(this).css({
                            "background-position": "left top"
                        })
                    };
                    P.fn["bulletHighlight" + this.id] = function() {
                        P(this).css({
                            "background-position": "left bottom"
                        })
                    };
                    P.fn["bulletSelected" + this.id] = function() {
                        P(this).css({
                            "background-position": "left bottom"
                        });
                        f.adjustNav(this)
                    }
                } else if (this.options.navstyle == "numbering") {
                    r.text(e + 1);
                    r.css({
                        "background-color": this.options.navcolor,
                        color: this.options.navfontcolor,
                        "font-size": this.options.navfontsize,
                        "font-family": this.options.navfont,
                        "text-align": "center",
                        "line-height": this.options.navheight + "px"
                    });
                    r.css(az_.applyBrowserStyles({
                        "border-radius": this.options.navradius + "px"
                    }));
                    if (this.options.navbuttonshowbgimage && this.options.navbuttonbgimage) r.css({
                        background: "url('" + this.options.navbuttonbgimage + "') no-repeat center top"
                    });
                    P.fn["bulletNormal" + this.id] = function() {
                        P(this).css({
                            "background-color": f.options.navcolor,
                            color: f.options.navfontcolor
                        });
                        if (f.options.navbuttonshowbgimage && f.options.navbuttonbgimage) P(this).css({
                            "background-position": "center top"
                        })
                    };
                    P.fn["bulletHighlight" + this.id] = function() {
                        P(this).css({
                            "background-color": f.options.navhighlightcolor,
                            color: f.options.navfonthighlightcolor
                        });
                        if (f.options.navbuttonshowbgimage && f.options.navbuttonbgimage) P(this).css({
                            "background-position": "center bottom"
                        })
                    };
                    P.fn["bulletSelected" + this.id] = function() {
                        P(this).css({
                            "background-color": f.options.navhighlightcolor,
                            color: f.options.navfonthighlightcolor
                        });
                        if (f.options.navbuttonshowbgimage && f.options.navbuttonbgimage) P(this).css({
                            "background-position": "center bottom"
                        });
                        f.adjustNav(this)
                    }
                } else if (this.options.navstyle == "thumbnails") {
                    r.css({
                        padding: this.options.navborder + "px",
                        "background-color": this.options.navbordercolor
                    });
                    r.css({
                        opacity: this.options.navopacity,
                        filter: "alpha(opacity=" + Math.round(100 * this.options.navopacity) + ")"
                    });
                    var l = new Image;
                    var f = this;
                    P(l).on("load", function() {
                        r.data("originalthumbwidth", this.width);
                        r.data("originalthumbheight", this.height);
                        if (f.options.navthumbstyle != "textonly") {
                            var t;
                            if (this.width / this.height <= f.options.navimagewidth / f.options.navimageheight) t = "max-width:none;width:100%;height:auto;margin-top:-" + Math.floor(this.height / this.width * f.options.navimagewidth / 2 - f.options.navimageheight / 2) + "px";
                            else t = "max-width:none;width:auto;height:100%;margin-left:-" + Math.floor(this.width / this.height * f.options.navimageheight / 2 - f.options.navimagewidth / 2) + "px";
                            r.append("<div class='amazingslider-bullet-image-" + f.id + "' style='display:block;position:absolute;width:" + f.options.navimagewidth + "px;height:" + f.options.navimageheight + "px;overflow:hidden;'><img alt='" + f.elemArray[e][M] + "' class='amazingslider-thumbnail-elem amazingslider-bullet-img-" + f.id + "' src='" + f.elemArray[e][y] + "' style='" + t + "' /></div>");
                            if (f.options.navshowplayvideo && (f.elemArray[e][x].length > 0 || f.elemArray[e][v] && f.elemArray[e][A] && f.elemArray[e][I] > 0)) r.append("<div class='amazingslider-bullet-playvideo-" + f.id + "' style='display:block;position:absolute;width:32px;margin:auto;top:0;left:0;right:0;bottom:0;/*width:" + f.options.navimagewidth + "px;height:" + f.options.navimageheight + "px;*/" + 'background:url("' + f.options.navplayvideoimage + '") no-repeat center center;background-size:contain;' + "' ></div>")
                        }
                        if (f.options.navthumbstyle != "imageonly") {
                            var i = "<div class='amazingslider-bullet-text-" + f.id + "' style='display:block;position:absolute;overflow:hidden;";
                            if (f.options.navthumbstyle == "imageandtitle") i += "margin-left:0px;margin-top:" + f.options.navimageheight + "px;width:" + f.options.navimagewidth + "px;height:" + f.options.navthumbtitleheight + "px;";
                            else if (f.options.navthumbstyle == "imageandtitledescription") i += "margin-left:" + f.options.navimagewidth + "px;margin-top:0px;width:" + f.options.navthumbtitlewidth + "px;height:" + f.options.navimageheight + "px;";
                            else if (f.options.navthumbstyle == "textonly") i += "margin-left:0px;margin-top:0px;width:" + String(f.options.navthumbtitlewidth + f.options.navimagewidth) + "px;height:" + f.options.navimageheight + "px;";
                            i += "'><div class='amazingslider-nav-thumbnail-tite-" + f.id + "'>" + f.elemArray[e][k] + "</div>";
                            if (f.options.navthumbstyle == "imageandtitledescription" || f.options.navthumbstyle == "textonly") i += "<div class='amazingslider-nav-thumbnail-description-" + f.id + "'>" + f.elemArray[e][z] + "</div>";
                            i += "</div>";
                            r.append(i)
                        }
                    });
                    l.src = this.elemArray[e][y];
                    P.fn["bulletNormal" + this.id] = function() {
                        P(this).css({
                            opacity: f.options.navopacity,
                            filter: "alpha(opacity=" + Math.round(100 * f.options.navopacity) + ")"
                        });
                        P(this).removeClass("amazingslider-bullet-selected").removeClass("amazingslider-bullet-highlighted");
                        if (f.options.navbordercolor) P(this).css({
                            "background-color": f.options.navbordercolor
                        })
                    };
                    P.fn["bulletHighlight" + this.id] = function() {
                        P(this).css({
                            opacity: 1,
                            filter: "alpha(opacity=100)"
                        });
                        if (f.options.navborderhighlightcolor) P(this).css({
                            "background-color": f.options.navborderhighlightcolor
                        });
                        P(this).removeClass("amazingslider-bullet-selected").addClass("amazingslider-bullet-highlighted")
                    };
                    P.fn["bulletSelected" + this.id] = function() {
                        P(this).css({
                            opacity: 1,
                            filter: "alpha(opacity=100)"
                        });
                        if (f.options.navborderhighlightcolor) P(this).css({
                            "background-color": f.options.navborderhighlightcolor
                        });
                        P(this).removeClass("amazingslider-bullet-highlighted").addClass("amazingslider-bullet-selected");
                        f.adjustNav(this)
                    }
                }
                return r
            },
            adjustNav: function(t) {
                var i = this;
                var e = P(t).position();
                var o = P(".amazingslider-nav-container-" + i.id, i.container);
                var s = P(".amazingslider-bullet-wrapper-" + i.id, i.container);
                if (i.options.navdirection == "horizontal") {
                    var n, a = e.left + i.options.navwidth / 2 - i.options.navfeaturedarrowimagewidth / 2;
                    if (i.options.navposition == "top" || i.options.navposition == "topleft" || i.options.navposition == "topright") n = e.top + i.options.navheight;
                    else n = e.top - i.options.navfeaturedarrowimageheight;
                    if (i.options.navshowfeaturedarrow) {
                        var r = P(".amazingslider-nav-featuredarrow-" + i.id, i.container);
                        r.css({
                            top: n + "px"
                        });
                        if (r.is(":visible")) r.stop(true, true).animate({
                            left: a + "px"
                        });
                        else r.css({
                            display: "block",
                            left: a + "px"
                        })
                    }
                    if (o.width() < s.width() && !i.pauseCarousel) {
                        var l = Math.abs(isNaN(parseInt(s.css("margin-left"))) ? 0 : parseInt(s.css("margin-left")));
                        if (e.left < l || e.left + i.options.navwidth > l + o.width()) {
                            var h = -e.left;
                            if (h <= o.width() - s.width()) h = o.width() - s.width();
                            if (h >= 0) h = 0;
                            s.animate({
                                "margin-left": h + "px"
                            }, {
                                queue: false,
                                duration: 500,
                                easing: "easeOutCirc"
                            });
                            i.updateCarouselLeftRightArrow(h)
                        }
                    }
                } else {
                    var a, n = e.top + i.options.navheight / 2 - i.options.navfeaturedarrowimageheight / 2;
                    if (i.options.navposition == "left") a = e.left + i.options.navwidth;
                    else a = e.left - i.options.navfeaturedarrowimagewidth;
                    a++;
                    if (i.options.navshowfeaturedarrow) {
                        var r = P(".amazingslider-nav-featuredarrow-" + i.id, i.container);
                        r.css({
                            left: a + "px"
                        });
                        if (r.is(":visible")) r.stop(true, true).animate({
                            top: n + "px"
                        });
                        else r.css({
                            display: "block",
                            top: n + "px"
                        })
                    }
                    if (o.height() < s.height() && !i.pauseCarousel) {
                        var l = Math.abs(isNaN(parseInt(s.css("margin-top"))) ? 0 : parseInt(s.css("margin-top")));
                        if (e.top < l || e.top + i.options.navheight > l + o.height()) {
                            var h = -e.top;
                            if (h <= o.height() - s.height()) h = o.height() - s.height();
                            if (h >= 0) h = 0;
                            s.animate({
                                "margin-top": h + "px"
                            }, {
                                queue: false,
                                duration: 500,
                                easing: "easeOutCirc"
                            });
                            i.updateCarouselLeftRightArrow(h)
                        }
                    }
                }
            },
            slideRun: function(t, i, e) {
                savedCur = this.curElem;
                this.calcIndex(t);
                if (savedCur == this.curElem && !(this.elemArray[this.curElem][x].length > 0 && i)) return;
                if (savedCur >= 0) this.container.removeClass("amazingslider-activeslide-" + this.id + "-" + savedCur);
                this.container.addClass("amazingslider-activeslide-" + this.id + "-" + this.curElem);
                if (this.isAnimating) {
                    if (this.transitionTimeout) clearTimeout(this.transitionTimeout);
                    P(".amazingslider-img-box-" + this.id, this.container).off("transitionFinished");
                    var o = "<div class='amazingslider-img-" + this.id + " ' style='display:block;position:absolute;left:0px;top:0px;width:100%;height:100%;overflow:hidden;'>";
                    o += "<img alt='" + this.elemArray[savedCur][M] + "' style='position:absolute;";
                    if (Math.abs(this.curImageMarginLeft) > 0) o += "max-width:" + this.curImageMaxWidth + "%;width:" + this.curImageMaxWidth + "%;height:100%;left:0%;top:0%;margin-left:" + this.curImageMarginLeft + "%";
                    else o += "max-width:" + this.curImageMaxWidth + "%;width:" + this.curImageMaxWidth + "%;height:auto;left:0%;top:0%;margin-top:" + this.curImageMarginTop + "%;";
                    if (this.options.borderradius > 0) o += "border-radius:" + this.options.borderradius + "px;-moz-border-radius:" + this.options.borderradius + "px;-webkit-border-radius:" + this.options.borderradius + "px;";
                    o += "' src='" + this.elemArray[savedCur][m] + "' /></div>";
                    P(".amazingslider-img-box-" + this.id, this.container).html(o);
                    this.isAnimating = false
                }
                var s = this.elemArray[this.curElem][l];
                if (s && s.length > 0 && "textformat" in this.options && s in this.options["textformat"]) this.textoptions = P.ASUpdateObject(this.textoptions, this.options["textformat"][s]);
                else this.textoptions = P.ASUpdateObject(this.textoptions, this.options);
                this.sliderTimeout.stop();
                this.sliderTimeout.timeout = this.elemArray[this.curElem][h] > 0 ? this.elemArray[this.curElem][h] : this.options.slideinterval;
                this.videoPaused = false;
                this.container.trigger("amazingslider.switch", [savedCur, this.curElem]);
                P(".amazingslider-video-wrapper-" + this.id, this.container).find("iframe").each(function() {
                    P(this).attr("src", "")
                });
                P(".amazingslider-video-wrapper-" + this.id, this.container).find("video").each(function() {
                    P(this).attr("src", "")
                });
                this.container.trigger("amazingslider.switchtext", [savedCur, this.curElem]);
                if ((i || this.options.autoplayvideo) && this.elemArray[this.curElem][x].length > 0) this.playVideo(true);
                else if (!this.elemArray[this.curElem][m] && this.elemArray[this.curElem][x].length > 0) this.playVideo(this.options.autoplayvideo);
                else {
                    P(".amazingslider-video-wrapper-" + this.id, this.container).css({
                        display: "none"
                    }).empty();
                    var n = true;
                    if (t == -2) n = false;
                    else if (t == -1) n = true;
                    else if (t >= 0) n = this.curElem > savedCur ? true : false;
                    this.showImage(n, e)
                }
                if (this.options.preloadprevnext) {
                    (new Image).src = this.elemArray[this.prevElem][m];
                    (new Image).src = this.elemArray[this.nextElem][m]
                }
                if (this.options.loop > 0)
                    if (this.curElem == this.elemArray.length - 1) {
                        this.loopCount++;
                        if (this.options.loop <= this.loopCount) this.isPaused = true
                    }
            },
            showImage: function(h, p) {
                var d = this;
                var t = new Image;
                P(t).on("load", function() {
                    var t = P(".amazingslider-img-box-" + d.id, d.container);
                    var i = P(".amazingslider-img-" + d.id, d.container);
                    var e = "<div class='amazingslider-img-" + d.id + "' style='display:block;position:absolute;left:0px;top:0px;width:100%;height:100%;overflow:hidden;'>";
                    e += "<img " + d.elemArray[d.curElem][g] + " alt='" + d.elemArray[d.curElem][M] + "' class='amazingsliderimg amazingslider-img-elem amazingslider-img-elem-" + d.id + "' data-originalwidth='" + this.width + "' data-originalheight='" + this.height + "' style='position:absolute;" + (az_.isIE678() ? "opacity:inherit;filter:inherit;" : "");
                    var o = d.options.height / d.options.width;
                    var s = this.height / this.width;
                    d.prevImageMarginTop = d.curImageMarginTop;
                    d.prevImageMarginLeft = d.curImageMarginLeft;
                    d.prevImageMaxWidth = d.curImageMaxWidth;
                    d.curImageMarginTop = 0;
                    d.curImageMarginLeft = 0;
                    d.curImageMaxWidth = 100;
                    if (d.options.scalemode == "flexheight") {
                        d.options.flexratio = s;
                        d.options.height = d.options.width * s;
                        P(".amazingslider-space-" + d.id, d.container).css({
                            height: d.options.height
                        });
                        d.container.css({
                            height: d.options.navdirection == "horizontal" && d.options.navmultirows ? "auto" : d.options.height
                        })
                    } else if (o < s)
                        if (d.options.scalemode == "fit") {
                            d.curImageMaxWidth = o / s * 100;
                            d.curImageMarginLeft = 50 - d.curImageMaxWidth / 2
                        } else d.curImageMarginTop = -1 * (s - o) * 50;
                    else if (d.options.scalemode == "fit") d.curImageMarginTop = (o - s) * 50;
                    else {
                        d.curImageMarginLeft = (1 / o - 1 / s) * o * 50;
                        d.curImageMaxWidth = 100 - 2 * d.curImageMarginLeft
                    }
                    if (Math.abs(d.curImageMarginLeft) > 0) e += "max-width:" + d.curImageMaxWidth + "%;width:" + d.curImageMaxWidth + "%;height:100%;left:0%;top:0%;margin-left:" + d.curImageMarginLeft + "%";
                    else e += "max-width:" + d.curImageMaxWidth + "%;width:" + d.curImageMaxWidth + "%;height:auto;left:0%;top:0%;margin-top:" + d.curImageMarginTop + "%;";
                    if (d.options.borderradius > 0) e += "border-radius:" + d.options.borderradius + "px;-moz-border-radius:" + d.options.borderradius + "px;-webkit-border-radius:" + d.options.borderradius + "px;";
                    e += "' src='" + d.elemArray[d.curElem][m] + "' />";
                    e += "</div>";
                    var n = P(e);
                    if (i.length > 0) i.before(n);
                    else t.append(n);
                    var a = d.firstslide && !d.options.transitiononfirstslide ? "" : d.options.transition;
                    if (p && p in d.options) a = p;
                    d.firstslide = false;
                    d.isAnimating = true;
                    t.amazingsliderTransition(d.id, i, n, {
                        effect: a,
                        direction: h,
                        duration: d.options.transitionduration,
                        easing: d.options.transitioneasing,
                        imgmarginleft: d.curImageMarginLeft,
                        imgmargintop: d.curImageMarginTop,
                        imgmaxwidth: d.curImageMaxWidth,
                        previmgmarginleft: d.prevImageMarginLeft,
                        previmgmargintop: d.prevImageMarginTop,
                        previmgmaxwidth: d.prevImageMaxWidth,
                        crossfade: d.options.crossfade,
                        fadeoutfadein: d.options.fadeoutfadein,
                        kenburns: d.options.kenburns,
                        fade: d.options.fade,
                        slide: d.options.slide,
                        cssslide: d.options.cssslide,
                        elastic: d.options.elastic,
                        slice: d.options.slice,
                        flip: d.options.flip,
                        flipwithzoom: d.options.flipwithzoom,
                        blinds: d.options.blinds,
                        threed: d.options.threed,
                        threedwithzoom: d.options.threedwithzoom,
                        threedhorizontal: d.options.threedhorizontal,
                        threedhorizontalwithzoom: d.options.threedhorizontalwithzoom,
                        blocks: d.options.blocks,
                        threedtiles: d.options.threedtiles,
                        tiles: d.options.tiles,
                        shuffle: d.options.shuffle,
                        threedflip: d.options.threedflip,
                        threedflipwithzoom: d.options.threedflipwithzoom
                    }, function() {
                        d.isAnimating = false;
                        if (!d.isPausedOnMouseover) d.sliderTimeout.resume(true);
                        else d.sliderTimeout.unsetstartandpause()
                    }, function(t) {
                        d.transitionTimeout = t;
                        if (!d.isPaused && !d.videoPaused && d.elemArray.length > 1) d.sliderTimeout.startandpause()
                    });
                    var r = P(".amazingslider-swipe-box-" + d.id, d.container);
                    if (d.elemArray[d.curElem][v]) {
                        r.css({
                            cursor: "pointer"
                        });
                        r.off("click").on("click", function() {
                            if (d.elemArray[d.curElem][A]) {
                                P(window).trigger("amazingslider.lightboxclicked", [d.options.sliderid, d.elemArray[d.curElem][c], d.elemArray[d.curElem][m], d.elemArray[d.curElem][k], d.elemArray[d.curElem][v]]);
                                if (!d.isPaused) {
                                    d.lightboxPaused = true;
                                    d.isPaused = true;
                                    d.sliderTimeout.pause()
                                }
                                d.html5Lightbox.showItem(d.elemArray[d.curElem][v])
                            } else {
                                P(window).trigger("amazingslider.linkclicked", [d.options.sliderid, d.elemArray[d.curElem][c], d.elemArray[d.curElem][m], d.elemArray[d.curElem][k], d.elemArray[d.curElem][v]]);
                                var t = d.elemArray[d.curElem][u] ? d.elemArray[d.curElem][u] : "_self";
                                window.open(d.elemArray[d.curElem][v], t)
                            }
                        })
                    } else {
                        r.css({
                            cursor: ""
                        });
                        r.off("click")
                    }
                    var l = d.elemArray[d.curElem][v] && d.elemArray[d.curElem][A] && d.elemArray[d.curElem][I] > 0;
                    P(".amazingslider-lightbox-play-" + d.id, d.container).css({
                        display: l ? "block" : "none"
                    });
                    P(".amazingslider-play-" + d.id, d.container).css({
                        display: d.elemArray[d.curElem][x].length > 0 ? "block" : "none"
                    })
                }).on("error", function() {
                    if (!d.isPaused && !d.videoPaused && d.elemArray.length > 1) d.sliderTimeout.start()
                });
                t.src = this.elemArray[this.curElem][m]
            },
            calcIndex: function(t) {
                var i;
                if (t == -2) {
                    this.nextElem = this.curElem;
                    this.curElem = this.prevElem;
                    this.prevElem = this.curElem - 1 < 0 ? this.elemArray.length - 1 : this.curElem - 1
                } else if (t == -1) {
                    this.prevElem = this.curElem;
                    this.curElem = this.nextElem;
                    this.nextElem = this.curElem + 1 >= this.elemArray.length ? 0 : this.curElem + 1
                } else if (t >= 0) {
                    this.curElem = t;
                    this.prevElem = this.curElem - 1 < 0 ? this.elemArray.length - 1 : this.curElem - 1;
                    this.nextElem = this.curElem + 1 >= this.elemArray.length ? 0 : this.curElem + 1
                }
            }
        };
        var F = function(t) {
            var i = "";
            var e = t.split(",");
            for (var o = 0; o < e.length; o++) i += String.fromCharCode(e[o]);
            return i
        };
        b = b || {};
        for (var O in b)
            if (O.toLowerCase() !== O) {
                b[O.toLowerCase()] = b[O];
                delete b[O]
            } this.each(function() {
            if (P(this).data("donotinit") && (!b || !b["forceinit"])) return;
            if (P(this).data("inited")) return;
            P(this).data("inited", 1);
            this.options = P.extend({}, b);
            this.options.linktitle = (Math.random() > .4 ? F("82,101,115,112,111,110,115,105,118,101,32") : "") + F("106,81,117,101,114,121,32,83,108,105,100,101,114");
            var e = this;
            P.each(P(this).data(), function(t, i) {
                e.options[t.toLowerCase()] = i
            });
            var t = {};
            var i = window.location.search.substring(1).split("&");
            for (var o = 0; o < i.length; o++) {
                var s = i[o].split("=");
                if (s && s.length == 2) {
                    var n = s[0].toLowerCase();
                    var a = unescape(s[1]).toLowerCase();
                    if (a == "true") t[n] = true;
                    else if (a == "false") t[n] = false;
                    else t[n] = a
                }
            }
            this.options = P.extend(this.options, t);
            this.options.customeffects = null;
            if (this.options.customtexteffect) try {
                this.options.customeffects = P.parseJSON(this.options.customtexteffect)
            } catch (v) {}
            if (P("#amazingslider_customtexteffect_" + this.options.sliderid).length > 0) try {
                this.options.customeffects = P.parseJSON(P("#amazingslider_customtexteffect_" + this.options.sliderid).text())
            } catch (v) {}
            if (this.options.textformat && typeof AMAZINGSLIDER_TEXT_EFFECT_FORMATS !== "undefined")
                if (this.options.textformat in AMAZINGSLIDER_TEXT_EFFECT_FORMATS) this.options = P.extend({}, AMAZINGSLIDER_TEXT_EFFECT_FORMATS[this.options.textformat], this.options);
            if (this.options.textformat && this.options.customeffects)
                if (this.options.textformat in this.options.customeffects) this.options = P.extend({}, this.options.customeffects[this.options.textformat], this.options);
            if (P(this).data("skin") && typeof AMAZINGSLIDER_SKIN_OPTIONS !== "undefined")
                if (P(this).data("skin") in AMAZINGSLIDER_SKIN_OPTIONS) this.options = P.extend({}, AMAZINGSLIDER_SKIN_OPTIONS[P(this).data("skin")], this.options);
            var r = {
                previewmode: false,
                preloadprevnext: true,
                isresponsive: true,
                isfullscreen: false,
                fullbrowserwidth: false,
                usejsforfullbrowserwidth: false,
                windowresizetimeout: 0,
                outputtext: false,
                titletag: "h2",
                descriptiontag: "h3",
                initsocial: true,
                showsocial: false,
                socialmode: "mouseover",
                socialposition: "position:absolute;top:8px;right:8px;",
                socialpositionsmallscreen: "position:absolute;top:8px;right:8px;",
                socialdirection: "horizontal",
                socialbuttonsize: 32,
                socialbuttonfontsize: 18,
                socialrotateeffect: true,
                showfacebook: true,
                showtwitter: true,
                showpinterest: true,
                titleusealt: true,
                ratioresponsive: false,
                ratiomediumscreen: 800,
                ratiomediumheight: 1.2,
                ratiosmallscreen: 480,
                ratiosmallheight: 1.6,
                pauseonmouseover: true,
                slideinterval: 5e3,
                randomplay: false,
                forceflash: false,
                forceflashonie10: true,
                forceflashonie11: false,
                nativehtml5controls: false,
                nativecontrolsonfirefox: false,
                nativecontrolsonie: false,
                nativecontrolsoniphone: true,
                nativecontrolsonipad: true,
                nativecontrolsonandroid: true,
                nativecontrolsonfullscreen: true,
                nativecontrolsnodownload: true,
                lazyloadtags: "lazy-src,lazyload-src,cfsrc,src",
                addextraattributes: false,
                lightboxbarheight: 64,
                lightboxresponsive: true,
                lightboxshowtitle: true,
                lightboxshowdescription: false,
                lightboxshownavigation: false,
                lightboxthumbwidth: 80,
                lightboxthumbheight: 60,
                lightboxthumbtopmargin: 12,
                lightboxthumbbottommargin: 4,
                lightboxtitlebottomcss: "color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;",
                lightboxdescriptionbottomcss: "color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;",
                lightboxfullscreenmode: false,
                lightboxcloseonoverlay: true,
                lightboxvideohidecontrols: false,
                lightboxtitlestyle: "bottom",
                lightboximagepercentage: 75,
                lightboxdefaultvideovolume: 1,
                lightboxoverlaybgcolor: "#000",
                lightboxoverlayopacity: .9,
                lightboxbgcolor: "#fff",
                lightboxtitleprefix: "%NUM / %TOTAL",
                lightboxtitleinsidecss: "color:#fff; font-size:16px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left;",
                lightboxdescriptioninsidecss: "color:#fff; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;",
                lightboxautoslide: false,
                lightboxslideinterval: 5e3,
                lightboxshowtimer: true,
                lightboxtimerposition: "bottom",
                lightboxtimerheight: 2,
                lightboxtimercolor: "#dc572e",
                lightboxtimeropacity: 1,
                lightboxshowplaybutton: true,
                lightboxalwaysshownavarrows: false,
                lightboxbordersize: 8,
                lightboxshowtitleprefix: true,
                lightboxborderradius: 0,
                lightboxnogroup: false,
                lightboxshowsocial: false,
                lightboxsocialposition: "position:absolute;top:100%;right:0;",
                lightboxsocialpositionsmallscreen: "position:absolute;top:100%;right:0;left:0;",
                lightboxsocialdirection: "horizontal",
                lightboxsocialbuttonsize: 32,
                lightboxsocialbuttonfontsize: 18,
                lightboxsocialrotateeffect: true,
                lightboxshowfacebook: true,
                lightboxshowtwitter: true,
                lightboxshowpinterest: true,
                scalemode: "fill",
                skinsfoldername: "skins",
                showtimer: true,
                timerposition: "bottom",
                timercolor: "#ffffff",
                timeropacity: .6,
                timerheight: 2,
                autoplay: false,
                loop: 0,
                autoplayvideo: true,
                loopvideo: true,
                playvideoimage: "play-video.png",
                playvideoimagewidth: 64,
                playvideoimageheight: 64,
                playmutedandinlinewhenautoplay: true,
                playvideoonclickthumb: true,
                videohidecontrols: false,
                videohideplaybutton: false,
                defaultvideovolume: 1,
                savevolumetocookie: true,
                enabletouchswipe: true,
                swipeonimageonly: true,
                border: 6,
                bordercolor: "#ffffff",
                borderradius: 0,
                showshadow: true,
                shadowsize: 5,
                shadowcolor: "#aaaaaa",
                showbottomshadow: false,
                bottomshadowimage: "bottom-shadow.png",
                bottomshadowimagewidth: 140,
                bottomshadowimagetop: 90,
                showbackgroundimage: false,
                backgroundimage: "background.png",
                backgroundimagewidth: 120,
                backgroundimagetop: -10,
                arrowstyle: "mouseover",
                arrowimage: "arrows.png",
                arrowwidth: 32,
                arrowheight: 32,
                arrowmargin: 0,
                arrowhideonmouseleave: 1e3,
                arrowtop: 50,
                showribbon: false,
                ribbonimage: "ribbon_topleft-0.png",
                ribbonposition: "topleft",
                ribbonimagex: -11,
                ribbonimagey: -11,
                showtext: true,
                shownumbering: false,
                numberingformat: "%NUM/%TOTAL ",
                shownav: true,
                navstyle: "thumbnails",
                navswitchonmouseover: false,
                navdirection: "horizontal",
                navposition: "bottom",
                navmargin: 24,
                navwidth: 64,
                navheight: 60,
                navspacing: 8,
                navmultirows: false,
                navrowspacing: 8,
                navshowpreview: true,
                navshowpreviewontouch: false,
                navpreviewposition: "top",
                navpreviewarrowimage: "preview-arrow.png",
                navpreviewarrowwidth: 20,
                navpreviewarrowheight: 10,
                navpreviewwidth: 120,
                navpreviewheight: 60,
                navpreviewborder: 8,
                navpreviewbordercolor: "#ffff00",
                navimage: "bullets.png",
                navradius: 0,
                navcolor: "",
                navhighlightcolor: "",
                navfont: "Lucida Console, Arial",
                navfontcolor: "#666666",
                navfonthighlightcolor: "#666666",
                navfontsize: 12,
                navbuttonshowbgimage: true,
                navbuttonbgimage: "navbuttonbgimage.png",
                navshowbuttons: false,
                navbuttonradius: 2,
                navbuttoncolor: "#999999",
                navbuttonhighlightcolor: "#333333",
                navshowplaypause: true,
                navshowarrow: true,
                navplaypauseimage: "nav-play-pause.png",
                navarrowimage: "nav-arrows.png",
                navshowplaypausestandalone: false,
                navshowplaypausestandaloneautohide: false,
                navshowplaypausestandaloneposition: "bottomright",
                navshowplaypausestandalonemarginx: 24,
                navshowplaypausestandalonemarginy: 24,
                navshowplaypausestandalonewidth: 32,
                navshowplaypausestandaloneheight: 32,
                navopacity: .8,
                navborder: 2,
                navbordercolor: "#ffffff",
                navborderhighlightcolor: "",
                navshowfeaturedarrow: true,
                navfeaturedarrowimage: "featured-arrow.png",
                navfeaturedarrowimagewidth: 20,
                navfeaturedarrowimageheight: 10,
                navthumbstyle: "imageonly",
                navthumbtitleheight: 20,
                navthumbtitlewidth: 120,
                navthumbtitlecss: "display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
                navthumbtitlehovercss: "text-decoration:underline;",
                navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
                navthumbdescriptionhovercss: "",
                navthumbnavigationstyle: "arrow",
                navthumbnavigationarrowimage: "carousel-arrows-32-32-0.png",
                navthumbnavigationarrowimagewidth: 32,
                navthumbnavigationarrowimageheight: 32,
                navthumbresponsive: false,
                navthumbmediumsize: 800,
                navthumbmediumwidth: 64,
                navthumbmediumheight: 64,
                navthumbmediumtitleheight: 20,
                navthumbmediumtitlewidth: 120,
                navthumbsmallsize: 600,
                navthumbsmallwidth: 48,
                navthumbsmallheight: 48,
                navthumbsmalltitleheight: 20,
                navthumbsmalltitlewidth: 120,
                navthumbresponsivemode: "samesize",
                navthumbcolumn: 5,
                navthumbmediumcolumn: 4,
                navthumbsmallcolumn: 3,
                navshowplayvideo: true,
                navplayvideoimage: "play-32-32-0.png",
                forcewidthtoevenforslice: true,
                increasewhenforcetoeven: false,
                transitiononfirstslide: false,
                transition: "slide",
                transitionduration: 1e3,
                transitioneasing: "easeOutQuad",
                slice: {
                    checked: true,
                    effectdirection: 0,
                    effects: "up,down,updown",
                    slicecount: 10,
                    duration: 1500,
                    easing: "easeOutCubic"
                },
                blocks: {
                    columncount: 5,
                    checked: true,
                    rowcount: 5,
                    effects: "topleft,bottomright,top,bottom,random",
                    duration: 1500,
                    easing: "easeOutCubic"
                },
                threedtiles: {
                    rowcount: 3,
                    columncount: 5,
                    checked: true,
                    effects: "top,bottom,random",
                    duration: 2e3,
                    easing: "ease-out",
                    depth: 20,
                    scale: .8,
                    scaleduration: 400,
                    bgcolor: "#333333",
                    perspective: 1e3,
                    fallback: "tiles",
                    scatter: 4,
                    perspectiveorigin: "bottom"
                },
                tiles: {
                    rowcount: 3,
                    columncount: 5,
                    checked: true,
                    effects: "top,bottom,random",
                    duration: 2e3,
                    easing: "ease-out",
                    scale: .8,
                    scaleduration: 400,
                    bgcolor: "#333333",
                    fallback: "blocks"
                },
                slide: {
                    duration: 1e3,
                    easing: "easeOutCubic",
                    checked: true,
                    effectdirection: 0
                },
                cssslide: {
                    duration: 1e3,
                    easing: "ease",
                    checked: true,
                    effectdirection: 0
                },
                elastic: {
                    duration: 1e3,
                    easing: "easeOutElastic",
                    checked: true,
                    effectdirection: 0
                },
                crossfade: {
                    duration: 1e3,
                    easing: "easeOutCubic",
                    checked: true
                },
                fadeoutfadein: {
                    duration: 1e3,
                    easing: "easeOutCubic",
                    checked: true
                },
                kenburns: {
                    fadeduration: 3e3,
                    duration: 5e3,
                    effects: "zoomin,zoomout",
                    scale: 1.1,
                    easing: "easeOutCubic",
                    nextadvancetime: 0,
                    checked: true
                },
                threedhorizontal: {
                    checked: true,
                    effectdirection: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 1,
                    duration: 1500,
                    scale: 1,
                    scaleduration: 0,
                    easing: "ease",
                    fallback: "slice",
                    scatter: 5,
                    perspectiveorigin: "bottom"
                },
                threedhorizontalwithzoom: {
                    checked: true,
                    effectdirection: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 4,
                    duration: 2200,
                    scale: .8,
                    scaleduration: 400,
                    easing: "ease",
                    fallback: "slice",
                    scatter: 5,
                    perspectiveorigin: "bottom"
                },
                fade: {
                    duration: 1e3,
                    easing: "easeOutCubic",
                    checked: true
                },
                shuffle: {
                    duration: 1500,
                    easing: "easeOutCubic",
                    columncount: 5,
                    checked: true,
                    rowcount: 5
                },
                threed: {
                    checked: true,
                    effectdirection: 0,
                    scale: 1,
                    scaleduration: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 5,
                    duration: 1500,
                    easing: "ease",
                    fallback: "slice",
                    scatter: 5,
                    perspectiveorigin: "right"
                },
                threedwithzoom: {
                    checked: true,
                    effectdirection: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 5,
                    duration: 2500,
                    scale: .8,
                    scaleduration: 400,
                    easing: "ease",
                    fallback: "slice",
                    scatter: 5,
                    perspectiveorigin: "right"
                },
                blinds: {
                    duration: 1500,
                    easing: "easeOutCubic",
                    checked: true,
                    effectdirection: 0,
                    slicecount: 5
                },
                threedflip: {
                    duration: 1500,
                    easing: "ease-out",
                    depth: 20,
                    scale: 1,
                    scaleduration: 0,
                    checked: true,
                    effectdirection: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 5,
                    fallback: "flip",
                    scatter: 4,
                    perspectiveorigin: "bottom"
                },
                threedflipwithzoom: {
                    duration: 2e3,
                    easing: "ease-out",
                    depth: 20,
                    scale: .8,
                    scaleduration: 400,
                    checked: true,
                    effectdirection: 0,
                    bgcolor: "#222222",
                    perspective: 1e3,
                    slicecount: 5,
                    fallback: "flipwithzoom",
                    scatter: 4,
                    perspectiveorigin: "bottom"
                },
                flip: {
                    checked: true,
                    effectdirection: 0,
                    slicecount: 5,
                    duration: 1500,
                    easing: "ease-in",
                    fallback: "slice",
                    scale: 1,
                    scaleduration: 0
                },
                flipwithzoom: {
                    checked: true,
                    effectdirection: 0,
                    slicecount: 5,
                    duration: 2e3,
                    easing: "ease-in",
                    fallback: "slice",
                    scale: .8,
                    scaleduration: 400
                }
            };
            var l = {
                textstyle: "static",
                textpositionstatic: "bottom",
                textautohide: false,
                textpositionmarginstatic: 0,
                textleftrightpercentforstatic: "40",
                textpositiondynamic: "topleft,topright,bottomleft,bottomright,topcenter,bottomcenter",
                textpositionmarginleft: 24,
                textpositionmarginright: 24,
                textpositionmargintop: 24,
                textpositionmarginbottom: 24,
                texteffect: "slide",
                texteffecteasing: "easeOutCubic",
                texteffectduration: 600,
                texteffectslidedirection: "left",
                texteffectslidedistance: 120,
                texteffectdelay: 500,
                texteffectseparate: true,
                texteffect1: "slide",
                texteffectslidedirection1: "right",
                texteffectslidedistance1: 120,
                texteffecteasing1: "easeOutCubic",
                texteffectduration1: 600,
                texteffectdelay1: 1500,
                texteffect2: "slide",
                texteffectslidedirection2: "right",
                texteffectslidedistance2: 120,
                texteffecteasing2: "easeOutCubic",
                texteffectduration2: 600,
                texteffectdelay2: 1500,
                addgooglefonts: true,
                googlefonts: "Inder",
                textcss: "display:block; padding:12px; text-align:left;",
                textbgcss: "display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
                titlecss: "display:block; position:relative; font:bold 14px Inder,Arial,Tahoma,Helvetica,sans-serif; color:#fff;",
                descriptioncss: "display:block; position:relative; font:12px Anaheim,Arial,Tahoma,Helvetica,sans-serif; color:#fff;",
                buttoncss: "display:block; position:relative;",
                texteffectresponsive: true,
                texteffectresponsivesize: 600,
                titlecssresponsive: "font-size:12px;",
                descriptioncssresponsive: "font-size:12px;",
                buttoncssresponsive: ""
            };
            this.options = P.extend(true, r, this.options);
            var h = ["slice", "blocks", "threedtiles", "tiles", "slide", "cssslide", "elastic", "crossfade", "fadeoutfadein", "kenburns", "threedhorizontal", "threedhorizontalwithzoom", "fade", "shuffle", "threed", "threedwithzoom", "blinds", "threedflip", "threedflipwithzoom", "flip", "flipwithzoom"];
            for (var o = 0; o < h.length; o++) {
                var p = h[o] + "duration";
                if (p in this.options) this.options[h[o]].duration = this.options[p];
                var d = h[o] + "fallback";
                if (d in this.options) this.options[h[o]].fallback = this.options[d]
            }
            for (var n in this.options)
                if (n.substring(0, 17) == "customtransition_") {
                    var c = n.split("_");
                    if (c.length == 3)
                        if (h.indexOf(c[1]) >= 0) this.options[c[1]][c[2]] = this.options[n]
                } this.textoptions = P.ASUpdateObject(l, this.options);
            if (this.options.forcewidthtoevenforslice) {
                var h = this.options.transition.toLowerCase().split(",");
                if (P.inArray("slice", h) < 0) this.options.forcewidthtoevenforslice = false
            }
            if (!this.options.shownav) this.options.navstyle = "none";
            if (typeof amazingslider_previewmode != "undefined") this.options.previewmode = amazingslider_previewmode;
            this.options.htmlfolder = window.location.href.substr(0, window.location.href.lastIndexOf("/") + 1);
            if (this.options.skinsfoldername.length > 0) this.options.skinsfolder = this.options.jsfolder + this.options.skinsfoldername + "/";
            else this.options.skinsfolder = this.options.jsfolder;
            var o;
            var m;
            if (typeof AMAZINGSLIDER_TEXT_EFFECT_FORMATS !== "undefined") {
                this.options.textformat = AMAZINGSLIDER_TEXT_EFFECT_FORMATS;
                if (this.options.customeffects) this.options.textformat = P.extend({}, this.options.textformat, this.options.customeffects)
            }
            var u = ["arrowimage", "navimage", "playvideoimage", "navthumbnavigationarrowimage", "navplayvideoimage", "bottomshadowimage", "backgroundimage", "ribbonimage", "navpreviewarrowimage", "navbuttonbgimage", "navplaypauseimage", "navarrowimage", "navfeaturedarrowimage"];
            for (var o = 0; o < u.length; o++)
                if (this.options[u[o]])
                    if (this.options[u[o]].substring(0, 7).toLowerCase() != "http://" && this.options[u[o]].substring(0, 8).toLowerCase() != "https://") this.options[u[o]] = this.options.skinsfolder + this.options[u[o]];
            var g;
            if ("sliderid" in this.options) g = this.options.sliderid;
            else {
                g = R;
                R++
            }
            var f = new B(P(this), this.options, this.textoptions, g);
            P(this).data("object", f);
            P(this).data("id", g);
            N.addObject(f)
        })
    }
})(jQuery);
(function(t) {
    t.ASUpdateObject = function(t, i) {
        for (var e in t)
            if (e in i) t[e] = i[e];
        return t
    }
})(jQuery);
(function(O) {
    O.fn.amazingsliderTransition = function(t, i, e, o, s, n) {
        var a = this;
        var r = o.effect;
        var l = o.duration;
        var h = o.easing;
        var p = o.direction;
        var d = null;
        if (r) {
            r = r.split(",");
            d = r[Math.floor(Math.random() * r.length)];
            d = O.trim(d.toLowerCase())
        }
        if ((d == "threed" || d == "threedwithzoom" || d == "threedtiles" || d == "threedhorizontal" || d == "threedhorizontalwithzoom" || d == "threedflip" || d == "threedflipwithzoom") && !az_.css33dTransformSupported()) d = o[d].fallback;
        if ((d == "flip" || d == "flipwithzoom" || d == "tiles") && az_.isIE6789()) d = o[d].fallback;
        if (d && o[d]) {
            if ("effectdirection" in o[d])
                if (o[d].effectdirection == 1) p = true;
                else if (o[d].effectdirection == 2) p = false;
            if (o[d].duration) l = o[d].duration;
            if (o[d].easing) h = o[d].easing
        }
        if (d == "fade") {
            n();
            a.css({
                overflow: "hidden"
            });
            e.show();
            if (i && i.length) i.fadeOut(l, h, function() {
                i.remove();
                s()
            });
            else s()
        } else if (d == "fadein") {
            n();
            a.css({
                overflow: "hidden"
            });
            e.hide();
            i.insertBefore(e);
            e.fadeIn(l, h, function() {
                i.remove();
                s()
            })
        } else if (d == "crossfade") {
            n();
            a.css({
                overflow: "hidden"
            });
            e.hide();
            if (i && i.length) i.fadeOut(l / 2, h, function() {
                e.fadeIn(l / 2, h, function() {
                    i.remove();
                    s()
                })
            });
            else s()
        } else if (d == "fadeoutfadein") {
            n();
            a.css({
                overflow: "hidden"
            });
            e.fadeIn(l, h);
            if (i && i.length) i.fadeOut(l, h, function() {
                i.remove();
                s()
            });
            else s()
        } else if (d == "kenburns") {
            a.css({
                overflow: "hidden"
            });
            a.kenburnsTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth
            }, o[d]), s, n)
        } else if (d == "cssslide") {
            n();
            a.css({
                overflow: "hidden"
            });
            if (p) {
                e.css({
                    left: "100%"
                });
                i.css({
                    transition: "left " + l + "ms " + h
                });
                e.css({
                    transition: "left " + l + "ms " + h
                });
                setTimeout(function() {
                    e.css({
                        left: "0%"
                    });
                    if (i && i.length) i.css({
                        left: "-100%"
                    });
                    setTimeout(function() {
                        i.remove();
                        s()
                    }, l + 500)
                }, 50)
            } else {
                e.css({
                    left: "-100%"
                });
                i.css({
                    transition: "left " + l + "ms " + h
                });
                e.css({
                    transition: "left " + l + "ms " + h
                });
                setTimeout(function() {
                    e.css({
                        left: "0%"
                    });
                    if (i && i.length) i.css({
                        left: "100%"
                    });
                    setTimeout(function() {
                        i.remove();
                        s()
                    }, l + 500)
                }, 50)
            }
        } else if (d == "slide" || d == "elastic") {
            n();
            a.css({
                overflow: "hidden"
            });
            if (p) {
                e.css({
                    left: "100%"
                });
                e.animate({
                    left: "0%"
                }, l, h);
                if (i && i.length) i.animate({
                    left: "-100%"
                }, l, h, function() {
                    i.remove();
                    s()
                });
                else s()
            } else {
                e.css({
                    left: "-100%"
                });
                e.animate({
                    left: "0%"
                }, l, h);
                if (i && i.length) i.animate({
                    left: "100%"
                }, l, h, function() {
                    i.remove();
                    s()
                });
                else s()
            }
        } else if (d == "slice") {
            a.css({
                overflow: "hidden"
            });
            a.sliceTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth
            }, o["slice"]), s, n)
        } else if (d == "flip" || d == "flipwithzoom") {
            a.css({
                overflow: "hidden"
            });
            a.flipTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "blinds") {
            a.css({
                overflow: "hidden"
            });
            a.blindsTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth
            }, o["blinds"]), s, n)
        } else if (d == "threed" || d == "threedwithzoom") {
            a.css({
                overflow: "visible"
            });
            a.threedTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "threedhorizontal" || d == "threedhorizontalwithzoom") {
            a.css({
                overflow: "visible"
            });
            a.threedHorizontalTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "threedflip" || d == "threedflipwithzoom") {
            a.css({
                overflow: "visible"
            });
            a.threedFlipTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "blocks") {
            a.css({
                overflow: "hidden"
            });
            a.blocksTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth
            }, o[d]), s, n)
        } else if (d == "threedtiles") {
            a.css({
                overflow: "hidden"
            });
            a.threedtilesTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "tiles") {
            a.css({
                overflow: "hidden"
            });
            a.tilesTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth,
                previmgmargintop: o.previmgmargintop,
                previmgmarginleft: o.previmgmarginleft,
                previmgmaxwidth: o.previmgmaxwidth
            }, o[d]), s, n)
        } else if (d == "shuffle") {
            a.css({
                overflow: "visible"
            });
            a.shuffleTransition(t, i, e, O.extend({
                duration: l,
                easing: h,
                direction: p,
                imgmargintop: o.imgmargintop,
                imgmarginleft: o.imgmarginleft,
                imgmaxwidth: o.imgmaxwidth
            }, o["shuffle"]), s, n)
        } else {
            n();
            e.show();
            i.remove();
            s()
        }
    };
    O.fn.kenburnsTransition = function(t, i, e, o, s, n) {
        var a = this;
        a.off("transitionFinished").on("transitionFinished", function() {
            a.off("transitionFinished");
            i.remove();
            s()
        });
        e.hide();
        i.insertBefore(e);
        var r = Math.floor(Math.random() * 4);
        var l = o.effects.split(",");
        var h = Math.floor(Math.random() * l.length);
        var p = O.trim(l[h]);
        if (az_.isIE6789()) {
            var d = {
                top: 0,
                left: 0,
                bottom: "auto",
                right: "auto"
            };
            switch (r) {
                case 0:
                    d = {
                        top: 0,
                        left: "auto",
                        bottom: "auto",
                        right: 0
                    };
                    break;
                case 1:
                    d = {
                        top: "auto",
                        left: 0,
                        bottom: 0,
                        right: "auto"
                    };
                    break;
                case 2:
                    d = {
                        top: "auto",
                        left: "auto",
                        bottom: 0,
                        right: 0
                    };
                    break;
                default:
                    d = {
                        top: 0,
                        left: 0,
                        bottom: "auto",
                        right: "auto"
                    }
            }
            e.css(d);
            var c = Math.round(o.scale * 100);
            if (p == "zoomout") {
                e.css({
                    width: c + "%",
                    height: c + "%",
                    display: "block",
                    opacity: 0
                });
                e.animate({
                    opacity: 1,
                    width: "100%",
                    height: "100%"
                }, o.duration, o.easing)
            } else {
                e.css({
                    width: "100%",
                    height: "100%",
                    display: "block",
                    opacity: 0
                });
                e.animate({
                    opacity: 1,
                    width: c + "%",
                    height: c + "%"
                }, o.duration, o.easing)
            }
        } else {
            e.find("img").css({
                display: "none"
            });
            e.show();
            var m = e.width();
            var u = e.height();
            var g = e.find("img").data("originalwidth");
            var f = e.find("img").data("originalheight");
            var v = 0;
            var b = 0;
            var w = g;
            var x = f;
            var y = f / g;
            var k = u / m;
            if (k < y) {
                x = g * k;
                b = (f - x) / 2
            } else {
                w = f / k;
                v = (g - w) / 2
            }
            var z = O('<canvas class="amazingslider-img-canvas-' + t + '" width="' + m + '" height="' + u + '" />');
            e.append(z);
            var A = e.find("img")[0];
            var E = z[0].getContext("2d");
            var I = 60 * o.fadeduration / 1e3;
            if (I <= 0) I = 1;
            var M = 1 / I;
            var T = 60 * o.duration / 1e3;
            if (T <= 0) T = 1;
            var S = (o.scale - 1) / T;
            var $ = 0;
            if (p == "zoomout") {
                var c = o.scale;
                (function B() {
                    m = e.width();
                    u = e.height();
                    O(".amazingslider-img-canvas-" + t, e).attr("width", m).attr("height", u);
                    $ += M;
                    c -= S;
                    if ($ > 1) $ = 1;
                    if (c < 1) c = 1;
                    E.globalAlpha = $;
                    switch (r) {
                        case 0:
                            E.drawImage(A, v, b, w, x, m - c * m, u - c * u, c * m, c * u);
                            break;
                        case 1:
                            E.drawImage(A, v, b, w, x, 0, u - c * u, c * m, c * u);
                            break;
                        case 2:
                            E.drawImage(A, v, b, w, x, m - c * m, 0, c * m, c * u);
                            break;
                        default:
                            E.drawImage(A, v, b, w, x, 0, 0, c * m, c * u)
                    }
                    if ($ < 1 || c > 1) requestAnimationFrame(B)
                })()
            } else {
                var c = 1;
                (function F() {
                    m = e.width();
                    u = e.height();
                    O(".amazingslider-img-canvas-" + t, e).attr("width", m).attr("height", u);
                    $ += M;
                    c += S;
                    if ($ > 1) $ = 1;
                    if (c > o.scale) c = o.scale;
                    E.globalAlpha = $;
                    switch (r) {
                        case 0:
                            E.drawImage(A, v, b, w, x, m - c * m, u - c * u, c * m, c * u);
                            break;
                        case 1:
                            E.drawImage(A, v, b, w, x, 0, u - c * u, c * m, c * u);
                            break;
                        case 2:
                            E.drawImage(A, v, b, w, x, m - c * m, 0, c * m, c * u);
                            break;
                        default:
                            E.drawImage(A, v, b, w, x, 0, 0, c * m, c * u)
                    }
                    if ($ < 1 || c < o.scale) requestAnimationFrame(F)
                })()
            }
        }
        var C = setTimeout(function() {
            a.trigger("transitionFinished")
        }, o.duration - o.nextadvancetime);
        n(C)
    };
    O.fn.sliceTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width();
        var p = h / o.slicecount;
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var d = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:" + a * p + "px;top:0%;width:" + p + "px;height:100%;overflow:hidden;'></div>");
            var c = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                c.css({
                    "margin-left": o.slicecount * o.imgmarginleft + "%"
                });
                c.css({
                    "max-width": o.slicecount * o.imgmaxwidth + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * o.imgmaxwidth + "%"
                })
            } else {
                c.css({
                    "margin-top": o.slicecount * o.imgmargintop + "%"
                });
                c.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            d.append(c);
            l.append(d)
        }
        var m = O(".amazingslider-img-slice-" + t, l);
        if (!o.direction) m = O(O.makeArray(m).reverse());
        var u = o.effects.split(",");
        var g = u[Math.floor(Math.random() * u.length)];
        g = O.trim(g.toLowerCase());
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            m.remove();
            s()
        });
        var f = o.duration / 2;
        var v = o.duration / 2 / o.slicecount;
        r = 0;
        m.each(function() {
            var t = O(this);
            switch (g) {
                case "up":
                    t.css({
                        top: "",
                        bottom: "0%",
                        height: "0%"
                    });
                    break;
                case "down":
                    t.css({
                        top: "0%",
                        height: "0%"
                    });
                    break;
                case "updown":
                    if (r % 2 == 0) t.css({
                        top: "0%",
                        height: "0%"
                    });
                    else t.css({
                        top: "",
                        bottom: "0%",
                        height: "0%"
                    });
                    break
            }
            setTimeout(function() {
                t.animate({
                    height: "100%"
                }, f, o.easing)
            }, v * r);
            r++
        });
        var b = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(b)
    };
    O.fn.blindsTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width();
        var p = h / o.slicecount;
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var d = O("<div class='amazingslider-img-slice-wrapper-" + t + " ' style='display:block;position:absolute;left:" + a * p + "px;top:0%;width:" + p + "px;height:100%;overflow:hidden;'></div>");
            var c = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
            var m = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                m.css({
                    "margin-left": o.slicecount * o.imgmarginleft + "%"
                });
                m.css({
                    "max-width": o.slicecount * o.imgmaxwidth + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * o.imgmaxwidth + "%"
                })
            } else {
                m.css({
                    "margin-top": o.slicecount * o.imgmargintop + "%"
                });
                m.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            c.append(m);
            d.append(c);
            l.append(d)
        }
        var u = O(".amazingslider-img-slice-" + t, l);
        if (!o.direction) u = O(O.makeArray(u).reverse());
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            O(".amazingslider-img-slice-wrapper-" + t, l).remove();
            s()
        });
        r = 0;
        u.each(function() {
            var t = O(this);
            var i;
            if (!o.direction) {
                t.css({
                    left: "",
                    right: "-100%"
                });
                i = {
                    right: "0%"
                }
            } else {
                t.css({
                    left: "-100%"
                });
                i = {
                    left: "0%"
                }
            }
            t.animate(i, o.duration * (r + 1) / o.slicecount, o.easing);
            r++
        });
        var g = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(g)
    };
    O.fn.threedTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width(),
            p = l.height(),
            d = p / 2;
        var c = h / o.slicecount;
        var m = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        l.append(m);
        m.css(az_.applyBrowserStyles({
            "transform-style": "preserve-3d",
            perspective: o.perspective,
            "perspective-origin": o.perspectiveorigin + " center"
        }));
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var u = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                u.css({
                    "margin-left": o.slicecount * o.imgmarginleft + "%"
                });
                u.css({
                    "max-width": o.slicecount * o.imgmaxwidth + "%",
                    left: "-" + c * a + "px",
                    width: o.slicecount * o.imgmaxwidth + "%"
                })
            } else {
                u.css({
                    "margin-top": o.slicecount * o.imgmargintop + "%"
                });
                u.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + c * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var g = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            g.append(u);
            var f = O("img", i).clone();
            if (Math.abs(o.previmgmarginleft) > 0) {
                f.css({
                    "margin-left": o.slicecount * o.previmgmarginleft + "%"
                });
                f.css({
                    "max-width": o.slicecount * o.previmgmaxwidth + "%",
                    left: "-" + c * a + "px",
                    width: o.slicecount * o.previmgmaxwidth + "%"
                })
            } else {
                f.css({
                    "margin-top": o.slicecount * o.previmgmargintop + "%"
                });
                f.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + c * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var v = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            v.append(f);
            var b = O("<div class='amazingslider-img-slice-left-" + t + " ' style='display:block;position:absolute;left:2px;top:2px;width:" + (p - 1) + "px;height:" + (p - 1) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var w = O("<div class='amazingslider-img-slice-right-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:" + (p - 1) + "px;height:" + (p - 1) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var x = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:" + a * c + "px;top:0%;width:" + c + "px;height:100%;'></div>");
            x.append(b);
            x.append(w);
            x.append(g);
            x.append(v);
            m.append(x);
            b.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(-90deg) translateZ(" + d + "px" + ")"
            }));
            w.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(90deg) translateZ(" + (c - d) + "px" + ")"
            }));
            v.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "translateZ(" + d + "px" + ")"
            }));
            g.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateX(" + (o.direction ? "90" : "-90") + "deg) translateZ(" + d + "px" + ")"
            }))
        }
        var y = O(".amazingslider-img-cube-" + t, l);
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            setTimeout(function() {
                m.remove()
            }, 100);
            s()
        });
        var k = o.scale == 1 ? 0 : 12;
        var z = o.scale == 1 ? 0 : o.scaleduration - k;
        if (z < 0) z = 0;
        var A = o.scale == 1 ? o.duration : o.duration - 2 * z;
        if (A < 0) {
            k = 0;
            z = 0;
            A = o.duration
        }
        var E = A / 2 / o.slicecount;
        var I = A / 2;
        y.each(function() {
            O(this).css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            O(this).css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            O(this).css(az_.applyBrowserStyles({
                transform: "translateZ(-" + d + "px" + ")"
            }))
        });
        i.hide();
        if (z > 0) {
            y.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": z + "ms"
            }));
            setTimeout(function() {
                y.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ") translateZ(-" + d + "px" + ")"
                }))
            }, k)
        }
        r = 0;
        y.each(function() {
            var t = O(this);
            var i = (o.slicecount - 1) / 2;
            var e = Math.round((r - i) * o.scatter * h / 100);
            setTimeout(function() {
                if (z > 0) t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": I + "ms",
                    transform: "scale(" + o.scale + ") translateZ(-" + d + "px" + ") rotateX(" + (o.direction ? "-89.99" : "89.99") + "deg)"
                }));
                else t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": I + "ms",
                    transform: "translateZ(-" + d + "px" + ") rotateX(" + (o.direction ? "-89.99" : "89.99") + "deg)"
                }));
                t.animate({
                    left: "+=" + e + "px"
                }, I / 2 - 50, function() {
                    t.animate({
                        left: "-=" + e + "px"
                    }, I / 2 - 50)
                })
            }, z + k + E * r + 100);
            r++
        });
        if (z > 0) setTimeout(function() {
            y.css(az_.applyBrowserStyles({
                "transition-duration": z + "ms",
                transform: "scale(1) translateZ(-" + d + "px" + ") rotateX(" + (o.direction ? "-89.99" : "89.99") + "deg)"
            }))
        }, o.duration - z - k);
        var M = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(M)
    };
    O.fn.threedHorizontalTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width(),
            p = l.height(),
            d = h / 2;
        var c = p / o.slicecount;
        var m = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        l.append(m);
        m.css(az_.applyBrowserStyles({
            "transform-style": "preserve-3d",
            perspective: o.perspective,
            "perspective-origin": "center " + o.perspectiveorigin
        }));
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var u = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                u.css({
                    "margin-left": o.imgmarginleft + "%",
                    height: "auto"
                });
                u.css({
                    "max-width": o.imgmaxwidth + "%",
                    top: "-" + c * a + "px",
                    width: o.imgmaxwidth + "%"
                })
            } else {
                u.css({
                    "margin-top": o.imgmargintop + "%"
                });
                u.css({
                    "max-width": "100%",
                    top: "-" + c * a + "px",
                    width: "100%"
                })
            }
            var g = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            g.append(u);
            var f = O("img", i).clone();
            if (Math.abs(o.previmgmarginleft) > 0) {
                f.css({
                    "margin-left": o.previmgmarginleft + "%",
                    height: "auto"
                });
                f.css({
                    "max-width": o.previmgmaxwidth + "%",
                    top: "-" + c * a + "px",
                    width: o.previmgmaxwidth + "%"
                })
            } else {
                f.css({
                    "margin-top": o.previmgmargintop + "%"
                });
                f.css({
                    "max-width": "100%",
                    top: "-" + c * a + "px",
                    width: "100%"
                })
            }
            var v = O("<div class='amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            v.append(f);
            var b = O("<div class='amazingslider-img-slice-left-" + t + " ' style='display:block;position:absolute;left:2px;top:2px;width:" + (h - 1) + "px;height:" + (h - 1) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var w = O("<div class='amazingslider-img-slice-right-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:" + (h - 1) + "px;height:" + (h - 1) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var x = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:0%;top:" + a * c + "px;width:100%;height:" + c + "px;'></div>");
            x.append(b);
            x.append(w);
            x.append(g);
            x.append(v);
            m.append(x);
            b.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateX(90deg) translateZ(" + d + "px" + ")"
            }));
            w.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateX(-90deg) translateZ(" + (c - d) + "px" + ")"
            }));
            v.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "translateZ(" + d + "px" + ")"
            }));
            g.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(" + (o.direction ? "-90" : "90") + "deg) translateZ(" + d + "px" + ")"
            }))
        }
        var y = O(".amazingslider-img-cube-" + t, l);
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            setTimeout(function() {
                m.remove()
            }, 100);
            s()
        });
        var k = o.scale == 1 ? 0 : 12;
        var z = o.scale == 1 ? 0 : o.scaleduration - k;
        if (z < 0) z = 0;
        var A = o.scale == 1 ? o.duration : o.duration - 2 * z;
        if (A < 0) {
            k = 0;
            z = 0;
            A = o.duration
        }
        var E = A / 2 / o.slicecount;
        var I = A / 2;
        y.each(function() {
            O(this).css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            O(this).css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            O(this).css(az_.applyBrowserStyles({
                transform: "translateZ(-" + d + "px" + ")"
            }))
        });
        i.hide();
        if (z > 0) {
            y.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": z + "ms"
            }));
            setTimeout(function() {
                y.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ") translateZ(-" + d + "px" + ")"
                }))
            }, k)
        }
        r = 0;
        y.each(function() {
            var t = O(this);
            var i = (o.slicecount - 1) / 2;
            var e = Math.round((r - i) * o.scatter * p / 100);
            setTimeout(function() {
                if (z > 0) t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": I + "ms",
                    transform: "scale(" + o.scale + ") translateZ(-" + d + "px" + ") rotateY(" + (o.direction ? "89.99" : "-89.99") + "deg)"
                }));
                else t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": I + "ms",
                    transform: "translateZ(-" + d + "px" + ") rotateY(" + (o.direction ? "89.99" : "-89.99") + "deg)"
                }));
                t.animate({
                    top: "+=" + e + "px"
                }, I / 2 - 50, function() {
                    t.animate({
                        top: "-=" + e + "px"
                    }, I / 2 - 50)
                })
            }, z + k + E * r + 100);
            r++
        });
        if (z > 0) setTimeout(function() {
            y.css(az_.applyBrowserStyles({
                "transition-duration": z + "ms",
                transform: "scale(1) translateZ(-" + d + "px" + ") rotateY(" + (o.direction ? "89.99" : "-89.99") + "deg)"
            }))
        }, o.duration - z - k);
        var M = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(M)
    };
    O.fn.threedFlipTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width(),
            p = l.height();
        var d = h / o.slicecount;
        var c = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        l.append(c);
        c.css(az_.applyBrowserStyles({
            "transform-style": "preserve-3d",
            perspective: o.perspective,
            "perspective-origin": o.perspectiveorigin + " center"
        }));
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var m = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                m.css({
                    "margin-left": o.slicecount * o.imgmarginleft + "%"
                });
                m.css({
                    "max-width": o.slicecount * o.imgmaxwidth + "%",
                    left: "-" + d * a + "px",
                    width: o.slicecount * o.imgmaxwidth + "%"
                })
            } else {
                m.css({
                    "margin-top": o.slicecount * o.imgmargintop + "%"
                });
                m.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + d * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var u = O("<div class='amazingslider-img-slice-next amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            u.append(m);
            var g = O("img", i).clone();
            if (Math.abs(o.previmgmarginleft) > 0) {
                g.css({
                    "margin-left": o.slicecount * o.previmgmarginleft + "%"
                });
                g.css({
                    "max-width": o.slicecount * o.previmgmaxwidth + "%",
                    left: "-" + d * a + "px",
                    width: o.slicecount * o.previmgmaxwidth + "%"
                })
            } else {
                g.css({
                    "margin-top": o.slicecount * o.previmgmargintop + "%"
                });
                g.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + d * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var f = O("<div class='amazingslider-img-slice-current amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            f.append(g);
            var v = O("<div class='amazingslider-img-slice-left-" + t + " ' style='display:block;position:absolute;left:2px;top:2px;width:" + o.depth + "px;height:" + (p - 2) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var b = O("<div class='amazingslider-img-slice-right-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:" + o.depth + "px;height:" + p + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            var w = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:" + a * d + "px;top:0%;width:" + d + "px;height:100%;'></div>");
            w.append(v);
            w.append(b);
            w.append(u);
            w.append(f);
            c.append(w);
            v.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(-90deg) translateZ(" + o.depth / 2 + "px" + ")"
            }));
            b.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(90deg) translateZ(" + (d - o.depth / 2) + "px" + ")"
            }));
            u.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "rotateY(-180deg) translateZ(" + o.depth / 2 + "px" + ")"
            }));
            f.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden",
                transform: "translateZ(" + o.depth / 2 + "px" + ")"
            }))
        }
        var x = O(".amazingslider-img-cube-" + t, l);
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            setTimeout(function() {
                c.remove()
            }, 100);
            s()
        });
        var y = o.scale == 1 ? 0 : 12;
        var k = o.scale == 1 ? 0 : o.scaleduration - y;
        if (k < 0) k = 0;
        var z = o.scale == 1 ? o.duration : o.duration - 2 * k;
        if (z < 0) {
            y = 0;
            k = 0;
            z = o.duration
        }
        var A = z / 2 / o.slicecount;
        var E = z / 2;
        x.each(function() {
            O(this).css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            O(this).css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            O(this).css(az_.applyBrowserStyles({
                transform: "translateZ(-" + o.depth / 2 + "px" + ")"
            }))
        });
        i.hide();
        r = 0;
        if (k > 0) {
            x.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": k + "ms"
            }));
            setTimeout(function() {
                x.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ") translateZ(-" + o.depth / 2 + "px" + ")"
                }))
            }, y)
        }
        x.each(function() {
            var t = O(this);
            var i = (o.slicecount - 1) / 2;
            var e = Math.round((r - i) * o.scatter * h / 100);
            setTimeout(function() {
                t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": E + "ms",
                    transform: "scale(" + o.scale + ") translateZ(-" + o.depth / 2 + "px" + ") rotateY(" + (o.direction ? k > 0 ? "-180.5" : "-180" : k > 0 ? "180.5" : "180") + "deg)"
                }));
                t.animate({
                    left: "+=" + e + "px"
                }, E / 2 - 50, function() {
                    t.animate({
                        left: "-=" + e + "px"
                    }, E / 2 - 50)
                })
            }, k + y + A * r + 100);
            r++
        });
        if (k > 0) setTimeout(function() {
            x.css(az_.applyBrowserStyles({
                "transition-duration": k + "ms",
                transform: "scale(1) translateZ(-" + o.depth / 2 + "px" + ") rotateY(" + (o.direction ? "-180" : "180") + "deg)"
            }))
        }, o.duration - k - y);
        var I = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(I)
    };
    O.fn.threedtilesTransition = function(t, i, e, o, s, n) {
        var a, r, l;
        var h = this;
        var p = h.width(),
            d = h.height();
        var c = p / o.columncount;
        var m = d / o.rowcount;
        var u = o.effects.split(",");
        var g = u[Math.floor(Math.random() * u.length)];
        g = O.trim(g.toLowerCase());
        var f = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        h.append(f);
        f.css(az_.applyBrowserStyles({
            "transform-style": "preserve-3d",
            perspective: o.perspective,
            "perspective-origin": o.perspectiveorigin + " center"
        }));
        e.hide();
        for (a = 0; a < o.rowcount; a++)
            for (r = 0; r < o.columncount; r++) {
                var v = O("img", e).clone();
                if (Math.abs(o.imgmarginleft) > 0) {
                    v.css({
                        "margin-left": o.columncount * o.imgmarginleft + "%"
                    });
                    v.css({
                        "max-width": o.columncount * o.imgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * o.imgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    v.css({
                        "margin-top": o.columncount * o.imgmargintop + "%"
                    });
                    v.css({
                        "max-width": o.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * 100 + "%"
                    })
                }
                var b = O("<div class='amazingslider-img-block-next amazingslider-img-block-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                b.append(v);
                var w = O("img", i).clone();
                if (Math.abs(o.previmgmarginleft) > 0) {
                    w.css({
                        "margin-left": o.columncount * o.previmgmarginleft + "%"
                    });
                    w.css({
                        "max-width": o.columncount * o.previmgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * o.previmgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    w.css({
                        "margin-top": o.columncount * o.previmgmargintop + "%"
                    });
                    w.css({
                        "max-width": o.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * 100 + "%"
                    })
                }
                var x = O("<div class='amazingslider-img-block-current amazingslider-img-block-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                x.append(w);
                var y = O("<div class='amazingslider-img-block-left-" + t + " ' style='display:block;position:absolute;left:2px;top:2px;width:" + (o.depth - 2) + "px;height:" + (m - 2) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
                var k = O("<div class='amazingslider-img-block-right-" + t + " ' style='display:block;position:absolute;left:0px;top:0px;width:" + o.depth + "px;height:" + m + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
                var z = O("<div class='amazingslider-img-block-bottom-" + t + " ' style='display:block;position:absolute;left:2px;top:0px;width:" + (c - 2) + "px;height:" + (o.depth - 1) + "px;overflow:hidden;outline:2px solid transparent;background-color:" + o.bgcolor + ";'></div>");
                var A = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:" + r * c + "px;top:" + a * m + "px;width:" + c + "px;height:" + m + "px;'></div>");
                A.append(y);
                A.append(k);
                A.append(z);
                A.append(b);
                A.append(x);
                f.append(A);
                y.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden",
                    transform: "rotateY(-90deg) translateZ(" + o.depth / 2 + "px" + ")"
                }));
                k.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden",
                    transform: "rotateY(90deg) translateZ(" + (c - o.depth / 2) + "px" + ")"
                }));
                z.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden",
                    transform: "rotateX(-90deg) translateZ(" + (m - o.depth / 2) + "px" + ")"
                }));
                b.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden",
                    transform: "rotateY(-180deg) translateZ(" + o.depth / 2 + "px" + ")"
                }));
                x.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden",
                    transform: "translateZ(" + o.depth / 2 + "px" + ")"
                }))
            }
        var E = O(".amazingslider-img-cube-" + t, h);
        h.off("transitionFinished").on("transitionFinished", function() {
            h.off("transitionFinished");
            i.remove();
            e.show();
            f.remove();
            s()
        });
        if (g == "bottom") E = O(O.makeArray(E).reverse());
        else if (g == "random") E = O(O.makeArray(E).sort(function() {
            return .5 - Math.random()
        }));
        var I = o.scale == 1 ? 0 : 12;
        var M = o.scale == 1 ? 0 : o.scaleduration - I;
        if (M < 0) M = 0;
        var T = o.scale == 1 ? o.duration : o.duration - 2 * M;
        if (T < 0) {
            I = 0;
            M = 0;
            T = o.duration
        }
        var S = T / 2 / (o.rowcount * o.columncount);
        var $ = T / 2;
        E.each(function() {
            O(this).css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            O(this).css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            O(this).css(az_.applyBrowserStyles({
                transform: "translateZ(-" + o.depth / 2 + "px" + ")"
            }))
        });
        i.hide();
        l = 0;
        if (M > 0) {
            E.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": M + "ms"
            }));
            setTimeout(function() {
                E.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ") translateZ(-" + o.depth / 2 + "px" + ")"
                }))
            }, I)
        }
        E.each(function() {
            var t = O(this);
            setTimeout(function() {
                t.css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": $ + "ms",
                    transform: "scale(" + o.scale + ") translateZ(-" + o.depth / 2 + "px" + ") rotateY(" + (o.direction ? M > 0 ? "-180.5" : "-180" : M > 0 ? "180.5" : "180") + "deg)"
                }))
            }, M + I + S * l + 100);
            l++
        });
        if (M > 0) setTimeout(function() {
            E.css(az_.applyBrowserStyles({
                "transition-duration": M + "ms",
                transform: "scale(1) translateZ(-" + o.depth / 2 + "px" + ") rotateY(" + (o.direction ? "-180" : "180") + "deg)"
            }))
        }, o.duration - M - I);
        var C = setTimeout(function() {
            h.trigger("transitionFinished")
        }, o.duration);
        n(C)
    };
    O.fn.tilesTransition = function(t, i, e, o, s, n) {
        var a, r, l;
        var h = this;
        var p = h.width(),
            d = h.height();
        var c = p / o.columncount;
        var m = d / o.rowcount;
        var u = o.effects.split(",");
        var g = u[Math.floor(Math.random() * u.length)];
        g = O.trim(g.toLowerCase());
        var f = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        h.append(f);
        f.css(az_.applyBrowserStyles({
            "transform-style": "preserve-3d"
        }));
        e.hide();
        for (a = 0; a < o.rowcount; a++)
            for (r = 0; r < o.columncount; r++) {
                var v = O("img", e).clone();
                if (Math.abs(o.imgmarginleft) > 0) {
                    v.css({
                        "margin-left": o.columncount * o.imgmarginleft + "%"
                    });
                    v.css({
                        "max-width": o.columncount * o.imgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * o.imgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    v.css({
                        "margin-top": o.columncount * o.imgmargintop + "%"
                    });
                    v.css({
                        "max-width": o.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * 100 + "%"
                    })
                }
                var b = O("<div class='amazingslider-img-block-next amazingslider-img-block-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                b.append(v);
                var w = O("img", i).clone();
                if (Math.abs(o.previmgmarginleft) > 0) {
                    w.css({
                        "margin-left": o.columncount * o.previmgmarginleft + "%"
                    });
                    w.css({
                        "max-width": o.columncount * o.previmgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * o.previmgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    w.css({
                        "margin-top": o.columncount * o.previmgmargintop + "%"
                    });
                    w.css({
                        "max-width": o.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * 100 + "%"
                    })
                }
                var x = O("<div class='amazingslider-img-block-current amazingslider-img-block-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                x.append(w);
                var y = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:" + r * c + "px;top:" + a * m + "px;width:" + c + "px;height:" + m + "px;'></div>");
                y.append(b);
                y.append(x);
                f.append(y);
                b.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden"
                }));
                b.css(az_.applyBrowserStyles({
                    "transition-property": "transform"
                }, true));
                b.css(az_.applyBrowserStyles({
                    transform: "rotateY(180deg)"
                }));
                x.css(az_.applyBrowserStyles({
                    "transform-style": "preserve-3d",
                    "backface-visibility": "hidden"
                }));
                x.css(az_.applyBrowserStyles({
                    "transition-property": "transform"
                }, true));
                x.css(az_.applyBrowserStyles({
                    transform: "rotateY(0deg)"
                }))
            }
        var k = O(".amazingslider-img-cube-" + t, h);
        h.off("transitionFinished").on("transitionFinished", function() {
            h.off("transitionFinished");
            i.remove();
            e.show();
            f.remove();
            s()
        });
        if (g == "bottom") k = O(O.makeArray(k).reverse());
        else if (g == "random") k = O(O.makeArray(k).sort(function() {
            return .5 - Math.random()
        }));
        var z = o.scale == 1 ? 0 : 12;
        var A = o.scale == 1 ? 0 : o.scaleduration - z;
        if (A < 0) A = 0;
        var E = o.scale == 1 ? o.duration : o.duration - 2 * A;
        if (E < 0) {
            z = 0;
            A = 0;
            E = o.duration
        }
        var I = E / 2 / (o.rowcount * o.columncount);
        var M = E / 2;
        i.hide();
        l = 0;
        if (A > 0) {
            k.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            k.css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            k.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": A + "ms"
            }));
            setTimeout(function() {
                k.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ")"
                }))
            }, z)
        }
        k.each(function() {
            var t = O(this);
            setTimeout(function() {
                t.find(".amazingslider-img-block-next").css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": M + "ms",
                    transform: "rotateY(0deg)"
                }));
                t.find(".amazingslider-img-block-current").css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": M + "ms",
                    transform: "rotateY(180deg)"
                }))
            }, A + z + I * l + 100);
            l++
        });
        if (A > 0) setTimeout(function() {
            k.css(az_.applyBrowserStyles({
                "transition-duration": A + "ms",
                transform: "scale(1)"
            }))
        }, o.duration - A - z);
        var T = setTimeout(function() {
            h.trigger("transitionFinished")
        }, o.duration);
        n(T)
    };
    O.fn.flipTransition = function(t, i, e, o, s, n) {
        var a, r;
        var l = this;
        var h = l.width();
        var p = h / o.slicecount;
        var d = O("<div class='amazingslider-img-cube-wrapper-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;'></div>");
        l.append(d);
        e.hide();
        for (a = 0; a < o.slicecount; a++) {
            var c = O("img", e).clone();
            if (Math.abs(o.imgmarginleft) > 0) {
                c.css({
                    "margin-left": o.slicecount * o.imgmarginleft + "%"
                });
                c.css({
                    "max-width": o.slicecount * o.imgmaxwidth + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * o.imgmaxwidth + "%"
                })
            } else {
                c.css({
                    "margin-top": o.slicecount * o.imgmargintop + "%"
                });
                c.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var m = O("<div class='amazingslider-img-slice-next amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            m.append(c);
            var u = O("img", i).clone();
            if (Math.abs(o.previmgmarginleft) > 0) {
                u.css({
                    "margin-left": o.slicecount * o.previmgmarginleft + "%"
                });
                u.css({
                    "max-width": o.slicecount * o.previmgmaxwidth + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * o.previmgmaxwidth + "%"
                })
            } else {
                u.css({
                    "margin-top": o.slicecount * o.previmgmargintop + "%"
                });
                u.css({
                    "max-width": o.slicecount * 100 + "%",
                    left: "-" + p * a + "px",
                    width: o.slicecount * 100 + "%"
                })
            }
            var g = O("<div class='amazingslider-img-slice-current amazingslider-img-slice-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;outline:1px solid transparent;background-color:" + o.bgcolor + ";'></div>");
            g.append(u);
            var f = O("<div class='amazingslider-img-cube-" + t + " ' style='display:block;position:absolute;left:" + a * p + "px;top:0%;width:" + p + "px;height:100%;'></div>");
            f.append(m);
            f.append(g);
            d.append(f);
            m.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            m.css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            m.css(az_.applyBrowserStyles({
                transform: "rotateY(180deg)"
            }));
            g.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            g.css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            g.css(az_.applyBrowserStyles({
                transform: "rotateY(0deg)"
            }))
        }
        var v = O(".amazingslider-img-cube-" + t, l);
        l.off("transitionFinished").on("transitionFinished", function() {
            l.off("transitionFinished");
            i.remove();
            e.show();
            setTimeout(function() {
                d.remove()
            }, 100);
            s()
        });
        var b = o.scale == 1 ? 0 : 12;
        var w = o.scale == 1 ? 0 : o.scaleduration - b;
        if (w < 0) w = 0;
        var x = o.scale == 1 ? o.duration : o.duration - 2 * w;
        if (x < 0) {
            b = 0;
            w = 0;
            x = o.duration
        }
        var y = x / 2 / o.slicecount;
        var k = x / 2;
        i.hide();
        r = 0;
        if (w > 0) {
            v.css(az_.applyBrowserStyles({
                "transform-style": "preserve-3d",
                "backface-visibility": "hidden"
            }));
            v.css(az_.applyBrowserStyles({
                "transition-property": "transform"
            }, true));
            v.css(az_.applyBrowserStyles({
                "transition-timing-function": o.easing,
                "transition-duration": w + "ms"
            }));
            setTimeout(function() {
                v.css(az_.applyBrowserStyles({
                    transform: "scale(" + o.scale + ")"
                }))
            }, b)
        }
        v.each(function() {
            var t = O(this);
            setTimeout(function() {
                t.find(".amazingslider-img-slice-next").css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": k + "ms",
                    transform: "rotateY(0deg)"
                }));
                t.find(".amazingslider-img-slice-current").css(az_.applyBrowserStyles({
                    "transition-timing-function": o.easing,
                    "transition-duration": k + "ms",
                    transform: "rotateY(180deg)"
                }))
            }, w + b + y * r + 100);
            r++
        });
        if (w > 0) setTimeout(function() {
            v.css(az_.applyBrowserStyles({
                "transition-duration": w + "ms",
                transform: "scale(1)"
            }))
        }, o.duration - w - b);
        var z = setTimeout(function() {
            l.trigger("transitionFinished")
        }, o.duration);
        n(z)
    };
    O.fn.blocksTransition = function(t, i, e, o, s, n) {
        var a, r, l;
        var h = this;
        var p = h.width(),
            d = h.height();
        var c = p / o.columncount;
        var m = d / o.rowcount;
        var u = o.effects.split(",");
        var g = u[Math.floor(Math.random() * u.length)];
        g = O.trim(g.toLowerCase());
        e.hide();
        for (a = 0; a < o.rowcount; a++)
            for (r = 0; r < o.columncount; r++) {
                var f = O("<div class='amazingslider-img-block-wrapper-" + t + " ' style='display:block;position:absolute;left:" + r * c + "px;top:" + a * m + "px;width:" + c + "px;height:" + m + "px;overflow:hidden;'></div>");
                var v = O("<div class='amazingslider-img-block-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                var b = O("img", e).clone();
                if (Math.abs(o.imgmarginleft) > 0) {
                    b.css({
                        "margin-left": o.columncount * o.imgmarginleft + "%"
                    });
                    b.css({
                        "max-width": o.columncount * o.imgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * o.imgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    b.css({
                        "margin-top": o.columncount * o.imgmargintop + "%"
                    });
                    b.css({
                        "max-width": o.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: o.columncount * 100 + "%"
                    })
                }
                v.append(b);
                f.append(v);
                h.append(f)
            }
        var w = O(".amazingslider-img-block-" + t, h);
        h.off("transitionFinished").on("transitionFinished", function() {
            h.off("transitionFinished");
            i.remove();
            e.show();
            O(".amazingslider-img-block-wrapper-" + t, h).remove();
            s()
        });
        if (g == "bottomright" || g == "bottom") w = O(O.makeArray(w).reverse());
        else if (g == "random") w = O(O.makeArray(w).sort(function() {
            return .5 - Math.random()
        }));
        l = 0;
        w.each(function() {
            var t = O(this);
            var i, e;
            i = Math.floor(l / o.columncount);
            e = l % o.columncount;
            t.hide();
            switch (g) {
                case "topleft":
                case "bottomright":
                    t.delay(o.duration * (i + e) / (o.rowcount + o.columncount)).fadeIn();
                    break;
                case "top":
                case "bottom":
                case "random":
                    t.delay(o.duration * l / (o.rowcount * o.columncount)).fadeIn();
                    break
            }
            l++
        });
        var x = setTimeout(function() {
            h.trigger("transitionFinished")
        }, o.duration);
        n(x)
    };
    O.fn.shuffleTransition = function(t, i, e, n, o, s) {
        var a, r, l;
        var h = this;
        var p = h.width(),
            d = h.height();
        var c = p / n.columncount;
        var m = d / n.rowcount;
        for (a = 0; a < n.rowcount; a++)
            for (r = 0; r < n.columncount; r++) {
                var u = O("<div class='amazingslider-img-block-wrapper-next-" + t + " ' style='display:block;position:absolute;left:" + r * c + "px;top:" + a * m + "px;width:" + c + "px;height:" + m + "px;overflow:hidden;'></div>");
                var g = O("<div class='amazingslider-img-block-next-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                var f = O("img", e).clone();
                if (Math.abs(n.imgmarginleft) > 0) {
                    f.css({
                        "margin-left": n.columncount * n.imgmarginleft + "%"
                    });
                    f.css({
                        "max-width": n.columncount * n.imgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: n.columncount * n.imgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    f.css({
                        "margin-top": n.columncount * n.imgmargintop + "%"
                    });
                    f.css({
                        "max-width": n.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: n.columncount * 100 + "%"
                    })
                }
                g.append(f);
                u.append(g);
                h.append(u);
                var v = O("<div class='amazingslider-img-block-wrapper-prev-" + t + " ' style='display:block;position:absolute;left:" + r * c + "px;top:" + a * m + "px;width:" + c + "px;height:" + m + "px;overflow:hidden;'></div>");
                var b = O("<div class='amazingslider-img-block-prev-" + t + " ' style='display:block;position:absolute;left:0%;top:0%;width:100%;height:100%;overflow:hidden;'></div>");
                var w = O("img", i).clone();
                if (Math.abs(n.imgmarginleft) > 0) {
                    w.css({
                        "margin-left": n.columncount * n.imgmarginleft + "%"
                    });
                    w.css({
                        "max-width": n.columncount * n.imgmaxwidth + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: n.columncount * n.imgmaxwidth + "%",
                        height: "auto"
                    })
                } else {
                    w.css({
                        "margin-top": n.columncount * n.imgmargintop + "%"
                    });
                    w.css({
                        "max-width": n.columncount * 100 + "%",
                        left: "-" + c * r + "px",
                        top: "-" + m * a + "px",
                        width: n.columncount * 100 + "%"
                    })
                }
                b.append(w);
                v.append(b);
                h.append(v)
            }
        e.hide();
        i.hide();
        var x = O(".amazingslider-img-block-wrapper-next-" + t, h);
        var y = O(".amazingslider-img-block-wrapper-prev-" + t, h);
        h.off("transitionFinished").on("transitionFinished", function() {
            h.off("transitionFinished");
            i.remove();
            e.show();
            O(".amazingslider-img-block-wrapper-next-" + t, h).remove();
            O(".amazingslider-img-block-wrapper-prev-" + t, h).remove();
            o()
        });
        var k = h.offset();
        var z = -k.left;
        var A = O(window).width() - k.left - h.width() / n.columncount;
        var E = -k.top * 100 / h.height();
        var I = O(window).height() - k.top - h.height() / n.rowcount;
        l = 0;
        y.each(function() {
            var t = O(this);
            var i = Math.random() * (A - z) + z;
            var e = Math.random() * (I - E) + E;
            t.animate({
                left: i + "px",
                top: e + "px",
                opacity: 0
            }, n.duration, n.easing);
            l++
        });
        l = 0;
        x.each(function() {
            var t = O(this);
            var i = Math.floor(l / n.columncount);
            var e = l % n.columncount;
            var o = Math.random() * (A - z) + z;
            var s = Math.random() * (I - E) + E;
            t.css({
                left: o + "px",
                top: s + "px",
                opacity: 0
            }, n.duration, n.easing);
            t.animate({
                left: e * c + "px",
                top: i * m + "px",
                opacity: 1
            }, n.duration, n.easing);
            l++
        });
        var M = setTimeout(function() {
            h.trigger("transitionFinished")
        }, n.duration);
        s(M)
    }
})(jQuery);
(function(d) {
    d.fn.sliderTouchSwipe = function(t) {
        var p = {
            preventWebBrowser: false,
            swipeLeft: null,
            swipeRight: null,
            swipeTop: null,
            swipeBottom: null
        };
        if (t) d.extend(p, t);
        return this.each(function() {
            var e = -1,
                o = -1;
            var s = -1,
                n = -1;

            function t(t) {
                var i = t.originalEvent;
                if (i.targetTouches.length >= 1) {
                    e = i.targetTouches[0].pageX;
                    o = i.targetTouches[0].pageY
                } else r(t)
            }

            function i(t) {
                if (p.preventWebBrowser) t.preventDefault();
                var i = t.originalEvent;
                if (i.targetTouches.length >= 1) {
                    s = i.targetTouches[0].pageX;
                    n = i.targetTouches[0].pageY
                } else r(t)
            }

            function a(t) {
                if (s > 0 || n > 0) {
                    l();
                    r(t)
                } else r(t)
            }

            function r(t) {
                e = -1;
                o = -1;
                s = -1;
                n = -1
            }

            function l() {
                if (Math.abs(s - e) > Math.abs(n - o))
                    if (s > e) {
                        if (p.swipeRight) p.swipeRight.call()
                    } else {
                        if (p.swipeLeft) p.swipeLeft.call()
                    }
                else if (n > o) {
                    if (p.swipeBottom) p.swipeBottom.call()
                } else if (p.swipeTop) p.swipeTop.call()
            }
            try {
                d(this).on("touchstart", t);
                d(this).on("touchmove", i);
                d(this).on("touchend", a);
                d(this).on("touchcancel", r)
            } catch (h) {}
        })
    }
})(jQuery);
jQuery.easing["jswing"] = jQuery.easing["swing"];
jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    easeInQuad: function(t, i, e, o, s) {
        return o * (i /= s) * i + e
    },
    easeOutQuad: function(t, i, e, o, s) {
        return -o * (i /= s) * (i - 2) + e
    },
    easeInOutQuad: function(t, i, e, o, s) {
        if ((i /= s / 2) < 1) return o / 2 * i * i + e;
        return -o / 2 * (--i * (i - 2) - 1) + e
    },
    easeInCubic: function(t, i, e, o, s) {
        return o * (i /= s) * i * i + e
    },
    easeOutCubic: function(t, i, e, o, s) {
        return o * ((i = i / s - 1) * i * i + 1) + e
    },
    easeInOutCubic: function(t, i, e, o, s) {
        if ((i /= s / 2) < 1) return o / 2 * i * i * i + e;
        return o / 2 * ((i -= 2) * i * i + 2) + e
    },
    easeInQuart: function(t, i, e, o, s) {
        return o * (i /= s) * i * i * i + e
    },
    easeOutQuart: function(t, i, e, o, s) {
        return -o * ((i = i / s - 1) * i * i * i - 1) + e
    },
    easeInOutQuart: function(t, i, e, o, s) {
        if ((i /= s / 2) < 1) return o / 2 * i * i * i * i + e;
        return -o / 2 * ((i -= 2) * i * i * i - 2) + e
    },
    easeInQuint: function(t, i, e, o, s) {
        return o * (i /= s) * i * i * i * i + e
    },
    easeOutQuint: function(t, i, e, o, s) {
        return o * ((i = i / s - 1) * i * i * i * i + 1) + e
    },
    easeInOutQuint: function(t, i, e, o, s) {
        if ((i /= s / 2) < 1) return o / 2 * i * i * i * i * i + e;
        return o / 2 * ((i -= 2) * i * i * i * i + 2) + e
    },
    easeInSine: function(t, i, e, o, s) {
        return -o * Math.cos(i / s * (Math.PI / 2)) + o + e
    },
    easeOutSine: function(t, i, e, o, s) {
        return o * Math.sin(i / s * (Math.PI / 2)) + e
    },
    easeInOutSine: function(t, i, e, o, s) {
        return -o / 2 * (Math.cos(Math.PI * i / s) - 1) + e
    },
    easeInExpo: function(t, i, e, o, s) {
        return i == 0 ? e : o * Math.pow(2, 10 * (i / s - 1)) + e
    },
    easeOutExpo: function(t, i, e, o, s) {
        return i == s ? e + o : o * (-Math.pow(2, -10 * i / s) + 1) + e
    },
    easeInOutExpo: function(t, i, e, o, s) {
        if (i == 0) return e;
        if (i == s) return e + o;
        if ((i /= s / 2) < 1) return o / 2 * Math.pow(2, 10 * (i - 1)) + e;
        return o / 2 * (-Math.pow(2, -10 * --i) + 2) + e
    },
    easeInCirc: function(t, i, e, o, s) {
        return -o * (Math.sqrt(1 - (i /= s) * i) - 1) + e
    },
    easeOutCirc: function(t, i, e, o, s) {
        return o * Math.sqrt(1 - (i = i / s - 1) * i) + e
    },
    easeInOutCirc: function(t, i, e, o, s) {
        if ((i /= s / 2) < 1) return -o / 2 * (Math.sqrt(1 - i * i) - 1) + e;
        return o / 2 * (Math.sqrt(1 - (i -= 2) * i) + 1) + e
    },
    easeInElastic: function(t, i, e, o, s) {
        var n = 1.70158;
        var a = 0;
        var r = o;
        if (i == 0) return e;
        if ((i /= s) == 1) return e + o;
        if (!a) a = s * .3;
        if (r < Math.abs(o)) {
            r = o;
            var n = a / 4
        } else var n = a / (2 * Math.PI) * Math.asin(o / r);
        return -(r * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * s - n) * 2 * Math.PI / a)) + e
    },
    easeOutElastic: function(t, i, e, o, s) {
        var n = 1.70158;
        var a = 0;
        var r = o;
        if (i == 0) return e;
        if ((i /= s) == 1) return e + o;
        if (!a) a = s * .3;
        if (r < Math.abs(o)) {
            r = o;
            var n = a / 4
        } else var n = a / (2 * Math.PI) * Math.asin(o / r);
        return r * Math.pow(2, -10 * i) * Math.sin((i * s - n) * 2 * Math.PI / a) + o + e
    },
    easeInOutElastic: function(t, i, e, o, s) {
        var n = 1.70158;
        var a = 0;
        var r = o;
        if (i == 0) return e;
        if ((i /= s / 2) == 2) return e + o;
        if (!a) a = s * .3 * 1.5;
        if (r < Math.abs(o)) {
            r = o;
            var n = a / 4
        } else var n = a / (2 * Math.PI) * Math.asin(o / r);
        if (i < 1) return -.5 * r * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * s - n) * 2 * Math.PI / a) + e;
        return r * Math.pow(2, -10 * (i -= 1)) * Math.sin((i * s - n) * 2 * Math.PI / a) * .5 + o + e
    },
    easeInBack: function(t, i, e, o, s, n) {
        if (n == undefined) n = 1.70158;
        return o * (i /= s) * i * ((n + 1) * i - n) + e
    },
    easeOutBack: function(t, i, e, o, s, n) {
        if (n == undefined) n = 1.70158;
        return o * ((i = i / s - 1) * i * ((n + 1) * i + n) + 1) + e
    },
    easeInOutBack: function(t, i, e, o, s, n) {
        if (n == undefined) n = 1.70158;
        if ((i /= s / 2) < 1) return o / 2 * i * i * (((n *= 1.525) + 1) * i - n) + e;
        return o / 2 * ((i -= 2) * i * (((n *= 1.525) + 1) * i + n) + 2) + e
    },
    easeInBounce: function(t, i, e, o, s) {
        return o - jQuery.easing.easeOutBounce(t, s - i, 0, o, s) + e
    },
    easeOutBounce: function(t, i, e, o, s) {
        if ((i /= s) < 1 / 2.75) return o * 7.5625 * i * i + e;
        else if (i < 2 / 2.75) return o * (7.5625 * (i -= 1.5 / 2.75) * i + .75) + e;
        else if (i < 2.5 / 2.75) return o * (7.5625 * (i -= 2.25 / 2.75) * i + .9375) + e;
        else return o * (7.5625 * (i -= 2.625 / 2.75) * i + .984375) + e
    },
    easeInOutBounce: function(t, i, e, o, s) {
        if (i < s / 2) return jQuery.easing.easeInBounce(t, i * 2, 0, o, s) * .5 + e;
        return jQuery.easing.easeOutBounce(t, i * 2 - s, 0, o, s) * .5 + o * .5 + e
    }
});
if (typeof N === "undefined") var N = new function() {
    this.objects = [];
    this.addObject = function(t) {
        this.objects.push(t)
    };
    this.loadNext = function(t) {
        for (var i = 0; i < this.objects.length; i++)
            if (this.objects[i].id == t) {
                this.objects[i].videoPaused = false;
                if (!this.objects[i].isPaused) this.objects[i].slideRun(-1)
            }
    }
};
if (typeof D === "undefined") {
    var D = false;
    var j = 0;

    function t() {
        D = true
    }
}
if (typeof R === "undefined") var R = 0;